export const en = {
    fileImport: {
        newAttempt: "New attempt",
        "title": "Import from file",
        "choose": "Choose a file",
        "mapping": "Match the columns",
        "options": "Choose import options",
        "progress": "Import in progress",
        "completed": "Import completed",
        "file": "CSV file",
        "csvHint": "Save your Excel file as CSV. Up to 5,000 rows and 20 MB; the file is read here, in your browser.",
        "resumeHint": "If you close or lose the connection, select the same file and options to resume. The browser remembers only the attempt, without storing the file.",
        "mappingHint": "{count} rows. Check the examples and match columns to fields. Phones must keep their leading zeros.",
        "columnField": "Field for {column}",
        "unnamed": "Column {number}",
        "empty": "No example",
        "ignore": "Do not import this column",
        "cityCode": "Municipality ISTAT code",
        "fieldUnavailable": "Field unavailable",
        "mappingInvalid": "Match a mobile or landline phone; each field can use only one column.",
        "source": "Source",
        "sourceRequired": "Enter the source of these Leads.",
        "tag": "Tag to add to everyone",
        "tagHint": "Optional; also added to existing Leads. Separate tags within a column with commas.",
        "existing": "Duplicates by phone",
        "keep": "Leave them as they are",
        "fill": "Fill empty fields only",
        "owner": "Assign new Leads",
        "rule": "Use the assignment rule",
        "ownerHint": "This applies only to new Leads: existing Leads keep their owner, even when they have none.",
        "ownerUnavailable": "People are unavailable now. You can use the assignment rule.",
        "entryHint": "Each valid row records an entry, including an existing Lead; the same row again within 24 hours is a double submission and does not count. New Leads start their sequence. Imported data cannot be undone.",
        "next": "Continue",
        "back": "Back",
        "import": "Import",
        "retry": "Retry",
        "reading": "Reading the file and fields…",
        "processed": "{done} of {total} rows processed",
        "interruptedHint": "You can close and resume with the same file and choices. Rows already imported remain; retrying does not duplicate them.",
        "counts": "{created} new · {updated} already present · {discarded} discarded",
        "rowNumbers": "Rows refer to the parsed table: header 1, then non-empty rows. A cell with multiple text lines counts once.",
        "duplicates": "Double submissions: {count}. These rows have the same data as an import in the last 24 hours: they were not imported again and their Leads did not change.",
        "badRow": "Row {row}: not imported; check data or permissions.",
        "problemField": "Field: {field}.",
        "problems": {
            "phone_missing": "Row {row}: no phone, not imported.",
            "invalid_phone": "Row {row}: invalid phone, not imported.",
            "invalid_field_value": "Row {row}: a value is not valid, not imported.",
            "archived_lead": "Row {row}: the phone belongs to an archived Lead, not imported. Restore the Lead from Archived, then import the row again.",
            "phones_conflict": "Row {row}: the landline already belongs to a Lead with another mobile, not imported. Check whether it is the same person.",
            "owner_not_eligible": "Row {row}: the chosen person can no longer receive Leads, not imported. Retry with another person or with the assignment rule.",
            "phone_in_use": "Row {row}: a number in the row already belongs to another Lead, not imported.",
            "field_not_editable": "Row {row}: a field or option is hidden on the card and cannot be written, not imported.",
            "phone_repeated_on_lead": "Row {row}: the same number is in two columns, not imported."
        },
        "unknownCity": "Row {row}: unknown city, Lead imported without a city.",
        "valueNotImported": "Row {row}: the value of «{field}» was not imported because it is not valid; the rest of the row was.",
        "possibleEmail": "Row {row}: email also used by another Lead; check the possible duplicate.",
        "busy": "Someone else is importing a file. Retry when they have finished.",
        "changedAttempt": "This attempt changed or was closed by a new import. Imported rows remain. Close and start a new attempt with updated choices or file.",
        "errors": {
            "empty_file": "The file has no rows to import.",
            "invalid_csv": "The CSV cannot be read unambiguously. Check separators, quotes and headers, then export it again.",
            "too_many_rows": "The file exceeds 5,000 rows. Split it into smaller files.",
            "unreadable_file": "The file could not be read. Select it again.",
            "unsupported_file": "Save your Excel file as CSV, then select the CSV.",
            "file_too_large": "The file exceeds 20 MB. Split it into smaller files.",
            "row_too_large": "A row exceeds the allowed size. Shorten cells or remove unused columns before importing."
        }
    },
    registration: {
        title: "Try Gioia365 free for 15 days",
        offer: "15 days free, then EUR 49 per month per user. No card required to start.",
        start: "Start your free trial",
        unavailable: "Registration is currently unavailable. Please try again later.",
        emailPending: "Open the email we sent and confirm your address to start your trial.",
        activationPending: "We are preparing your company. Please try again shortly.",
        activated: "Your company is ready. Open the link in your email to sign in.",
        confirmTitle: "Confirm your email address",
        confirm: "Confirm email and start your trial",
        enter: "Choose your password and sign in",
        ends: "Your free trial ends on {date}.",
        expired: "Your free trial has ended. Activate your subscription to resume work.",
        capacity: "Save trial seats",
        team: "Manage your team",
        retryRegistration: "Request a new confirmation email",
    },
    billing: {
        purchaseTitle: "Activate Gioia365",
        price: "49 EUR per month per user",
        telephony: "Telephony is not included in this purchase.",
        companyName: "Company name",
        firstName: "Owner first name",
        lastName: "Owner last name",
        email: "Owner email",
        seats: "Team seats",
        total: "{amount} EUR per month",
        tax: "Review the amount and details before confirming payment.",
        checkout: "Continue to payment",
        signIn: "Sign in to Gioia365",
        unavailable: "Purchases are currently unavailable. Please try again later.",
        statusTitle: "Your purchase",
        newPurchase: "Back to purchases",
        manageTitle: "Subscription",
        paid: "Your subscription is active.",
        unpaid: "Your payment needs attention. Manage your subscription to resume work.",
        used: "Seats used: {used} of {seats}.",
        overQuota: "Your team uses more seats than purchased. CRM access is paused: increase seats, or suspend people or cancel invitations from Team.",
        recovery: "You can manage payments and reduce occupied seats from Team. CRM access resumes when the subscription is paid and seats cover active people and valid invitations. Nobody is suspended automatically.",
        suspendNamed: "Suspend {name}",
        cancelNamed: "Cancel invitation to {name}",
        leaveView: "Opening Team leaves the Commercial View so you can act as the owner.",
        restart: "The previous contract has ended. You can activate a new subscription for the same company and its team.",
        restartCheckout: "Activate a new subscription",
        confirmSuspend: "Confirm suspension",
        confirmCancel: "Confirm cancellation",
        cancelText: "The invitation to {name} will no longer be valid. You can invite them again when seats are available.",
        ends: "The subscription ends at the end of the paid period.",
        portal: "Manage payment and invoices",
        manual: "This company is managed directly by Gioia365. It has no automatic charges.",
        chooseCompany: "Choose a company",
        order: { payment_pending: "We are verifying your payment.", activation_pending: "We are activating your company. You will receive the invitation by email.", activated: "Your company is active. We emailed your invitation.", expired: "Payment was not completed. You can start a new purchase." },
    },
    common: {
        appName: "Gioia365",
        greeting: "Hello, {name}",
        language: "Language",
        italian: "Italian",
        english: "English",
        loading: "One moment…",
        retry: "Try again",
        close: "Close",
        discardChanges: "Discard changes",
        saving: "Saving…",
        notifications: "Notifications",
        signOut: "Sign out",
        signingOut: "Signing out…",
        cancel: "Cancel",
        firstName: "First name",
        lastName: "Last name",
        nameMissing: "Please enter first and last name.",
    },
    auth: {
        errors: {
            rateLimited: "Too many attempts in a row. Wait a minute and try again.",
            unavailable: "The sign-in service is not responding. Try again shortly; if it keeps happening, tell whoever runs Gioia365.",
            unexpected: "Something went wrong. Try again shortly.",
        },
        login: {
            title: "Sign in to Gioia365",
            email: "Email",
            password: "Password",
            submit: "Sign in",
            submitting: "Signing in…",
            invalidCredentials: "Wrong email or password.",
        },
        resetPassword: {
            title: "Choose your password",
            intro: "You will use it with your email to sign in to Gioia365.",
            newPassword: "New password (at least {min} characters)",
            confirmPassword: "Repeat the new password",
            submit: "Save password",
            submitting: "Saving…",
            tooShort: "The password must have at least {min} characters.",
            tooLong: "The password can have at most {max} characters.",
            mismatch: "The two passwords do not match.",
            invalidLink: "This link no longer works: it lasts one hour and can be used only once. Ask for a new link.",
            done: "Password saved. You can now sign in with your email and the new password.",
            goToLogin: "Go to sign in",
        },
        forgot: {
            link: "Forgot your password?",
            title: "Forgot your password?",
            intro: "Type the email you sign in with: we will send you a link to choose a new password.",
            email: "Email",
            submit: "Send me the link",
            submitting: "Sending…",
            sent: "If the email belongs to a Gioia365 account, the link will arrive shortly. It is valid for one hour.",
            noEmail: "This server does not send emails yet: ask the Gioia365 Super admin for a new link.",
            back: "Back to sign in",
        },
        google: {
            or: "or",
            button: "Sign in with Google",
            opening: "Opening Google…",
            completing: "Signing in with Google…",
            unknown: "This Google account does not belong to anyone in Gioia365. To get in, ask whoever manages your company's team for an invitation; if you already have one, open it from the email and choose your password.",
            cancelled: "Google sign-in cancelled. You can try again or sign in with email and password.",
            notLinked: "You cannot sign in with this Google account: it does not match a Gioia365 person with a confirmed email. Sign in with email and password.",
            unverified: "Google does not confirm this account's email, so it cannot be used to sign in. Sign in with email and password.",
            workspace: "Only your company's work Google accounts (Google Workspace) can sign in with Google, not personal ones. Sign in with email and password.",
            failed: "Google did not complete the sign-in. Try again, or sign in with email and password.",
        },
    },
    email: {
        registration: { subject: "Confirm your email to try Gioia365", body: "Confirm your email and start your free 15-day trial: {link}" },
        invitation: {
            subject: "Gioia365: your invitation to {organization}",
            body: "Hi {name},\n\nYou have been invited to work in {organization} on Gioia365. Open this link to choose your password and sign in:\n\n{link}\n\nThe link is valid until {date}. After that, to sign in to {organization}, always use this address with your email and password:\n\n{address}\n\nIf you were not expecting this invitation, ignore this email.",
        },
        passwordReset: {
            subject: "Gioia365: choose a new password",
            body: "You asked to choose a new password for Gioia365. Open this link within an hour:\n\n{link}\n\nIf you did not ask for it, ignore this email: your password stays the same.",
        },
        infoRequest: {
            subject: "Gioia365: information request from {company}",
            body: "New information request from the website {site}.\n\nName: {name}\nCompany: {company}\nEmail: {email}\nPhone: {phone}\nPeople in the sales team: {teamSize}\nPage language: {locale}\nReceived: {date}\n\nMessage:\n{message}\n\nReply to this email to answer {email}.",
            notGiven: "not given",
        },
        duplicateDigest: {
            subject: "Gioia365: new possible duplicates in {organization} ({count})",
            intro: "there are new possible duplicates in {organization} since the last summary: {count}.",
            introFirst: "this is the first summary of possible duplicates in {organization}: it includes all those still to check, {count}.",
            samePhone: "- {first} and {second}: same mobile",
            sameEmail: "- {first} and {second}: same email",
            more: "More pairs: {count}.",
            body: "Hi {name},\n\n{intro}\n\n{pairs}\n\nYou will find them in «Data cleanup», where you merge them into one Lead or mark them «Not duplicates»:\n\n{link}\n\nYou receive this email every working morning with new possible duplicates, because you clean up the data of {organization}.",
        },
    },
    invitation: {
        title: "Join {organization}",
        titleGeneric: "Your invitation",
        summary: "The invitation is for {email} with the role “{role}”. It expires on {date}.",
        incompleteLink: "This link is not complete: open the link you received again.",
        expiredOn: "The invitation expired on {date}: ask whoever invited you to send it again.",
        alreadyMember: "You are already part of {organization}.",
        organizationInactive: "{organization} is not active on Gioia365 at the moment.",
        goToLogin: "Go to sign in",
        newPassword: "Choose a password (at least {min} characters)",
        confirmPassword: "Repeat the password",
        existingIntro: "You already have a Gioia365 account with this email: write your password.",
        passwordMissing: "Write your password.",
        wrongPassword: "The password is not correct.",
        forgotPassword: "Forgot your password?",
        signedInAs: "You are already signed in as {email}.",
        submit: "Join {organization}",
        submitting: "Joining…",
    },
    home: {
        comingNext: "Leads, tasks and the day's numbers will appear here.",
        inCompany: "You are in {organization} as {role}.",
        inCompanyAsPlatform: "You are in {organization} as Gioia365 Super admin.",
        goToSettings: "Go to Settings",
    },
    // The Home «Today» and «Sequences followed today» (M5 plan, Task 22): a plain translation of the Italian words.
    homeToday: {
        title: "Today",
        newLeads: "New Leads to contact",
        newLeadsHint: "entered the Smart Lists and never called",
        newLeadsOne: "1 new Lead to contact",
        newLeadsMany: "{count} new Leads to contact",
        callNewLeads: "Call the new Leads",
        attempts: "Call attempts today",
        attemptsDetail: "{answered} answered · {leads} different Leads",
        closedEarly: "{count} ended early · excluded from attempts",
        disco: "Booked discos",
        discoValue: "{count} today",
        discoNext: "Next on the agenda: {lead}, today at {time}.",
        discoNone: "No disco left to do today.",
        openNextDisco: "Open the next disco",
        appointments: "Discos and demos today",
        appointmentsNone: "No discos or demos today.",
        appointmentItem: "{time} · {kind} with {lead}",
        appointmentState: {
            to_do: "To do",
            in_progress: "In progress",
            to_close: "To close: record how it went from the card",
            held: "Done",
            no_show: "The Lead did not show up",
        },
    },
    homeSequences: {
        mine: "Your sequences followed today: {respected} of {total}",
        team: "Sequences followed today: {respected} of {total}",
        none: "none today",
        mineNone: "Your sequences followed today: {none}",
        teamNone: "Sequences followed today: {none}",
        person: "{name}: {respected} of {total}",
        personNone: "{name}: {none}",
        violatedOne: "Not followed:",
        violatedMany: "Not followed:",
        moreOne: "and one more",
        more: "and {count} more",
        hint: "Followed: first call within {minutes} minutes from when the Lead comes in, one attempt in every working half-day{friday}, {first} calls in the first attempt and at least {others} in the others (Settings → Call sequence). Next to the name is the first reason. Sequence calls are not tasks: the Salesperson makes them from the Smart Lists, and here you see whether they did.",
        hintOneAttempt: "Followed: first call within {minutes} minutes from when the Lead comes in, one attempt in every working half-day{friday}, {first} calls in the first attempt (Settings → Call sequence). Next to the name is the first reason. Sequence calls are not tasks: the Salesperson makes them from the Smart Lists, and here you see whether they did.",
        fridayHint: " (on Friday only the morning)",
    },
    shell: {
        skipToContent: "Skip to content",
        menu: "Menu",
        mainNavigation: "Main navigation",
        company: {
            label: "Company of this tab:",
            button: "Company of this tab: {organization}",
            none: "Choose the company",
            title: "Your companies",
            currentRole: "{role} · open in this tab",
            platformRole: "Gioia365 Super admin",
            all: "All Gioia365 companies",
        },
        nav: {
            home: "Home",
            tasks: "Tasks",
            leads: "Leads",
            opportunities: "Opportunities",
            conversations: "Conversations",
            activity: "Activity",
            reports: "Reports",
            smartLists: "Smart Lists",
            settings: "Settings",
            platform: "Gioia365 companies",
        },
        rail: {
            collapse: "Collapse menu",
            expand: "Expand menu",
        },
        account: {
            role: "{role} · {organization}",
            platformIn: "Gioia365 Super admin · {organization}",
            platform: "Gioia365 Super admin",
        },
        platformNotice: "You are in {organization} as Gioia365 Super admin. Every access is recorded.",
        commercialView: {
            open: "See as…",
            title: "See as another person in the company",
            intro: "Choose an active person in the company: you see the program as they see it, with their menu and their Leads. It is only a view: what you do stays in your name.",
            list: "People you can see as",
            otherRoles: "Other roles",
            current: "in view",
            none: "There is no other active person you can see as.",
            exit: "Leave the view",
            region: "See as…",
            band: "You are seeing what {name} ({role}) sees.",
            bandName: "You are seeing what {name} sees.",
            bandNote: "What you do stays in your name.",
            change: "Change",
            leave: "Leave",
            closed: "The view as {name} has closed: Gioia365 no longer allows it, for example because the person was suspended or their role now has more powers than yours. You now see as usual.",
            outsideTitle: "Page outside the view",
            outside: "This page is not part of what {name} sees. Leave the view to open it.",
        },
    },
    settings: {
        eyebrow: "Settings · {organization}",
        sections: "Settings sections",
        // Titles of the menu groups (order approved on 17 October 2026, IMP-13).
        groups: {
            company: "Company",
            people: "People",
            leads: "Leads",
            calls: "Calls",
            whatsapp: "WhatsApp",
            data: "Data",
        },
        team: "Team",
        roles: "Roles and permissions",
        calendar: "Calendar, time zone and language",
        leadFields: "Card fields",
        leadVisibility: "Who sees the Leads",
        callSequence: "Call sequence",
        leadIntake: "Lead intake",
        assignment: "Lead assignment",
        goals: "Goals",
        whatsappSending: "Sending WhatsApps",
        whatsappTemplates: "WhatsApp templates",
        importExport: "Import and export",
        draft: {
            summary: "{count} changes to save. Nothing changes for the team until you save.",
            summaryOne: "1 change to save. Nothing changes for the team until you save.",
            save: "Save…",
            discarded: "Changes discarded: everything stays as it was.",
            confirmTitle: "What changes for the team",
            confirmNote: "It applies to the whole company right away. The change stays in the Activity log with your name and the time.",
            back: "Back to the changes",
            apply: "Save and apply to the whole company",
            leaveTitle: "You have not saved your changes",
            leaveText: "If you leave now the changes are lost and everything stays as it was for the team.",
            leaveDiscard: "Leave without saving",
            stay: "Stay here",
        },
    },
    team: {
        about: {
            title: "What it is for",
            text: "Here is who is part of {organization}: full name, role, whether they are active and the number they call from, which can be the same for several people.",
            whoDecidesTitle: "Who decides",
            whoDecides: "The company's Super admin, Admin and Super user, and the Gioia365 Super admin. Nobody changes someone whose role is higher than their own; the owner is protected. The numbers to call from are added, verified, given and removed by the company's Super admin and Admin (whoever has «Numbers to call from») and by the Gioia365 Super admin.",
        },
        readOnly: "The team is managed by the company's Super users, Admins and Super admin: you can only view it.",
        title: "Who is in {organization}",
        counts: "People: {total} · active {active} · invited {invited} · suspended {suspended}",
        invite: "Invite someone",
        caption: "The {organization} team",
        columns: {
            person: "Person",
            role: "Role",
            status: "Status",
            action: "Action",
        },
        owner: "owner",
        you: "you",
        // A person born suspended from the Close import (INGR-15).
        fromClose: "from Close",
        protected: "protected",
        manage: "Manage",
        manageNamed: "Manage {name}",
        status: {
            active: "Active",
            invited: "Invited",
            suspended: "Suspended",
            archived: "Archived",
            suspending: "Suspension in progress",
            archiving: "Archiving in progress",
            invitedOn: "invited on {date}",
            expiredOn: "expired on {date}",
        },
        showArchived: "Also show archived people ({count})",
        leadsLeft: "{count} Leads to reassign",
        leadsLeftOne: "1 Lead to reassign",
        leadsLeftUnknown: "Leads to reassign: count not available",
        countsFailed: "I cannot count people's Leads, so next to suspended or archived people I cannot say how many Leads are left to reassign. Try again.",
        inView: "You are seeing what {name} sees: the Leads to reassign here are only those this person sees, and to reassign them leave the view.",
        leads: {
            legend: "Their {count} Leads",
            legendOne: "Their Lead",
            reassign: "Reassign them to the other Users, in turn",
            reassignHint: "One each to the active Users, in name order, from the oldest Lead. Each Lead's Timeline keeps who reassigned it.",
            keep: "Keep them as they are for now",
            keepHint: "They stay flagged for reassignment: their row on this page says how many.",
            cannotReassign: "They stay with them, flagged for reassignment: whoever can change the owner of every Lead reassigns them.",
            cannotReassignInView: "They stay with them, flagged for reassignment: they are not reassigned while you see as another person. Leave the view to reassign them.",
            countsFailedSuspend: "I cannot count their Leads, so I cannot offer to reassign them here. Try again; if you suspend anyway, the Leads they have stay with them, flagged for reassignment.",
            countsFailedArchive: "I cannot count their Leads. Try again; if they still have some, archiving stops and says how many.",
            countsFailedPending: "I cannot count their Leads, so I cannot offer to reassign them here. Try again.",
            pending: "They are still theirs and are waiting to be reassigned.",
            counting: "Counting their Leads…",
        },
        hideArchived: "Hide archived people",
        fields: {
            email: "Email to sign in to Gioia365",
            emailHint: "The invitation arrives here: the person chooses their password and signs in.",
            // The invitation of a person born suspended from Close (INGR-15).
            emailFromClose: "The email they had in Close: accepting the invitation they find their Leads. If they do not use Gioia365 yet they choose their password there; if they already do, they sign in with the one they have.",
            emailInvalid: "Write a valid email: it is the one they sign in with.",
            emailLocked: "The email is changed by the person themselves or by the Gioia365 Super admin, because it is the one they sign in with.",
            role: "Role",
            roleHint: "What each role can do is chosen in {link}.",
            roleReadOnly: "This role can do things you cannot do: you cannot change it from here.",
            roleSuperAdminLevel: "A role at the Super admin level cannot be changed from here: there is only one Super admin.",
            noRoles: "There is no role you can give: every role in the company has a level equal to or higher than yours, or can do things you cannot do.",
        },
        inviteDialog: {
            submit: "Send the invitation",
            sent: "Invitation sent to {email}. {name} joins when they accept it.",
            readyTitle: "Invitation ready for {name}",
            readyIntro: "The email did not go out: copy the link and send it to {name} yourself, for example on WhatsApp. It is valid for 7 days.",
        },
        manageDialog: {
            save: "Save",
            saved: "Saved: {name}.",
            suspend: "Suspend",
            resume: "Reactivate",
            // For a person born suspended from Close (INGR-15), instead of «Reactivate».
            invite: "Invite",
            archive: "Archive",
        },
        invitationDialog: {
            resend: "Send the invitation again",
            resent: "Invitation sent again to {email}.",
            resendBlocked: "You cannot send it again: the role of this invitation can do things you cannot do. You can cancel it.",
            cancel: "Cancel the invitation",
            cancelled: "Invitation to {email} cancelled.",
        },
        confirm: {
            suspendTitle: "Suspend {name}",
            suspendText: "{name} can no longer sign in to Gioia365 and gets no new Leads. All the work done stays under their name.",
            archiveTitle: "Archive {name}",
            archiveText: "{name} leaves {organization}. Their name stays in the history. Nothing is deleted.",
            archiveLeads: "They still have {count} Leads: a Lead cannot stay with an archived person. First they are reassigned to the other Users, in turn, then {name} leaves {organization}.",
            archiveLeadsOne: "They still have 1 Lead: a Lead cannot stay with an archived person. First it is reassigned to another User, then {name} leaves {organization}.",
            archiveReassign: "Reassign and archive",
            archiveBlocked: "They still have {count} Leads: first they must be reassigned to the other Users, and only whoever changes the owner of every Lead can do it.",
            archiveBlockedOne: "They still have 1 Lead: first it must be reassigned to another User, and only whoever changes the owner of every Lead can do it.",
            archiveBlockedInView: "They still have {count} Leads: first they must be reassigned to the other Users. Leave the view to reassign them.",
            archiveBlockedInViewOne: "They still have 1 Lead: first it must be reassigned to another User. Leave the view to reassign it.",
        },
        done: {
            suspended: "Access suspended for {name}.",
            resumed: "Access reactivated for {name}.",
            archived: "{name} is no longer part of {organization}: their name stays in the history.",
            suspendedReassigned: "Access suspended for {name}. {count} Leads reassigned to the other Users, in turn.",
            suspendedReassignedOne: "Access suspended for {name}. 1 Lead reassigned to another User.",
            suspendedKept: "Access suspended for {name}. Their {count} Leads stay with them, flagged for reassignment.",
            suspendedKeptOne: "Access suspended for {name}. Their Lead stays with them, flagged for reassignment.",
            suspendedNotReassigned: "Access suspended for {name}, but their Leads stay with them. {reason}",
            reassigned: "{count} Leads of {name} reassigned to the other Users, in turn.",
            reassignedOne: "1 Lead of {name} reassigned to another User.",
            archivedReassigned: "{name} is no longer part of {organization}: their name stays in the history. {count} Leads reassigned to the other Users, in turn.",
            archivedReassignedOne: "{name} is no longer part of {organization}: their name stays in the history. 1 Lead reassigned to another User.",
            reassignedNotArchived: "The Leads of {name} went to the other Users, but archiving did not work. {reason}",
        },
        errors: {
            already_member: "{email} is already part of {organization}.",
            invitation_pending: "There is already a pending invitation for {email}: open it and use «Send the invitation again».",
            role_level: "You cannot give this role or act on this person: their level is equal to or higher than yours.",
            protected_owner: "The owner is protected: nobody changes them from here.",
            cannot_act_on_self: "For yourself use «Your account».",
            invalid_state: "Someone has just changed it: the table is up to date.",
            system_role: "The Super admin role, or a role at its level, is given to nobody: every company has only one Super admin, the owner.",
            permission_denied: "You are not allowed: this role can do things you cannot do, or you no longer manage the team.",
            owner_not_eligible: "There is no other active User to give them to: resume or invite a Salesperson, then try again.",
            membership_has_leads: "They still have {leads} Leads: first they must be reassigned to the other Users.",
            membership_from_close: "This person comes from Close: to bring them back to the team, send an invitation with «Invite». When they accept it they find their Leads.",
        },
    },
    roles: {
        about: {
            title: "What it is for",
            text: "Here you decide what each person in {organization} can do. A role is a set of permissions: for each part of the program you choose what they can view, create, edit and delete, and which special functions and Settings they can use. Everyone gets a role; if someone needs something different, you make a custom role just for them.",
            whoDecidesTitle: "Who decides",
            whoDecides: "The company's Super admin and Admin create the roles and give them to people, but nobody gives permissions they do not have and nobody changes someone whose role is equal to or higher than their own. The Gioia365 Super admin decides which permissions companies can give. Every change is recorded with its author and time.",
        },
        tabs: {
            label: "What do you want to see",
            users: "Users",
            roles: "Roles",
            platform: "For all companies",
        },
        readOnly: "Roles and permissions are changed by the company's Super admin and Admin: you can only view them.",
        needsTeam: "To give someone a role you also need the permission to manage the team, and you do not have it: here you can only view the roles.",
        users: {
            title: "Each person's role",
            help: "Everyone gets a role: a change takes effect at once. «Custom role» copies that person's role into a new one, to change as needed.",
            caption: "People and roles in {organization}",
            columns: {
                person: "User",
                role: "Role",
                does: "What they do",
                action: "Action",
            },
            roleOf: "Role of {name}",
            custom: "Custom role",
            customFor: "Custom role for {name}",
            changed: "{name} now has the role «{role}».",
            unsaved: "Not saved yet: press Enter to save or Esc to cancel.",
            systemRole: "The Super admin role cannot be changed from here: every company has only one Super admin.",
        },
        words: {
            title: "Who can do what, in words",
            intro: "The rules of {organization} for each role, from the highest level. They are written from the saved permissions, so they change when the permissions change. Above everyone is the Gioia365 Super admin, who manages the platform for all companies.",
            level: "level {level}",
            area: "{area}: {actions}.",
            noAccess: "{area}: no access.",
            view: { none: "does not see", own: "sees only their own", all: "sees all" },
            create: { none: "does not create", all: "creates" },
            update: { none: "does not edit", own: "edits only their own", all: "edits all" },
            delete: { none: "does not delete", own: "deletes only their own", all: "deletes all" },
            can: "Can: {list}.",
            settings: "Settings they can change: {list}.",
            allSettings: "all",
        },
        list: {
            label: "Roles",
            system: "system",
            holders: "{count} people",
            holdersOne: "1 person",
            unsaved: "not saved yet",
            add: "New role",
        },
        editor: {
            name: "Role name",
            nameMissing: "Give the role a name.",
            nameTaken: "There is already a role with this name.",
            description: "Description",
            descriptionHint: "One sentence on what it is for: it shows in «What they do» on the Users tab.",
            level: "Level: {level}",
            levelHelp: "The level comes from the starting role and does not change.",
            levels: { user: "User", superUser: "Super user", admin: "Admin", superAdmin: "Super admin" },
            holders: "{count} people have it.",
            holdersOne: "1 person has it.",
            holdersNone: "Nobody has it yet.",
            unsaved: "It does not exist until you save it.",
            forPerson: "When you save it, it becomes {name}'s role.",
            forPersonNoTeam: "When you save it, the role is created; whoever manages the team gives it to {name}.",
            duplicate: "Duplicate",
            delete: "Delete",
            newName: "New role",
            newDescription: "Starts from the permissions of «{role}».",
            copyName: "{name} (copy)",
            copyDescription: "Copy of «{role}».",
            customName: "{name}'s role",
            customDescription: "Copy of «{role}», tailored for {name}.",
            systemLock: "The Super admin can do everything and their role does not change: there is only one Super admin, the owner.",
            superAdminLevel: "A role at the Super admin level cannot be copied or given to anyone: there is only one Super admin.",
            levelReadOnly: "You can only change roles at a lower level than yours: you can only view this one.",
            powersReadOnly: "This role can do things you cannot do: you can only view it.",
            matrixCaption: "What they can do with the data",
            matrixArea: "Part of the program",
            cell: "{area}: {action}",
            notNeeded: "not needed",
            matrixNote: "«Only their own» means the data they own or created; «All» means the data of the whole company. «Delete» means archive: the Lead leaves lists and Smart Lists and can be restored.",
            notYoursOption: "{scope} · you cannot give a permission you do not have",
            notYours: "· you cannot give a permission you do not have",
            unavailable: "· not available: Gioia365 decides",
            settingsNote: "Sections that do not exist yet apply from the day they arrive.",
            invalidCell: "This choice is not valid: pick another one.",
            invalidText: "This text contains characters that cannot be used: type it again.",
        },
        diff: {
            new: "New role «{name}».",
            newFor: "New role «{name}», to give to {person}.",
            name: "Name: «{before}» becomes «{after}».",
            description: "Description changed.",
            scope: "{area}, {action}: from «{before}» to «{after}».",
            can: "Can: {feature}.",
            cannot: "Can no longer: {feature}.",
            canSetting: "Can change «{section}» in Settings.",
            cannotSetting: "Can no longer change «{section}» in Settings.",
        },
        saveBar: {
            summary: "{count} unsaved changes to the role «{name}»: {changes}",
            summaryOne: "1 unsaved change to the role «{name}»: {changes}",
            more: "{changes} …",
            save: "Save the role",
            discarded: "Changes discarded: the role stays as it was.",
            saved: "Role «{name}» saved ({count} changes): it applies at once to everyone who has it.",
            savedOne: "Role «{name}» saved (1 change): it applies at once to everyone who has it.",
            notCompleted: "The role «{name}» was created but its permissions were not saved: try again with «Save the role».",
            notGiven: "The role «{name}» was created but not given to {person}: give it from the Users tab.",
        },
        leave: {
            title: "You have not saved the role",
            text: "If you leave now, the changes to the role are lost and the permissions stay as they were.",
            discard: "Leave without saving",
            stay: "Stay here",
        },
        remove: {
            title: "Delete the role «{name}»?",
            text: "Nobody has it: it disappears from the list and its name becomes free again.",
            confirm: "Delete the role",
            done: "Role «{name}» deleted: nobody had it.",
        },
        errors: {
            permission_denied: "You cannot give permissions you do not have.",
            role_level: "You can only change roles at a lower level than yours.",
            validation_failed: "Some details are not valid: each one is marked with a message.",
            feature_unavailable: "These features can no longer be given, Gioia365 decides: {list}.",
            inUse: "{who} still have it: change their role first.",
            inUseOne: "{who} still has it: change their role first.",
            people: "{count} people",
            peopleOne: "1 person",
            invitations: "{count} invitations",
            invitationsOne: "1 invitation",
            both: "{people} and {invitations}",
        },
        platform: {
            title: "Permissions companies can give",
            intro: "The Gioia365 Super admin decides here, for all companies. A permission that is switched off cannot be given to any role in the companies: only each company's Super admin keeps it.",
            removeTitle: "Remove «{feature}» from all companies?",
            removeText: "It disappears from every role that is not a system role, in every company, and switching it back on does not put it back in the roles.",
            removeConfirm: "Remove from all companies",
            removed: "Removed «{feature}»: {count} roles updated.",
            removedOne: "Removed «{feature}»: 1 role updated.",
            restored: "«{feature}» is available to companies again: give it to a role when needed.",
        },
    },
    // Settings → Calendar, time zone and language (plan M1b Task 10). No article before the company name. The company
    // language is only a fallback for whoever accepts an invitation (decision 39, 30 September 2026).
    calendar: {
        about: {
            title: "What it is for",
            text: "The time zone, the working days and hours and the closures of {organization}, plus the language for new people. The call sequence, callbacks, Tasks and the periods of Home and Reports start from here.",
            whyTitle: "Why it is in Settings",
            why: "The time zone belongs to the company, not to the person: a salesperson who travels sees the same hours as their colleagues. The company's Admin and Super admin change it; the change applies to everyone right away and is recorded.",
        },
        lastSaved: "Last saved: {when}.",
        readOnly: "You can only view them: the Admin and Super admin of {organization} change them.",
        readOnlyPlatform: "These are the rules of {organization}: its Super admin or its Admin change them, not the Gioia365 Super admin.",
        zone: {
            title: "Time zone",
            label: "Every date and time in Gioia365 is read in this time zone",
            entry: "{name} · {id}",
        },
        zones: {
            rome: "Italy (Rome)",
            zurich: "Switzerland (Zurich)",
            paris: "France (Paris)",
            berlin: "Germany (Berlin)",
            madrid: "Spain (Madrid)",
            london: "United Kingdom (London)",
            lisbon: "Portugal (Lisbon)",
            vienna: "Austria (Vienna)",
        },
        hours: {
            title: "Days and working hours",
            day: "Day",
            works: "Works",
            worksDay: "Works, {day}",
            from: "From",
            to: "To",
            fromDay: "From, {day}",
            toDay: "To, {day}",
        },
        weekdays: {
            name: { "1": "Monday", "2": "Tuesday", "3": "Wednesday", "4": "Thursday", "5": "Friday", "6": "Saturday", "7": "Sunday" },
            on: { "1": "on Monday", "2": "on Tuesday", "3": "on Wednesday", "4": "on Thursday", "5": "on Friday", "6": "on Saturday", "7": "on Sunday" },
            of: { "1": "Monday", "2": "Tuesday", "3": "Wednesday", "4": "Thursday", "5": "Friday", "6": "Saturday", "7": "Sunday" },
        },
        closures: {
            title: "Closures",
            caption: "Closure days",
            day: "Day",
            reason: "Why",
            remove: "Remove",
            removeNamed: "Remove the closure of {date}",
            none: "No closures.",
            noReason: "no reason",
            dayLabel: "Closure day",
            reasonPlaceholder: "For example: summer break",
            add: "Add the closure",
            missing: "Choose the day and write why it is closed.",
            duplicate: "That day is already closed.",
            full: "The calendar keeps at most 1,000 closures: remove some that have already passed.",
            note: "On closed days no sequence calls or callbacks are scheduled: they move to the first open day.",
            addHolidays: "Add the {year} national holidays",
            holidaysHint: "The red days of the Italian calendar: New Year's Day, Epiphany, Easter and Easter Monday, 25 April, 1 May, 2 June, Ferragosto, Saint Francis (4 October), All Saints, Immaculate Conception, Christmas and Saint Stephen. The missing ones go in, from today on, each with its Italian name; a day already closed keeps its reason. The patron saint's day is added by hand.",
            holidaysAdded: "{count} national holidays of {year} added: they apply when you save.",
            holidaysAddedOne: "1 national holiday of {year} added: it applies when you save.",
        },
        language: {
            title: "Company language",
            label: "Language for new people, if their browser does not indicate one",
            hint: "It does not change the language of people who are already in: everyone picks theirs from their own account. It only matters to someone who accepts an invitation with a browser that does not say their language.",
        },
        problems: {
            noOpenDay: "Choose at least one working day.",
            endBeforeStart: "On every day the end time comes after the start time.",
        },
        changes: {
            zone: "The company time zone becomes {after}, no longer {before}: every date and time is read with it.",
            opens: "The team works {day}, from {start} to {end}.",
            closes: "The team no longer works {day}.",
            hours: "The working hours for {day} become {start}–{end}.",
            closureAdded: "New closure: {date}, {reason}.",
            closureAddedNoReason: "New closure: {date}.",
            closureRemoved: "Closure of {date} removed ({reason}).",
            closureRemovedNoReason: "Closure of {date} removed.",
            closureReason: "The reason for the closure of {date} becomes «{reason}».",
            language: "The company language becomes {language}: it only applies to new people whose browser does not indicate a language.",
            languages: { it: "Italian", en: "English" },
        },
        saveBar: {
            summary: "{count} changes to save. Nothing changes for the team until you save.",
            summaryOne: "1 change to save. Nothing changes for the team until you save.",
            save: "Save…",
            discarded: "Changes discarded: everything stays as it was.",
            saved: "Saved: it applies to the whole company.",
        },
        confirm: {
            title: "What changes for the team",
            note: "It applies to the whole company right away. The change is recorded with your name and the time.",
            back: "Back to the changes",
            apply: "Save and apply to the whole company",
        },
        leave: {
            title: "You have not saved your changes",
            text: "If you leave now the changes to calendar, time zone and language are lost and the earlier ones stay.",
            discard: "Leave without saving",
            stay: "Stay here",
        },
        errors: {
            closureReasons: "A closure has a reason that does not work: remove it and add it again.",
        },
    },
    platform: {
        eyebrow: "Gioia365 Super admin",
        title: "Gioia365 companies",
        about: {
            title: "What it is for",
            text: "Here are the companies that use Gioia365. Only the Gioia365 Super admin creates and suspends them.",
        },
        list: {
            title: "The companies",
            caption: "The Gioia365 companies",
            counts: "{total} in all: {active} active, {suspended} suspended, {closed} closed, {preparing} being set up.",
            empty: "There is no company yet. Create one with «New company».",
            preparing: "Setting up the database of {organization}…",
        },
        new: "New company",
        columns: {
            company: "Company",
            status: "Status",
            owner: "Owner",
            people: "Active people",
            created: "Created on",
            action: "Action",
        },
        status: {
            provisioning: "Being set up",
            stalled: "Setup stopped",
            active: "Active",
            suspending: "Suspension in progress",
            closing: "Closing in progress",
            suspended: "Suspended",
            closed: "Closed",
        },
        row: {
            enter: "Enter",
            enterNamed: "Enter {organization}",
            manage: "Manage",
            manageNamed: "Manage {organization}",
            continueSetup: "Resume the setup",
            continueSetupNamed: "Resume the setup of {organization}",
        },
        fields: {
            name: "Company name",
            nameMissing: "Write the company name.",
            slug: "Short address",
            slugHint: "It is also the company's address, to give to the people who work there (for example gioia365.com/academy); it cannot be changed.",
            slugInvalid: "Use 3 to 40 characters: lowercase letters and numbers, separated by hyphens, and not the name of a page of the program.",
            timeZone: "Time zone",
            language: "Language for new people, if their browser does not indicate one",
            owner: "Owner",
            ownerValue: "{name} · {email}",
            ownerFirstName: "Owner's first name",
            ownerLastName: "Owner's last name",
            ownerNameMissing: "Please enter the owner's first and last name.",
            ownerEmail: "Owner's email",
            ownerEmailHint: "The invitation arrives here: the owner chooses their password and becomes the company's Super admin.",
            ownerEmailInvalid: "Write a valid email: it is the one the owner signs in with.",
        },
        create: {
            submit: "Create the company",
            submitting: "Setting up the company's database…",
            waiting: "This takes a moment: do not close this window.",
            created: "Company created. The invitation was sent to {email}.",
        },
        ownerLink: {
            title: "The owner's invitation is ready",
            intro: "{organization} has been created. The email did not go out: copy the link and send it to {name} yourself, for example on WhatsApp. It expires on {date}.",
        },
        manage: {
            suspend: "Suspend",
            resume: "Reactivate",
            close: "Close",
            closeNamed: "Close {organization}",
            done: "Done",
            rename: "Save the name",
            renaming: "Saving…",
            renamed: "Name saved.",
            renameHint: "Everyone sees it in the program and in invitations. The short address below does not change.",
        },
        confirm: {
            suspendTitle: "Suspend {organization}?",
            suspendText: "Nobody in the company can sign in until you reactivate it. Nothing is deleted.",
            closeTitle: "Close {organization}?",
            closeText: "This is permanent: nobody can sign in any more. The data stays until the database is deleted by hand.",
        },
        done: {
            suspended: "{organization} is suspended.",
            resumed: "{organization} is active again.",
            closed: "{organization} is closed.",
        },
        errors: {
            invalid_state: "Someone has just changed it: the table is up to date.",
            resumeTaken: "Someone else has just finished it: the table is up to date.",
        },
    },
    platformWhatsApp: {
        open: "WhatsApp numbers",
        title: "Allowed numbers for {organization}'s WhatsApps",
        intro: "Outside production {organization}'s automatic WhatsApps (the official WhatsApp from Meta and WhatsApp Agile) only go to these numbers: the phones of the team testing it. By hand nothing is sent by itself and it always stays.",
        allowed: "Allowed numbers",
        allowedFormat: "One number per line, with the country prefix, for example +393000000001. At most {max}.",
        allowedInvalid: "«{number}» is not a valid number: write it with the country prefix, for example +393000000001.",
        allowedTooMany: "Too many: at most {max} numbers.",
        empty: "No allowed number: no automatic WhatsApp of {organization} leaves.",
        save: "Save",
        saveNothing: "No changes to save.",
        saved: "Allowed numbers saved.",
        conflict: "Meanwhile someone changed {organization}'s allowed numbers: to keep the ones written here, save again.",
    },
    platformTelephony: {
        title: "Telephony of {organization}",
        open: "Telephony",
        off: "Telephony is off.",
        turnOn: "Turn on telephony",
        turnOnHint: "Gioia365 creates the company's subaccount, key and application at the provider by itself: there is no need to open the console or copy anything.",
        turningOnWait: "Gioia365 is setting up the provider: it takes a few seconds. You can leave this window open.",
        provider: "Provider",
        providers: {
            twilio: "Twilio",
            telnyx: "Telnyx",
        },
        setupTitle: "Setup at the provider",
        stepName: {
            account: "Subaccount",
            api_key: "Key",
            application: "Application",
            storage: "Audio storage",
        },
        stepAccount: "Subaccount created",
        stepApiKey: "Key created",
        stepApplication: "Application created",
        stepStorage: "Audio storage set up",
        stepAudioAtProvider: "The audio stays at the provider (Twilio, United States)",
        stepDoing: "{step}: in progress…",
        stepWaiting: "{step}: waiting",
        stepFailed: "{step}: failed",
        statePending: "Being set up…",
        stateReady: "Ready",
        stateFailed: "Failed at the «{step}» step: {reason}",
        stateStalled: "The setup stopped halfway: «Retry» resumes it from where it got to.",
        retry: "Retry",
        retrying: "Retrying…",
        reason: {
            credentials: "the provider does not accept the Gioia365 key: it must be replaced with a valid one.",
            rateLimited: "the provider asks to slow down: try again in a few minutes.",
            providerDown: "the provider has a fault right now: try again in a few minutes.",
            unreachable: "Gioia365 could not reach the provider: try again shortly.",
            timeout: "the provider did not answer in time: try again.",
            accountMissing: "the subaccount is no longer at the provider.",
            foreignAccount: "the provider already has an account with this name that Gioia365 did not create for this company, and it does not use it.",
            applicationMissing: "the voice application is no longer at the provider.",
            invalidResponse: "the provider answered in a way Gioia365 does not understand: try again shortly.",
            signingSecret: "the provider did not give Gioia365 the code it recognises its notices by: try again shortly.",
            secrets: "Gioia365 cannot reread the access details it had saved for this company.",
            generic: "the provider did not complete the step: try again shortly.",
        },
        waitReady: "The displayed number, recording and the test open when telephony is ready.",
        inactiveTurnOn: "The company is not active: until it is, telephony cannot be turned on.",
        inactive: "The company is not active: until it is, the setup cannot be resumed and the displayed number cannot be verified. You can still save the settings, test the connection and turn telephony off.",
        callerTitle: "Displayed number",
        callerNumber: "Displayed number (for «Test the connection»)",
        callerHint: "It is used by «Test the connection». To verify this number, the provider calls the mobile and whoever holds it types the code. In calls the Lead sees the mobile of whoever calls, given in Settings → Team.",
        callerInvalid: "Write the number with the country code and no spaces, for example +393000000001.",
        callerAlreadyVerified: "The provider has already verified this number for the company, for example in the mobile pool: it is not verified a second time here, and the displayed number stays as it was.",
        callsTitle: "Recording and numbers",
        recording: "Record calls",
        recordingNotice: "Notice to the Lead before recording",
        recordingNoticeHint: "The Lead hears it as soon as they answer. Leave it empty to say nothing.",
        noticeInvalid: "The notice can have at most 300 characters, on one line and with no special characters.",
        allowed: "Allowed numbers",
        allowedHint: "Only these numbers can be called. In test companies they are required.",
        allowedFormat: "One number per line, with the country code, for example +393000000001. At most {max}.",
        allowedMissing: "Test companies need allowed numbers: write at least one.",
        allowedInvalid: "«{number}» is not a valid number: write it with the country code, for example +393000000001.",
        allowedTooMany: "That is too many: at most {max} numbers.",
        allowedLandline: "{number} looks like an Italian landline without the 0: after +39 landlines start with 0, for example +39 02… or +39 095…",
        save: "Save",
        saveNothing: "No changes to save.",
        saved: "Settings saved.",
        conflict: "Someone else has just changed this company's telephony: I reread the settings. Check what you wrote and save again.",
        checkTitle: "Connection",
        check: "Test the connection",
        checking: "Testing the connection…",
        checkOk: "Connection succeeded",
        checkedAt: "Tested on {date}",
        checkReason: {
            credentials_rejected: "The provider does not accept this company's key.",
            account_mismatch: "The subaccount that answers is not this company's.",
            application_missing: "The voice application is no longer at the provider.",
            caller_not_verified: "The displayed number is not verified yet: verify it above.",
            unreachable: "Gioia365 could not reach the provider: try again shortly.",
            other: "The test did not succeed: try again shortly.",
        },
        disable: "Turn off telephony",
        disableTitle: "Turn off the telephony of {organization}?",
        disableText: "Nobody in the company can call until you turn it on again. Nothing is deleted at the provider.",
        disabling: "Turning telephony off…",
    },
    callerVerification: {
        verify: "Verify",
        busy: "Asking the provider for the verification…",
        typeCode: "The phone is ringing: whoever holds it answers and types {code} on the keypad.",
        codeSent: "The provider sends a code to that phone. The verification ends when the provider confirms it.",
        requested: "Verification asked of the provider: waiting for confirmation. If the phone did not ring, press «Verify» to ask for a new code.",
        verified: "Verified",
        failed: "Verification failed: the phone did not answer or the code was wrong. Press «Verify» to try again.",
    },
    callerNumbers: {
        poolTitle: "Pool of numbers to call from",
        poolHint: "The company's Italian numbers, which calls go out from: they come with the telephony and are given to people from their row, with «Manage». Everyone has one, and the same number can belong to several people: every call stays with whoever makes it.",
        column: "Number to call from",
        none: "No number",
        free: "free",
        of: "assigned to {name}",
        alsoOf: "also assigned to {names}",
        summary: "Numbers to call from: {assigned} assigned out of {total}.",
        summaryOne: "Numbers to call from: 1 assigned out of {total}.",
        add: "Add a mobile",
        import: "Read the mobiles already verified",
        failed: "Verification failed: try again.",
        remove: "Remove from the pool",
        requested: "Verification asked of the provider: waiting for confirmation.",
        failedElsewhere: "Verification failed: whoever manages the numbers to call from, the company's Super admin or Admin, tries it again.",
        empty: "There is no mobile in the pool yet.",
        loadFailed: "I can't read the numbers to call from. Try again.",
        verifyNamed: "Verify {number}",
        removeNamed: "Remove {number} from the pool",
        imported: "Mobiles already verified added to the pool: {count}.",
        importedOne: "One mobile already verified added to the pool.",
        importedNone: "No new mobile: the ones verified at the provider are already in the pool.",
        addDialog: {
            verifyTitle: "Verify {number}",
            intro: "Gioia365 asks the provider to verify it: the mobile rings and whoever holds it types the code shown here.",
            number: "Mobile",
            numberHint: "An Italian mobile with the country code, for example +393000000001.",
            numberInvalid: "Write the mobile with the +39 country code, for example +393000000001.",
            label: "Mobile's name",
            labelHint: "To recognise it, for example «Desk 2».",
            labelMissing: "Write the mobile's name, at most 60 characters.",
            gone: "This mobile is no longer in the pool: someone else removed it.",
            alreadyVerified: "The provider has already verified this mobile: press «Remove from the pool», then «Read the mobiles already verified», which brings it back to the pool verified.",
            tooMany: "Too many verifications in a short time: the phone has already rung several times. Try again in an hour.",
        },
        removeDialog: {
            title: "Remove {number} from the pool?",
            assigned: "{name} loses it and has no number to call from until you give them another one.",
            assignedMany: "{names} lose it and have no number to call from until you give them another one.",
            free: "It belongs to nobody.",
            past: "The calls already made with this mobile stay as they were.",
            done: "{number} removed from the pool.",
        },
        assign: {
            blocked: "To give numbers, your role needs the «Numbers to call from» section in {link}.",
            suspended: "Someone suspended keeps their number but does not get a new one.",
            versionConflict: "Meanwhile someone changed the numbers to call from: I read them again, check and save again.",
            releasedOnly: "{name} no longer has {number}, but the chosen number was not assigned. {reason}",
        },
        numberDialog: {
            title: "The number {name} calls from",
            assign: "Assign",
            change: "Change",
            assignNamed: "Give {name} a number to call from",
            changeNamed: "Change the number {name} calls from",
        },
    },
    permissions: {
        area: {
            leads: "Leads",
            smart_lists: "Smart Lists",
            tasks: "Tasks and callbacks",
            opportunities: "Opportunities",
            conversations: "Conversations and recordings",
            activity: "Activity log",
            reports: "Reports and Home numbers",
        },
        action: {
            view: "View",
            create: "Create",
            update: "Edit",
            delete: "Delete",
        },
        scope: {
            none: "No",
            own: "Only their own",
            all: "All",
        },
        createScope: {
            none: "No",
            all: "Yes",
        },
        group: {
            leads: "Leads",
            calls: "Calls and WhatsApp",
            team: "Team and users",
            settings: "Settings they can change",
        },
        feature: {
            change_owner: "Change the owner, with a reason",
            import_leads: "Import from a file",
            export_leads: "Export to a file",
            bulk_actions: "Do bulk actions on several Leads",
            merge_duplicates: "Merge duplicates (Data cleanup)",
            trash_restore: "Archive and restore Leads",
            manage_tags: "Create and change tags",
            call: "Call and use the phone desk",
            whatsapp_send: "Send WhatsApp",
            listen_team_recordings: "Listen to colleagues' recordings",
            commercial_view: "See as another person in the company («See as…»)",
            manage_team: "Manage the team (invite, suspend, archive, names, phones and WhatsApp)",
            manage_roles: "Manage roles and permissions",
            settings: {
                team: "Team",
                roles: "Roles and permissions",
                phone_numbers: "Numbers to call from",
                lead_statuses: "Lead statuses",
                lead_fields: "Lead card fields",
                lead_visibility: "Who sees the Leads",
                tags: "Tags",
                call_sequence: "Call sequence (including the minutes for the first call)",
                outcomes: "Outcomes and paths",
                callbacks: "Callbacks and hours",
                whatsapp_channels: "The WhatsApps the company uses",
                whatsapp_sending: "WhatsApp sending",
                whatsapp_templates: "WhatsApp templates",
                calendar: "Calendar, time zone and language",
                assignment: "Lead assignment",
                lead_intake: "Lead intake",
                table_views: "Company view",
                goals: "Goals",
            },
        },
    },
    manualLink: {
        label: "Invitation link",
        copy: "Copy the link",
        copied: "Copied",
        copyFailed: "I cannot copy it from here: select the link and copy it by hand.",
    },
    account: {
        title: "Your account",
        name: {
            help: "This is your account name.",
            helpInCompany: "This is your account name. In the {organization} team you appear as “{displayName}”: whoever manages the team can change that.",
            save: "Save name",
            saved: "Name saved.",
        },
        language: {
            label: "Language",
            italian: "Italiano",
            english: "English",
            saved: "Language saved.",
        },
        password: {
            title: "Password",
            change: "Change password",
            current: "Current password",
            currentMissing: "Write your current password.",
            wrong: "The current password is not correct.",
            done: "Password changed. Your other sessions have been signed out.",
        },
        company: {
            title: "This tab's company",
            current: "{organization} · {role}",
            platform: "In this tab you are in {organization} as Gioia365 Super admin.",
            change: "Change company",
        },
    },
    tab: {
        question: "Which company are you working in on this tab?",
        onePerTab: "Each browser tab works in one company only: you can open another tab on another company.",
        unavailable: "This tab's company is no longer available: choose another one.",
        unknownAddress: "You are not authorized to open this page.",
        noCompany: "You are not part of any active company. Ask whoever manages the team to invite you.",
        platformLink: "Gioia365 companies",
    },
    errorPage: {
        message: "Something did not respond. Try again shortly.",
        signOut: "Sign-out failed. Try again shortly.",
    },
    errors: {
        google_calendar_unavailable: "Google Calendar is not available in Gioia365 yet.",
        google_oauth_invalid: "This connection expired or belongs to another session. Try again from Your account.",
        google_calendar_failed: "Google Calendar did not respond correctly. Try again.",
        registration_unavailable: "Registration is currently unavailable. Please try again later.",
        registration_token_invalid: "This link is invalid or expired. Register again to receive a new link.",
        billing_unavailable: "Purchases are currently unavailable. Please try again later.",
        billing_payment_required: "Your payment needs attention. Manage your subscription to resume work.",
        billing_seat_limit: "Your team uses more seats than purchased. Increase seats before inviting or reactivating people.",
        billing_signature_invalid: "Payment could not be verified.",
        unauthenticated: "Your session has expired: sign in again.",
        membership_required: "This tab does not know which company you are working in: choose the company.",
        membership_forbidden: "You are no longer part of this company, or your access is suspended.",
        platform_forbidden: "This area is only for the Gioia365 Super admin.",
        organization_unavailable: "The company is not available right now. Try again shortly; if it keeps happening, tell whoever runs Gioia365.",
        permission_denied: "You do not have permission to do this.",
        protected_owner: "The company owner is protected: their role and status cannot be changed.",
        role_level: "You can only do this for roles below yours.",
        slug_taken: "This short address is already used by another company: choose another one.",
        provisioning_failed: "Setup stopped halfway. Try again: it resumes where it stopped.",
        provisioning_unavailable: "Creating companies is not active on this server: the database administrator credential is missing.",
        invitation_invalid: "This link no longer works: ask whoever invited you for a new invitation.",
        invitation_expired: "The invitation has expired: ask whoever invited you to send it again.",
        invitation_revoked: "This invitation was cancelled or replaced by a newer one: use the latest link you received.",
        invitation_used: "This invitation has already been used.",
        invitation_pending: "There is already a pending invitation for this email.",
        already_member: "Someone in the company already has this email.",
        invalid_credentials: "Wrong email or password.",
        role_in_use: "This role is still assigned to someone: change their role first.",
        system_role: "The company's Super admin role cannot be changed or archived.",
        feature_unavailable: "This feature is not available: it is up to Gioia365.",
        cannot_act_on_self: "You cannot do this on your own account.",
        not_found: "Could not find what you are looking for: it may have been removed.",
        validation_failed: "Some details are not valid: check the fields and try again.",
        invalid_state: "This cannot be done in its current state: reload the page and check.",
        rate_limited: "Too many attempts: wait a minute and try again.",
        session_mismatch: "This invitation is for someone else. Sign out and open the link again.",
        role_name_taken: "There is already a role with this name: choose another one.",
        origin_forbidden: "The request did not come from Gioia365: reload the page and try again.",
        payload_too_large: "Too much data at once: reduce it and try again.",
        internal_error: "Something went wrong on the server. Try again shortly.",
        // Leads, record and import (M2 plan): fallback texts, the M2 screens can say more.
        organization_schema_outdated: "The company is waiting for an update of its database. Try again shortly; if it keeps happening, tell whoever runs Gioia365.",
        lead_not_found: "Lead not found: it may have been archived or merged into another one, or it is not among those you can see.",
        version_conflict: "Someone has just changed this data: reload and make the change again.",
        field_not_editable: "This field cannot be changed from here.",
        invalid_field_value: "A value is not valid: check the field and try again.",
        invalid_phone: "The phone number is not valid: check it and try again.",
        phone_required: "At least one phone is needed: the mobile or the landline.",
        phone_in_use: "This number is already on another Lead.",
        phone_repeated_on_lead: "This number is already written on this Lead.",
        possible_duplicate_email: "This email is already on another Lead: it may be the same target company.",
        reason_required: "Write the reason for the change.",
        owner_not_eligible: "The person you chose cannot own these Leads, or there is nobody to give them to.",
        call_not_found: "Could not find this call on this Lead.",
        card_model_invalid: "The record layout is not valid: check the fields and try again.",
        import_run_not_found: "Could not find this import.",
        saved_search_not_found: "Could not find this Close saved search among those to decide: reload the page.",
        commercial_view_denied: "You cannot see as this person.",
        membership_active: "This person is still active: their Leads are reassigned only once they are suspended or archived.",
        membership_has_leads: "This person still has Leads: reassign them before continuing.",
        membership_from_close: "This person comes from Close: to bring them back to the team, send them an invitation.",
        filter_invalid: "A filter is not valid: change or remove it and try again.",
        smart_list_not_found: "Smart List not found: it may have been deleted, or it is not among those you can see.",
        smart_list_name_taken: "Its owner already has a Smart List with this name in the menu: choose another one.",
        tag_name_invalid: "This name does not work for a tag: it needs at least one letter or digit, and «Owner:» is reserved for lead sources.",
        tag_hidden: "A tag with this name already exists, but it is hidden: it is no longer added to leads. Choose another name.",
        recipients_required: "Choose at least one colleague to share it with.",
        lead_archived: "This Lead is already archived: you can find it among the archived Leads.",
        lead_not_archived: "This Lead is not archived: reload the page and check.",
        lead_merged: "A Lead merged into another one cannot be restored: its data are already in the Lead that remained.",
        confirmation_required: "Type «elimina» to confirm: deleting is permanent.",
        bulk_too_large: "Too many Leads for one bulk action: at most 5,000 at a time. Narrow the search or the filters and try again.",
        merge_invalid: "These two Leads cannot be merged this way: reload «Data cleanup» and try again from the proposed pair.",
        telephony_unavailable: "Telephony is not ready for this company: switch it on and wait for the setup to finish, then try again.",
        telephony_provisioning_unavailable: "Telephony cannot be set up right now: Gioia365 has no access key at the provider.",
        telephony_provisioning_failed: "The telephony provider did not complete a setup step. Press «Retry»: it resumes where it stopped.",
        lead_not_callable: "This Lead or this number cannot be called now: reload the record to see why.",
        lead_in_call: "A colleague is already on the phone with this Lead: wait until they finish.",
        destination_not_allowed: "This number is not among those the company may call during the tests.",
        call_outcome_exists: "This call already has an outcome: the one you chose now stays in the Timeline as late, without changing it.",
        recording_unavailable: "The recording cannot be played right now. Try again later.",
        recording_link_expired: "Listening has expired: press «Listen» again.",
        attachment_unavailable: "The attachment cannot be opened right now: try again shortly.",
        attachment_link_expired: "The attachment link has expired: open it again from the Timeline.",
        lead_audio_not_deleted: "The call recordings or the note attachments of this Lead could not be deleted, so the Lead was not deleted and stays among the archived ones.",
        dialer_session_active: "You already have a calling session open: interrupt it before starting another one.",
        dialer_session_not_found: "This calling session is no longer there: go back to the list and press «Start calling».",
        dialer_source_empty: "There is no Lead to call in this list right now.",
        dialer_outcome_missing: "First choose the outcome of the call and do the required steps, then «Next Lead».",
        dialer_call_in_progress: "The call is still in progress: end it before moving to the next Lead.",
        lead_reserved: "A colleague is working on this Lead in the Power Dialer right now: call it when they leave it.",
        dialer_queue_busy: "Someone is changing the Leads to call right now: try again in a moment.",
        dialer_already_called: "You already called this Lead in this session: it is not skipped, move on with «Next Lead».",
        dialer_session_paused: "Paused: press Resume to continue",
        sequence_not_open: "This Lead's call sequence has already ended.",
        sequence_cannot_restart: "The sequence restarts only after the Lead answered, after it was stopped by hand or after a wrong number.",
        caller_number_missing: "You have no number to call with: ask whoever manages the numbers to give you a mobile, in Settings → Team.",
        caller_number_taken: "This person already has a number to call from: everyone has only one. Take away the one they have first.",
        caller_number_not_verified: "This mobile is not verified yet: it can be assigned once the provider confirms the verification.",
        caller_number_not_mobile: "Only Italian mobile numbers can be added: a landline or a foreign number will not do.",
        caller_number_exists: "This number is already in the mobile pool.",
        caller_number_already_verified: "The provider has already verified this mobile: press «Read the mobiles already verified».",
        task_not_found: "This Task is no longer there, or it is not among the ones you see.",
        task_exists: "This Lead already has an open callback: move it instead of setting another one.",
        callback_slot_invalid: "This time does not work for a callback: callbacks are Monday to Friday from 08:30 to 20:00, on the quarter hour and after now.",
        appointment_exists: "An open appointment of this kind already exists.",
        appointment_slot_invalid: "Choose a future time within the company’s working calendar.",
        appointment_result_too_early: "You can record the result from the appointment’s start time.",
        opportunity_not_found: "This opportunity is no longer there, or it is not among the ones you see.",
        opportunity_exists: "This Lead already has an open opportunity: close it before reopening another one.",
        manual_call_invalid: "This time does not work for the call: pick a moment that has already passed, since the Lead was added.",
        whatsapp_blocked: "No WhatsApp can be sent to this Lead now: the status blocks it, there is no mobile, or «Do not send WhatsApp» is on.",
        whatsapp_number_taken: "This number already belongs to a colleague: each person has their own.",
        whatsapp_channel_not_enabled: "The company cannot use this WhatsApp yet: for now set «By hand».",
        whatsapp_meta_not_configured: "The official WhatsApp is not connected to Gioia365 yet: for now WhatsApp messages are sent by hand.",
        whatsapp_meta_window_required: "Registering this number needs the Meta window: press «Register on Meta and save» and complete the steps.",
        whatsapp_signup_failed: "The registration on Meta stopped halfway: press «Retry», it resumes where it stopped.",
        whatsapp_signup_busy: "A registration on Meta is already in progress for the company: wait for it to finish and try again.",
        whatsapp_number_mismatch: "The number chosen in the Meta window is not the one written here: check the number and try again.",
        whatsapp_waba_mismatch: "A WhatsApp Business account other than the company's was chosen in the Meta window, and the company's is already in use (a registered number or a template sent to Meta): choose the company's and try again.",
        whatsapp_number_cap_reached: "The Business Manager already has all the numbers it can register: adding more needs a request to Meta.",
        whatsapp_template_not_submitted: "Meta did not accept the template: try again shortly. Its state on Meta has not changed.",
        whatsapp_template_variable_at_edge: "Meta does not accept a template that starts or ends with a variable: add a word or a full stop.",
        whatsapp_recipient_not_allowed: "Number not allowed in the test company: the automatic WhatsApp does not go out, you can send it by hand.",
        whatsapp_waba_taken: "This WhatsApp Business account is already connected to another Gioia365 company: in the Meta window choose this company's account.",
        whatsapp_waba_not_accessible: "Meta says the access given in the window does not include this WhatsApp Business account: open the Meta window again and choose the company's account.",
        whatsapp_daily_cap: "This Lead already received their 2 WhatsApp messages today: with WhatsApp Agile the third does not go out. If needed, send it by hand.",
        whatsapp_agile_code_not_recognised: "WhatsApp Agile does not recognise this code for this number: check the code and the number, with its country code.",
        whatsapp_agile_not_paired: "The code is right but the phone does not look connected: scan the QR code with the work phone and save again.",
        whatsapp_agile_unreachable: "WhatsApp Agile is not answering right now: nothing was saved, try again in a few minutes.",
        intake_test_unavailable: "«Let a test Lead in» exists only in test companies.",
        meta_unavailable: "The link with Meta is not active on this server.",
        meta_login_failed: "Facebook did not accept the login: try «Connect the Facebook page» again.",
        meta_unreachable: "Meta is not answering right now: try again in a few minutes.",
        meta_page_not_found: "This page is not among the ones you manage on Facebook: try again and choose one of yours.",
        meta_page_forms_unreadable: "Meta does not let Gioia365 read the forms of this page: it takes an admin account of the page with a role on the Meta app and, if the page uses the «Leads Access Manager», access to the leads.",
        meta_page_in_use: "This page is already linked to another Gioia365 company: a page brings leads into one company only.",
        report_period_invalid: "The period ends after today or is longer than a year.",
        close_key_rejected: "Close does not recognise this key: check that you copied all of it.",
        close_key_forbidden: "This key cannot read the Close organization: create one that can.",
        close_unreachable: "Close does not answer: try again in a few minutes.",
        close_key_missing: "Save the Close API key first.",
        close_key_unreadable: "The saved key can no longer be read: save it again.",
        close_dry_run_required: "First do a test run without saving with the current key and wait for it to finish.",
        close_import_busy: "An import from Close is already running for this company: wait until it finishes.",
        close_import_not_started: "The import from Close did not start: try again in a few minutes; if it happens again, the Gioia365 team checks it.",
        ghl_key_rejected: "GoHighLevel does not accept this token: check you copied all of it and that it has the read-only scopes (contacts.readonly, conversations.readonly, conversations/message.readonly, locations.readonly).",
        ghl_key_forbidden: "This token cannot read the location: check the Location ID and that the token belongs to this sub-account, with the read-only scopes (contacts.readonly, conversations.readonly, conversations/message.readonly, locations.readonly).",
        ghl_location_not_found: "GoHighLevel finds no location with this Location ID: copy it again from the sub-account settings.",
        ghl_rate_limited: "GoHighLevel received too many requests: try again in a minute.",
        ghl_unreachable: "GoHighLevel does not answer: try again in a few minutes.",
        ghl_key_missing: "Save the GoHighLevel key first.",
        ghl_key_unreadable: "The saved GoHighLevel key can no longer be read: save it again.",
        ghl_import_busy: "A GoHighLevel test run or import is already running.",
        ghl_dry_run_required: "First run “Test run without saving” with the current key.",
        ghl_tags_unconfirmed: "First confirm the tags of the last test run.",
        ghl_owner_missing: "The person who gets the new Leads is not in the Team as an active User.",
        ghl_tags_stale: "These tags belong to a test run that is no longer the last one: look at the new one.",
        ghl_close_import_running: "The Close import is running (or it is between 21:00 and 22:05 Rome time): try again when it is done.",
        ghl_dry_run_incomplete: "The last test run did not read everything GoHighLevel has: run it again before importing.",
        close_ghl_import_running: "An import from GoHighLevel is running: the Close import starts when it is done.",
        ghl_write_dry_run_required: "Run «Test without writing» with the current key first.",
        ghl_write_forbidden: "GoHighLevel does not allow writing with this token: create a new token that also has the scopes contacts.write and locations/customFields.write and save it above.",
        network: "The server is not responding. Check your connection and try again.",
        unexpected_response: "The server gave an unexpected answer. Try again shortly.",
        unexpected: "Something went wrong. Try again shortly.",
    },
    leadList: {
        intro: "Search and open a card. Click a header to sort.",
        searchLabel: "Search in every field",
        searchPlaceholder: "Search: name, target company, phone, email, city…",
        whoLabel: "Whose Leads",
        whoMine: "Mine",
        whoAll: "Everyone's",
        countOne: "1 Lead",
        countMany: "{count} Leads",
        newLead: "New Lead",
        captionAll: "All the Leads of {organization}",
        captionMine: "Your Leads",
        captionFound: "The Leads found in {organization}",
        captionMineFound: "Your Leads found",
        captionFiltered: "The filtered Leads of {organization}",
        captionMineFiltered: "Your filtered Leads",
        captionSorted: "{scope} · sorted by {column}, {direction}",
        columns: {
            lead: "Lead",
            lastName: "Last name",
            firstName: "First name",
            salonName: "Target company name",
            city: "City",
            status: "Status",
            latestCall: "Latest call",
            nextTask: "Next task",
            calls: "Calls",
            callsFull: "Calls over all time",
            calls12Months: "Calls 12 months",
            calls12MonthsFull: "Calls in the last 12 months",
            calls4Months: "Calls 4 months",
            calls4MonthsFull: "Calls in the last 4 months",
            tags: "Tags",
            createdAt: "Created on",
            owner: "Owner",
            mobile: "Mobile",
            landline: "Landline",
            email: "Email",
            province: "Province",
            region: "Region",
            country: "Country",
            latestCallOutcome: "Outcome of the latest call",
            source: "Source",
            smartLists: "In Smart Lists",
        },
        sortWords: {
            textAsc: "from A to Z",
            textDesc: "from Z to A",
            numberAsc: "lowest first",
            numberDesc: "highest first",
            dateAsc: "oldest first",
            dateDesc: "newest first",
            orderAsc: "in status order",
            orderDesc: "in reverse status order",
        },
        province: "{name} ({abbreviation})",
        neverCalled: "Never called",
        inbound: "incoming",
        nextTask: { agreed: "agreed callback", callback: "callback" },
        source: {
            meta: "Meta forms",
            web: "Website",
            ghl: "GoHighLevel",
            file: "From a file",
            manual: "By hand",
            close: "Close",
            other: "Other entry",
            withCampaign: "{source} · {campaign}",
            latest: "latest: {source}",
        },
        smartListsMore: "+{count}",
        smartListsMoreLabel: "and {count} more: {names}",
        noOwner: "No owner",
        ownerInactive: "no longer active, to reassign",
        loadingRow: "Row loading",
        pagesFailed: "Some rows did not load.",
        emptyTitle: "No Leads yet",
        emptyAll: "{organization} has no Leads yet.",
        emptyMineTitle: "You have no Leads of your own yet",
        emptyMineChoose: "Choose «Everyone's» to see your colleagues' Leads too.",
        emptyMineWait: "When one is assigned to you, you will find it here.",
        noResultsTitle: "No Leads for «{q}»",
        noResultsText: "Check the spelling, or search for part of the name, the target company or the phone number.",
        noResultsMine: "You are looking at yours only: choose «Everyone's» to search your colleagues' Leads too.",
        resetSearch: "Clear the search",
    },
    leadFilters: {
        button: "Filters",
        activeOne: "1 active filter",
        activeMany: "{count} active filters",
        allTogether: "{active}: they all apply together",
        none: "No filters: you see all the Leads",
        reset: "Clear the filters",
        done: "Done",
        find: "Find a filter",
        noFieldMatches: "No filter for «{q}».",
        searchIn: "Search in {field}",
        search: "Search",
        removeThis: "Remove this filter",
        remove: "Remove the filter {field}",
        chipField: "{field}:",
        all: "all",
        allFeminine: "all",
        groups: {
            owner: "Owner",
            status: "Lead state",
            calls: "Calls and tasks",
            territory: "Territory",
            salon: "Target company",
            opportunities: "Disco, demo and opportunities",
            created: "Origin",
        },
        fields: {
            owner: "Owner",
            status: "Status",
            tags: "Tags",
            nextTaskAt: "Next task",
            sequence: "Call sequence",
            latestCallAt: "Latest call",
            latestCallOutcome: "Outcome of the latest call",
            outgoingCallCount: "Number of calls",
            outgoingCallCountLast12Months: "Calls in the last 12 months",
            outgoingCallCountLast4Months: "Calls in the last 4 months",
            country: "Country",
            region: "Region",
            province: "Province",
            city: "City",
            opportunity: "Opportunity",
            createdAt: "Created on",
            emailClicked: "Clicked an email",
        },
        ops: {
            in: "is",
            not_in: "is not",
            any: "has any of these",
            all: "has all of them",
            none: "has none of",
            gte: "at least",
            lte: "at most",
            eq: "exactly",
            today: "today",
            yesterday: "yesterday",
            last7: "last 7 days",
            last30: "last 30 days",
            older7: "more than 7 days ago",
            older30: "more than 30 days ago",
            older90: "more than 3 months ago",
            older180: "more than 6 months ago",
            older365: "more than 12 months ago",
            on: "on…",
            before: "before…",
            after: "after…",
        },
        orNeverCalled: "{op} or never called",
        how: "{field}: how",
        number: "{field}: number",
        numberInvalid: "Write a whole number, 0 or more.",
        day: "Day",
        chosen: "{count} chosen",
        chosenOne: "1 chosen",
        noOwner: "No owner",
        outcomeNone: "Never called",
        nextTask: { overdue: "overdue", today: "today", tomorrow: "tomorrow", by: "by the day…", none: "none" },
        emailClicked: {
            within: "in the last … days",
            withinDays: "in the last {days} days",
            never: "never",
            days: "{field}: how many days",
            daysInvalid: "Write a number of days from 1 to 365.",
            hint: "Only clicks count: an open can be the automatic preview of an email program.",
        },
        sequence: {
            due_today: "To call today",
            new_never_called: "New Lead, never called",
            in_progress_later: "In progress, later on",
            ended: "Ended or stopped",
        },
        opportunity: {
            none: "None",
            disco_booked: "Disco booked",
            disco_held: "Disco held",
            demo_booked: "Demo booked",
            demo_held: "Demo held",
            sold: "Club or Percorso sold",
            lost: "Lost",
        },
        perimeter: "Counts across all the Leads you can see",
        typeTwo: "Type at least two letters to search.",
        noOptions: "Nothing to choose.",
        noMatches: "Nothing for «{q}».",
        truncated: "There are more: type more to find them.",
        optionsFailed: "The choices of this filter did not load.",
        emptyTitle: "No Lead matches this search or these filters.",
        emptyHint: "Try removing a filter.",
        emptyHintMine: "Try removing a filter, or choose «Everyone's» to search your colleagues' Leads too.",
        resetAll: "Clear search and filters",
        countryNames: {
            IT: "Italy",
            CH: "Switzerland",
        },
    },
    tableView: {
        button: "Columns and view",
        title: "Columns and view",
        intro: "Columns don't change the filters. Width: drag the right edge of the header.",
        find: "Search a column",
        noMatches: "No column for “{q}”.",
        companyFieldsFull: "At most {max} company fields in the table: hide one to show this one.",
        show: "Show",
        moveUp: "Move up",
        moveDown: "Move down",
        moveLeft: "Move left",
        moveRight: "Move right",
        hide: "Hide",
        width: "Width",
        shown: "In the table",
        others: "Other columns",
        leadFixed: "always first, fixed on the left",
        groups: {
            lead: "Lead",
            calls: "Calls and tasks",
            territory: "Territory",
            contact: "Phones and email",
            salon: "Target company",
        },
        contextLabel: "Applies to:",
        contextLeads: "the Lead list",
        contextList: "the Smart List “{name}”",
        sourceProduct: "the starting view",
        sourcePersonal: "your saved view",
        sourceCompany: "the view of {organization}",
        sourceDevice: "your arrangement, not saved yet",
        using: "You are using {source}.",
        sortUnsaved: "Sort to save: {column}, {direction}.",
        savedHint: "Columns and order stay as you leave them, even if you leave.",
        unsavedHint: "It stays like this even if you leave. Save it to find it on every device.",
        layoutFailed: "The saved view did not load.",
        catalogFailed: "The company fields did not load. Try again before saving the view.",
        useMine: "Use your saved view",
        useProduct: "Back to the starting view",
        useCompany: "Use the view of {organization}",
        saveMine: "Save for me",
        savedMine: "View saved just for you: you will find it on every computer and phone.",
        saveCompany: "Save for all of {organization}",
        confirmCompany: "Confirm: it applies to everyone in {organization}",
        warnCompany: "Every user of {organization} will see this arrangement; personal views already saved are reset. Everyone can then adjust it again for themselves.",
        savedCompany: "View saved for all of {organization}.",
        reasonCompany: "Only people with “Company view” in “Roles and permissions” save the view for the whole company.",
        conflictCompany: "Someone has just saved another view for all of {organization}. It has been reloaded: confirm again to replace it with yours.",
        commercialViewWarning: "You are publishing for every user, not just for {name}.",
        close: "Close",
        menu: "More on this column",
        sortAsc: "Sort {direction}",
        resizeHandle: "Resize {column}",
    },
    smartLists: {
        create: "Create Smart List from these filters",
        createReason: "Add at least one filter to create a Smart List.",
        dialogTitle: "Create Smart List",
        name: "List name",
        nameRequired: "Write the list name.",
        nameTaken: "You already have a list with this name.",
        nameTakenFor: "{name} already has a list with this name.",
        whoSees: "Who sees it",
        visibility: {
            private: "Private",
            shared: "Shared with chosen colleagues",
            public_team: "Public to the team",
        },
        visibilityHint: {
            private: "you, the Super users, the Admins and the Super admin",
            shared: "with chosen colleagues",
            public_team: "all the active users of the company",
        },
        shareWith: "Share with",
        recipientsRequired: "Choose at least one colleague to share it with.",
        noColleagues: "There is no other active User in the team to share it with.",
        whoseLeads: "Which Leads go into the list",
        noOwnerChange: "No Lead changes owner: the list only chooses which Leads to show.",
        theseFilters: "The Leads of these filters",
        theseFiltersPlatform: "As Gioia365 Super admin you have no lists of your own in this company: create the list for a Salesperson, or enter as the company owner.",
        todayCount: ": {count} Leads today.",
        todayCountOne: ": 1 Lead today.",
        forPerson: "The Leads of a Salesperson, for them:",
        personSelect: "The Salesperson of the list",
        noCommercials: "As Gioia365 Super admin you create a list for a Salesperson, and there is no active User in the team.",
        scopeNoteOwner: "Each Salesperson sees and calls only the Leads they own: Settings → “Who sees the Leads” says so.",
        scopeNoteAll: "Whoever uses the list sees and calls all the Leads of the filters, colleagues' ones too: Settings → “Who sees the Leads” says so.",
        saveNote: "The filters are saved, not the free search: the list updates by itself when the data change.",
        mineNotSaved: "“Mine” is not saved in the list: it holds all the Leads of these filters that you can see.",
        cancel: "Cancel",
        createAndOpen: "Create and open",
        saveAsTitle: "Save as new",
        saveAsName: "Name of the new list",
        saveAsNote: "The original list does not change. The new one is yours and opens at once.",
        saveAsSubmit: "Save and open",
        groups: {
            pinned: "Pinned",
            mine: "Yours",
            shared_with_me: "Shared with you",
            team: "The team's",
            colleagues: "Colleagues'",
        },
        railLabel: "The Smart Lists you see",
        pin: "Pin to top",
        unpin: "Unpin",
        moveUp: "Move up",
        moveDown: "Move down",
        pinList: "Pin “{name}” to top",
        unpinList: "Unpin “{name}”",
        moveUpList: "Move “{name}” up",
        moveDownList: "Move “{name}” down",
        orderFailed: "The order of the lists was not saved: it is back as it was. Try again.",
        findList: "Find a list",
        truncated: "These are the first {count} lists you see: “Find a list” searches only among them.",
        noLists: "No Smart List yet: one is born from the Leads list, with “Filters” and then “Create Smart List from these filters”.",
        goToLeads: "Go to the Leads list",
        countOne: "1 Lead",
        countMany: "{count} Leads",
        countMissing: "—",
        countUnavailable: "The count of this list is not available right now.",
        newOne: "1 new",
        newMany: "{count} new",
        railNews: "There are new Leads in the Smart Lists",
        page: {
            dynamic: "With filters: it updates by itself",
            owner: "Owner: {name}",
            ownerWithStatus: "Owner: {name} ({status})",
            personWithStatus: "{name} ({status})",
            personStatus: {
                suspended: "suspended",
                archived: "archived",
                inactive: "no longer active",
            },
            savedAtBy: "Saved on {when} by {who}",
            saved: "Saved",
            dirty: "Unsaved changes",
            staleOne: "A filter of this list used a field that no longer exists: it no longer applies and is removed at the next “Save”.",
            staleMany: "{count} filters of this list used fields that no longer exist: they no longer apply and are removed at the next “Save”.",
            share: "Share",
            more: "More",
            moreLabel: "More on the list",
            rename: "Rename",
            renameHint: "The name changes for whoever uses it too",
            history: "List history",
            historyHintOne: "1 version: who changed it and when",
            historyHint: "{count} versions: who changed it and when",
            delete: "Delete the list",
            deleteHint: "Nothing happens to the Leads",
            moreNote: "Only {owner}, the Super users, the Admins and the Super admin can rename it; only {owner}, the Admins and the Super admin can delete it.",
            moreNoteDelete: "Only {owner}, the Admins and the Super admin can delete it.",
            moreNoteRename: "Only {owner}, the Super users, the Admins and the Super admin can rename it.",
            discard: "Discard changes",
            save: "Save",
            saveAs: "Save as new",
            copyName: "{name} (copy)",
            readOnly: "Read only: only the owner ({owner}) or a Super user, an Admin or the Super admin can change it. To keep your changes use “Save as new”.",
            start: "Start calling",
            startFrom: "Starting from {lead}. Leads to call: {count}.",
            startDirty: "Save the changes with “Save” or “Save as new” to start calling",
            startEmpty: "No Leads to call in this list right now.",
            startNoCall: "You need “Call and use the phone desk” in “Roles and permissions”.",
            resume: "Resume calling",
            restart: "Start over",
            savedLine: "Session interrupted on {when}, with {done} Leads done: it resumes from {next}. “Start over” starts again from the first.",
            savedLineOne: "Session interrupted on {when}, with 1 Lead done: it resumes from {next}. “Start over” starts again from the first.",
            savedLineNone: "Session interrupted on {when}, before finishing the first Lead: it resumes from {next}.",
            workedCalled: "Called in the session to resume",
            workedSkipped: "Skipped in the session to resume",
            otherSession: "You have a calling session in progress on “{source}”: interrupt it to call from here?",
            interruptOther: "Interrupt and call from here",
            search: "Search the results",
            searchNote: "The search shows {shown} of {total} Leads and does not change the list.",
            queue: "Calls go in this order, from number 1: {sort}. To change it click a header, then “Save”.",
            sortText: "{column}, {direction}",
            caption: "Leads of the list in call order: {sort}",
            position: "Place {position} in the call order",
            positionPrefix: "Place",
            empty: "No Lead matches the conditions of the list.",
            emptyHint: "When the data change, the list updates by itself.",
            noSearchResults: "The search finds no Lead in this list.",
            clearSearch: "Clear the search",
            savedVersion: "Saved: version {revision}.",
            conflict: "Meanwhile someone else saved this list: I reloaded it and your changes are still here. Check them and press “Save” again.",
            changedMeanwhile: "Meanwhile someone else changed this list: I reloaded it. Check and try again.",
            confirmTitle: "What changes for whoever uses it",
            confirmUsers: "Also used by {people}. From now on, for them:",
            confirmUsersTeam: "everyone in {organization}, because it is public to the team",
            confirmUsersShared: "the colleagues it is shared with",
            confirmCount: "For you the Leads in the list go from {before} to {after}.",
            confirmHistory: "The previous version stays in the history.",
            confirmSave: "Save for everyone",
            leaveTitle: "You have not saved the changes",
            leaveText: "You changed the filters or the order of this list. If you leave now, the changes are lost and the list stays as it was.",
            stay: "Stay here",
            leaveDiscard: "Leave without saving",
            saveAndLeave: "Save and leave",
            renameTitle: "Rename the list",
            renameName: "Name",
            renameNote: "The name changes in the menu of whoever uses it too.",
            renamed: "List renamed: “{name}”.",
            deleteTitle: "Delete the list",
            deleteText: "Delete “{name}”? It disappears from the menu of whoever sees it; nothing happens to the Leads.",
            deleteConfirm: "Delete",
            deleted: "List “{name}” deleted. Nothing happened to the Leads.",
            notFoundTitle: "Smart List not found",
            notFoundText: "This list no longer exists or is not shared with you.",
            openList: "Open “{name}”",
            historyCaption: "Versions of the list, newest first",
            historyVersion: "Version",
            historyWhen: "When",
            historyWho: "Who",
            historyWhat: "What changed",
            historyAction: "Action",
            inUse: "in use",
            restore: "Restore this version",
            historyNote: "Every save is a version. Restoring an old version does not delete the later ones.",
            restored: "Version {revision} restored as an unsaved change: press “Save” to keep it.",
            restoredReadOnly: "Version {revision} restored as a change: you can keep it only with “Save as new”.",
            restoredSame: "Version {revision} already has the same filters and order as the list: there is nothing to save.",
            shareTitle: "Who sees this list",
            shareReadOnly: "{owner} manages it: you can see who sees it, but only the owner, the Super users, the Admins and the Super admin can change that.",
            shareHint: {
                private: "The owner, the Super users, the Admins and the Super admin see it.",
                shared: "The colleagues you tick below see it too.",
                public_team: "Everyone in {organization} sees it, in the menu on the left. Nobody outside Gioia365 sees it.",
            },
            shareOwner: "Owner of the list",
            shareOwnerNote: "You can give the list to a colleague: it becomes theirs and they manage it. The history keeps that you did it.",
            shareOwnerInactive: "{owner} is {status}: the list stays and whoever uses it keeps calling. If needed, choose a new owner below.",
            shareNote: "Whoever sees it can open it, call with “Start calling” and save a copy with “Save as new”. Only the owner, the Super users, the Admins and the Super admin can change it. Sharing a list shows no extra Leads: everyone sees only the Leads they can already see.",
            shareSave: "Save who sees it",
            shareOwnerOnly: "{owner} becomes the owner: choose at least one other colleague to share it with, or another visibility.",
            shared: "{changes} It stays in the list history.",
            recipientSuspended: "{name} (suspended)",
            recipientInactive: "{name} (no longer among the active Users)",
            changes: {
                filterAdded: "Added the filter {field}: {value}.",
                filterChanged: "{field}: from “{before}” to “{after}”.",
                filterRemoved: "Removed the filter {field} (was “{value}”).",
                structure: "Changed how the filters combine.",
                sort: "Call order: from “{before}” to “{after}”.",
                name: "Renamed from “{before}” to “{after}”.",
                visibility: "Who sees it: {after}.",
                recipients: "Shared with: {names}.",
                owner: "Owner: from {before} to {after}.",
                created: "Created.",
            },
        },
    },
    newLead: {
        title: "New Lead",
        salonName: "Target company name",
        mobile: "Mobile",
        prefix: "Mobile prefix",
        prefixes: {
            it: "+39 IT",
            ch: "+41 CH",
            sm: "+378 SM",
            fr: "+33 FR",
            de: "+49 DE",
            at: "+43 AT",
        },
        mobilePlaceholder: "347 123 4567",
        landline: "Landline",
        phoneHint: "A phone number is the only required detail: the mobile or the landline.",
        email: "Email",
        owner: "Owner",
        ownerNone: "No owner, assign it later",
        ownerRule: "With the assignment rule",
        ownerSelf: "The new Lead is yours.",
        afterCreate: "It starts with the default status; after «Create Lead» its card opens.",
        submit: "Create Lead",
        phoneRequired: "Write the mobile or the landline.",
        phoneInvalid: "This number is not valid: check it, for example 347 123 4567.",
        looksLandline: "It looks like a landline: write it in «Landline».",
        looksMobile: "It looks like a mobile: write it in «Mobile».",
        phoneRepeated: "It is the same number as the mobile.",
        emailInvalid: "Check the email, for example name@company.com.",
        cityInvalid: "Choose the city from the list while you type.",
        phoneInUse: "A Lead with this number already exists: I am not creating a second one.",
        phoneInUseHidden: "A Lead with this number already exists, but it is not among those you can open: ask whoever manages the Leads.",
        openLead: "Open the Lead",
        duplicateEmail: "Another Lead has this email. It may be a duplicate, but a Lead is recognised by its phone: if it is a different person, create it anyway.",
        createAnyway: "Create anyway",
        created: "Lead created.",
    },
    cityPicker: {
        label: "City",
        placeholder: "Type the city, even just part of it",
        hint: "Province, region and country fill in by themselves.",
        place: "{province} · {region} · {country}",
        italy: "Italy",
        results: "Municipalities found",
        searching: "Looking for municipalities…",
        none: "No municipality found for «{q}».",
    },
    styleguide: {
        title: "Design system",
        tokens: "Tokens",
        breakpoints: "Breakpoints",
        components: "Components",
        dialogs: "Dialogs and panels",
        fields: "Fields",
        tables: "Tables",
        states: "States and notes",
        feedback: "Notifications and the save bar",
        navigation: "Page header and choices",
        serverStatus: "Server status",
        serverUnavailable: "Server unreachable",
        serverVersion: "Version {version}",
    },
    outcomes: {
        answered: "Answered",
        no_answer: "No answer",
        wrong_number: "Wrong number",
    },
    answeredOutcomes: {
        call_back: "Call back",
        not_interested: "Not interested",
        do_not_call: "Does not want to be called",
        disco_booked: "Disco booked",
        demo_booked: "Demo booked",
        other: "Other (with a note)",
    },
    timeline: {
        title: "Timeline",
        filtersLabel: "Show in the Timeline",
        filters: {
            all: "All",
            calls: "Calls",
            notes: "Notes",
            changes: "Changes",
            history: "Close history",
            email: "Email",
        },
        searchLabel: "Search the Timeline",
        loading: "Loading the Timeline…",
        loadingMore: "Loading older items…",
        more: "Show older items",
        moreFailed: "The older items did not arrive.",
        empty: "Nothing in this Lead's Timeline yet.",
        emptyFilter: "Nothing to show with this filter.",
        noResults: "Nothing in the Timeline for «{q}».",
        resetSearch: "Clear the search",
        fromClose: "from Close",
        dateUnknown: "original date unknown",
        unknownAuthor: "unknown author",
        composer: {
            label: "New note",
            placeholder: "Write a note about the Lead…",
            hint: "Notes cannot be changed: an addition becomes a new note.",
            submit: "Save note",
            saving: "Saving the note…",
            required: "Write something before saving the note.",
            saved: "Note saved in the Timeline.",
        },
        memo: {
            title: "Call note",
            add: "Add a call note",
            label: "Note on this call",
            submit: "Save call note",
            saving: "Saving the call note…",
            required: "Write the call note before saving it.",
            saved: "Call note saved on this call. It cannot be changed: an addition becomes a new call note.",
        },
        call: {
            outbound: "Outbound call",
            inbound: "Inbound call",
            unknownOutcome: "Outcome unknown",
            failed: "Failed, does not count",
            outcomeWithDetail: "{outcome} ({detail})",
            live: "In progress",
            twoSteps: "{outcome} · {answered}",
            duration: "duration {duration}",
            manual: "entered by hand",
            minutes: "{count} min",
            details: {
                busy: "busy",
                vmAnswer: "voicemail",
                vmLeft: "voicemail, message left",
                abandoned: "hung up before an answer",
                blocked: "call blocked",
                automatic: "recorded by Gioia365",
            },
        },
        whatsapp: {
            prepared: "WhatsApp prepared",
            declaredSent: "WhatsApp declared sent",
            other: "WhatsApp",
            received: "The Lead wrote",
            unread: "To read",
            readBy: "Read by {name} on {when}",
            readByPlatform: "Read by Gioia365 on {when}",
            markRead: "Mark as read",
            automaticAuthor: "Gioia365 (automatic)",
            inboundKinds: {
                image: "The Lead sent an image: open it on the phone",
                audio: "The Lead sent an audio message: listen to it on the phone",
                video: "The Lead sent a video: open it on the phone",
                document: "The Lead sent a document: open it on the phone",
                sticker: "The Lead sent a sticker: open it on the phone",
                location: "The Lead sent a location: open it on the phone",
                contacts: "The Lead sent a contact: open it on the phone",
                other: "The Lead sent a message that Gioia365 does not show: open it on the phone",
            },
            withTemplate: "{title} · template «{name}»",
            openedTo: "opened in WhatsApp Desktop to {number}",
            to: "to {number}",
            declaredAt: "declared sent {when}",
            unverifiable: "delivery and reading cannot be verified",
            official: "Official WhatsApp · {state}",
            officialStates: {
                queued: "Accepted by Meta",
                sent: "Sent",
                delivered: "Delivered",
                read: "Read by the Lead",
                failed: "Not delivered",
                notConfirmed: "Not confirmed",
            },
            failureReason: "reason: {reason}",
            failureWithCode: "{title} (code {code})",
            failureCode: "code {code}",
            failureReasons: {
                code130429: "the number reached Meta's limit of messages per second",
                code130472: "the Lead's number is part of a Meta experiment that excludes this message",
                code131000: "unknown error from Meta",
                code131021: "the Lead's number is the same as the sender's",
                code131026: "the number is not on WhatsApp, has not accepted WhatsApp's terms or has an app that is too old",
                code131031: "the WhatsApp Business account is locked by Meta",
                code131042: "there is a problem with the payment method of the WhatsApp Business account",
                code131047: "more than 24 hours have passed since the Lead last replied",
                code131048: "too many messages from this number were blocked or flagged as spam",
                code131049: "Meta did not deliver it so as not to send too many marketing messages to the same person",
                code131050: "the Lead chose not to receive marketing messages from this company",
                code131056: "too many messages to the same Lead in a short time",
                code131057: "the WhatsApp Business account is under maintenance",
                code132000: "the values do not match the template's variables",
                code132001: "the template does not exist on Meta or is not approved",
                code132007: "the template breaks a WhatsApp policy",
                code132012: "the template's values do not have the right format",
                code132015: "the template is paused by Meta for low quality",
                code132016: "the template was disabled by Meta",
                code133010: "the sender's number is not registered on WhatsApp Business",
                code368: "the WhatsApp Business account is restricted by Meta for a policy violation",
                notConfirmed: "Meta did not confirm the sending: the message may or may not have arrived",
            },
            agileStates: {
                queued: "Being sent with WhatsApp Agile",
                sent: "Accepted by WhatsApp Agile",
                failed: "Not accepted by WhatsApp Agile",
                noResponse: "WhatsApp Agile did not answer: we do not know whether it left",
                notConfirmed: "Not confirmed by WhatsApp Agile",
            },
            agileFailures: {
                http: "WhatsApp Agile answered with error {status}",
                httpWithText: "{text} (WhatsApp Agile, error {status})",
                invalidReference: "the Lead's number or the sender's number is not in a form WhatsApp Agile accepts",
                notResent: "it is not sent again by itself, so it never goes twice: WhatsApp Agile retries for 24 hours what it accepted",
            },
        },
        email: {
            events: {
                delivered: "Email delivered",
                opened: "Email opened",
                clicked: "Clicked a link in the email",
                bounced: "Email bounced",
                complained: "Email marked as spam",
                unsubscribed: "Unsubscribed from emails",
                replied: "Replied to the email",
            },
            subject: "Subject: “{subject}”",
            link: "Link:",
        },
        note: {
            title: "Note",
            withOrigin: "Note · {origin}",
            attachments: {
                title: "Attachments",
                open: "Open",
                download: "Download",
                openLabel: "Open «{name}»",
                downloadLabel: "Download «{name}»",
                to_copy: "To copy from Close",
                failed: "Copy from Close failed",
                missing: "No longer in Close",
                expired: "No longer available",
                sizeKb: "{size} KB",
                sizeMb: "{size} MB",
            },
        },
        change: {
            one: "«{field}» field changed",
            many: "{count} changes: {fields}",
            line: "{field}: {change}",
            fromTo: "from «{before}» to «{after}»",
            added: "added «{value}»",
            removed: "removed «{value}»",
            reason: "Reason: {reason}",
            empty: "empty",
            unknownField: "Lead detail",
            yes: "yes",
            no: "no",
        },
        intake: {
            enteredWeb: "Came in from the website",
            enteredGhl: "Came in from GoHighLevel",
            enteredMeta: "Came in from the Meta forms",
            enteredFile: "Came in from a file",
            reentered: "Came back with the same mobile · {source}, {changes}",
            sources: {
                web: "from the website",
                ghl: "from GoHighLevel",
                meta: "from the Meta forms",
                file: "from a file",
                manual: "from «New Lead»",
                other: "from an entry",
            },
            nothingNew: "nothing to update",
            updated: "details updated, {list}",
            fieldsOne: "1 field",
            fieldsMany: "{count} fields",
            tagsOne: "one tag",
            tagsMany: "{count} tags",
            and: "{first} and {second}",
        },
        event: {
            created: "Lead created",
            createdInClose: "Lead created in Close",
            createdDetails: "Status: {status} · Owner: {owner}",
            imported: "Lead imported from Close",
            joinedFromClose: "Close history added: same mobile",
            archived: "Lead archived",
            archivedReason: "Reason: {reason}",
            restored: "Lead restored",
            merged: "Merged with «{name}»",
            mergedNoName: "Merged with another Lead",
            mergedDetails: "Its calls, notes and changes are in here too.",
            mergedAway: "Merged into «{name}»",
            mergedAwayNoName: "Merged into another Lead",
            outcomeLate: "Outcome arrived late, not applied",
            outcomeLateProposed: "Proposed: {outcome}",
            phoneMarkedWrong: "Number marked wrong: {field} {number}",
            phoneMarkedWrongNumber: "Number marked wrong: {number}",
            dialerSkipped: "Skipped in the calling session: {reason}",
            dialerPassed: "Moved to the next one without calling",
            // The call sequence (M5 plan, Task 12).
            sequenceStarted: "Call sequence started",
            sequenceRestarted: "Sequence restarted from the beginning",
            sequenceRestartedAutomatically: "Sequence restarted by itself: {n} working days without contact",
            sequenceAttemptClosed: "Attempt {n} closed with {calls} of {required}",
            sequenceViolated: "Sequence not followed: {reason}",
            sequenceEnded: "Sequence ended: {reason}",
            sequenceStopped: "Sequence stopped by hand",
            sequenceAnsweredManually: "The lead answered ({how}) · marked by hand",
            callSlot: "attempt {attempt} · call {number}",
            taskCreated: "Callback set for {when}",
            taskCreatedAgreed: "Callback set for {when} · agreed with the Lead",
            taskRescheduled: "Callback moved from {before} to {after}",
            taskCompleted: "Callback done",
            taskCanceled: "Callback canceled",
            taskAgreed: "Callback for {when} · agreed with the Lead",
            taskNotAgreed: "Callback for {when} · no longer agreed with the Lead",
            whatsappOptedOut: "Do not send WhatsApp: on",
            whatsappOptedOutText: "The Lead asked not to receive WhatsApp messages, for example by writing STOP. Calls remain possible.",
            whatsappOptedIn: "Do not send WhatsApp: off",
            whatsappOptedInText: "The Lead asked for WhatsApp messages again.",
            other: "Activity recorded",
            opportunity: {
                title: "Opportunity: stage changed",
                phases: "From «{before}» to «{after}»",
                phase: "Stage: «{after}»",
                pipeline: "Pipeline: {name}",
                value: "Value: {value}",
                monthly: "{value} a month",
                annual: "{value} a year",
            },
            task: {
                title: "Task completed",
                due: "Due: {date}",
                assignedTo: "Assigned to: {name}",
            },
            closeImportUpdate: "Updated in Close by an import",
            closeLeadMerge: "Merged in Close with another Lead",
            // A Close email that came in as history (22/10/2026): Gioia365 does not send emails.
            closeEmail: {
                sent: "Close email sent",
                received: "Close email received",
                other: "Close email",
                subject: "Subject: {subject}",
                noSubject: "No subject",
                status: "Status in Close: {status}",
                statuses: {
                    draft: "draft, never sent",
                    scheduled: "scheduled, not sent",
                    outbox: "outgoing, not sent",
                    error: "not sent because of an error",
                },
                attachments: "Attachments left in Close: {count}",
                truncated: "The text goes on in Close: the first 100,000 characters come in here.",
            },
            ghlMessage: {
                inbound: "{channel} received in GoHighLevel",
                outbound: "{channel} sent from GoHighLevel",
                other: "{channel} from GoHighLevel",
                channels: { email: "Email", whatsapp: "WhatsApp", instagram: "Instagram message", facebook: "Facebook message", sms: "SMS", call: "Call" },
                subject: "Subject: {subject}",
                noSubject: "No subject",
                duration: "Duration: {minutes} min {seconds} s",
                truncated: "The text goes on in GoHighLevel: the first 100,000 characters come in here.",
                automated: "Automated {channel} from GoHighLevel: {count}",
                automatedPeriod: "From {from} to {to}, newsletters and sequences: not read one by one.",
                automatedNew: "Of these {total}, {count} came in with this import: the others are in the earlier lines.",
            },
            meeting: {
                title: "Meeting",
                titled: "Meeting: {title}",
                start: "Start: {when}",
                duration: "Duration: {duration}",
                attendees: "Attendees: {names}",
                location: "Place: {place}",
                status: "Status: {status}",
                statuses: {
                    completed: "held",
                    canceled: "cancelled",
                    upcoming: "scheduled",
                },
            },
            custom: {
                title: "Close activity",
                field: "{name}: {value}",
                unnamedField: "Unnamed field",
            },
        },
    },
    leadCard: {
        fields: {
            firstName: "First name",
            lastName: "Last name",
            salonName: "Target company name",
            email: "Email",
            website: "Website",
            streetAddress: "Street address",
            postalCode: "Postal code",
            mobile: "Mobile",
            landline: "Landline",
            secondHolder: "Second holder",
            secondHolderFirstName: "Second holder's first name",
            secondHolderLastName: "Second holder's last name",
            secondHolderEmail: "Second holder's email",
            secondHolderMobile: "Second holder's mobile",
            status: "Status",
            city: "City",
            // Read-only: they come from the city (decision of 1 October 2026).
            province: "Province",
            region: "Region",
            country: "Country",
            owner: "Owner",
            tags: "Tags",
        },
        backToList: "Back to the Leads",
        eyebrow: "Lead",
        twoHolders: "{first} and {second}",
        ownerFact: "Owner: {name}",
        noOwner: "No owner",
        ownerInactive: "no longer active, to reassign",
        status: "Status",
        tags: "Tags",
        noTags: "No tags",
        editTags: "Edit tags",
        actions: "Quick actions",
        note: "Note",
        more: "More",
        moreLabel: "More actions",
        loadingCard: "Loading the card…",
        colleague: "This Lead belongs to {name}. You can update it: it stays theirs, and every change shows in the Timeline with your name.",
        colleagueReadOnly: "This Lead belongs to {name}. You can read its card, not change it.",
        readOnly: "You can read this card, not change it.",
        duplicates: {
            label: "Possible duplicates",
            samePhone: "Possible duplicate: same mobile as {link}",
            sameEmail: "Possible duplicate: same email as {link}",
            merge: "Merge",
            notDuplicates: "Not duplicates",
            more: "and {count} more",
            readOnly: "Whoever cleans up the data will sort it out.",
            gone: "This pair is no longer there: the card has been updated.",
        },
        conflict: "Someone else changed this Lead in the meantime: the card now shows the updated data, and your change was not saved.",
        statusSaved: "Status changed: {name}. It stays in the Timeline.",
        data: {
            title: "Lead data",
            help: "Click a value to change it, then Enter to save or Esc to cancel. Every change stays in the Timeline with the name of who made it.",
            sections: {
                contact: "Contact and responsibility",
                salon: "Target company and qualification",
                territory: "Territory",
            },
            salonNote: "Stated problem and competitors go in the notes.",
            fromCity: "from the city",
            provinceValue: "{name} · {abbreviation}",
            cityValue: "{name} ({abbreviation})",
            empty: "Add",
            editLabel: "Edit {field}: {value}",
            editHint: "Enter saves · Esc cancels",
            editHintMultiline: "Enter saves · Shift+Enter starts a new line · Esc cancels",
            saved: "«{field}» saved: it stays in the Timeline.",
            prefix: "{field} prefix",
            choiceNone: "No choice",
            euro: "€",
        },
        errors: {
            number: "Type a number, with at most two decimals: for example 38 or 38.50.",
            email: "Check the email, for example name@company.com.",
            city: "Pick the city from the list as you type.",
            phone: "This number is not valid: check it, for example 347 123 4567.",
            looksLandline: "It looks like a landline: type it in «Landline».",
            looksMobile: "It looks like a mobile: type it in «Mobile».",
            secondHolderLandline: "It looks like a landline: the second holder only has a mobile.",
            conflict: "Someone else changed this Lead while you were saving: your change is here, not saved. Check it and press Enter to save it.",
        },
        secondHolder: {
            add: "Add another holder",
            remove: "Remove the second holder",
            confirmTitle: "Remove the second holder",
            confirmText: "The second holder's first name, last name, mobile and email leave the card. The change stays in the Timeline with your name.",
            confirm: "Remove",
            removed: "Second holder removed: it stays in the Timeline.",
        },
        owner: {
            title: "Change owner",
            select: "New owner",
            none: "No owner",
            noOptions: "There is nobody else to give it to.",
            reason: "Reason · required",
            reasonPlaceholder: "For example: holidays, change of area, the Lead's request",
            reasonRequired: "Write the reason for the change.",
            history: "Past calls, notes and numbers stay under the name of who made them.",
            submit: "Change owner",
            changed: "Owner changed: it is now {name}.",
            removed: "Owner removed: the Lead now has no owner.",
        },
        tagsDialog: {
            title: "Lead tags",
            filter: "Search a tag",
            none: "No tags for «{q}».",
            empty: "There are no tags yet.",
            hint: "You pick among the tags that already exist.",
            filterOrCreate: "Search or create a tag",
            hintCreate: "Pick among the tags that already exist, or write the name of a new one.",
            create: "Create the tag «{name}»",
            created: "Tag «{name}» created and added: the change stays in the Timeline.",
            submit: "Save tags",
            saved: "Tags saved: the change stays in the Timeline.",
        },
        summary: {
            title: "Summary",
            lastCall: "Last call",
            lastCallTerm: "When, outcome, who",
            neverCalled: "Never called",
            inbound: "inbound",
            calls: "Calls",
            made: "Made",
            received: "Received",
            inCrm: "In the CRM",
            created: "Created",
            updated: "Last change",
            fromClose: "from Close",
            nextStep: "Next step",
        },
    },
    // «Call» and the call desk of the lead card, with the bar at the top when you change page (M4 plan, Task 13).
    callDesk: {
        title: "Call desk",
        callerLabel: "{name} is calling",
        ready: "Ready. Press Call: when the call ends, choose the outcome and what to do next, without leaving the card.",
        call: "Call",
        pickLabel: "Choose which number to call",
        pickMenu: "Which number to call",
        secondMobile: "Mobile of {name}",
        live: "On a call",
        timer: "Call duration",
        ringing: "Ringing",
        ending: "Ending the call…",
        closedEarly: "Ended early: less than 20 seconds of ringing. It does not count towards consecutive calls or the sequence.",
        hangupUnmeasured: "The closure cannot be verified. It does not count towards consecutive calls or the sequence.",
        closureUnconfirmed: "The end of the call is not confirmed yet. Try again shortly.",
        invalidNumber: "The provider reports an invalid number. Would you like to mark it «Wrong number»?",
        unreachableNumber: "The number cannot be reached. Check it: if it is wrong, you can mark it «Wrong number».",
        unreachableLabel: "Unreachable",
        markWrongNumber: "Mark Wrong number",
        numberLater: "Check later",
        ringDuration: "Ringing: {seconds} s",
        ringDurationUnknown: "Ringing: duration unavailable",
        earlyLabel: "Ended early, not counted",
        unmeasuredLabel: "Unverified closure, not counted",
        invalidNumberLabel: "Invalid number",
        hangUp: "End the call",
        leaveWarning: "A call is in progress: if you close the page, the call ends too.",
        outcomeLegend: "Call outcome · required",
        callAgainNow: "Call again now",
        answered: "Answered",
        noAnswer: "No answer",
        wrongNumber: "Wrong number",
        howDidItGo: "How did it go?",
        notesLabel: "Notes on this call",
        notesPlaceholder: "What they told you, what you promised…",
        reasonNoOutcome: "Choose the outcome first: without an outcome you cannot go on.",
        reasonNoAnswered: "Choose how the answered call went.",
        reasonNoNote: "With the outcome «Other» write a note: it is required.",
        reasonStatus: "The call lasted at least {minutes} minutes and the status is still «{status}»: choose one before closing.",
        close: "End the call",
        saving: "Saving the outcome…",
        retrying: "The server does not answer: I keep trying to save the outcome while the page stays open.",
        missingOutcome: "The outcome of the call at {time} is missing",
        afterOutcome: "After «{outcome}»",
        statusQuestion: "Do you want to change the status?",
        statusNow: "It is «{status}» now.",
        newStatus: "New status",
        saveStatus: "Save the status",
        statusesUnavailable: "The list of statuses did not load.",
        quickStatus: "Set «{status}»",
        searchSalon: "Search the target company on Google",
        searchHint: "Search the target company by name and city, check the number on its website or on Google Maps and look for a typo.",
        fixPhone: "Fix the number",
        barLabel: "Your call",
        barLive: "On a call with {name}",
        barBack: "Back to the card",
        barMissing: "Outcome missing: back to the card",
        barMissingCallback: "Choose when to call back: back to the card",
        barMissingStatus: "Status missing (call of at least {minutes} minutes): back to the card",
        barMissingStep: "A required step is missing: back to the card",
        barSaved: "Outcome saved: back to the card to end the call",
        barOtherCompany: "This call belongs to {company}: switch to that company to go back to the card.",
        barOtherCompanyUnknown: "This call belongs to another company: switch to that company to go back to the card.",
        busyCalling: "Call in progress.",
        busyOutcome: "Record the outcome of the call you just ended first.",
        dismiss: "Close the notice",
        microphone: "The browser does not let Gioia365 use the microphone, and without the microphone the call does not start. Click the padlock next to the address, allow the microphone for this site and try again.",
        load: "Gioia365 has been updated: reload the page to call.",
        reload: "Reload the page",
        notConnected: "The call did not start: try again.",
        callGone: "This call no longer exists, perhaps because the Lead was deleted: its outcome cannot be saved.",
        providerError: "The call stopped (code {code}): try again; if it keeps happening, report the code.",
        inCallMine: "You are already on the phone with this Lead, perhaps from another browser tab: end that call first.",
        reasons: {
            status_blocks: "The Lead's status blocks calls.",
            phone_wrong: "The number is marked wrong: fix it in the data and «Call» comes back.",
            no_phone: "No number to call: add it to the card.",
            telephony_off: "The company's telephony is not on: the Gioia365 Super admin turns it on.",
            no_caller_number: "You have no number to call with: ask whoever manages the numbers to give you a mobile, in Settings → Team.",
            in_call: "On a call with {name} now",
            reserved: "{name} is working on it now",
            no_feature: "Your role cannot call: whoever manages roles and permissions decides.",
            not_editable: "You can only view this Lead: to call it you need to be able to edit it.",
            commercial_view: "During «See as…» you cannot call: leave the view to call.",
            platform_context: "As the Gioia365 Super admin you do not call from here: calls are made with a membership of the company.",
        },
        // The microphone and speaker in the head of the call desk (product owner's request of 6 October 2026): proposals (question 216).
        audio: {
            title: "Microphone and speaker",
            button: "Microphone and speaker: {name}",
            microphone: "Microphone",
            output: "Speaker",
            systemDefault: "System default",
            systemDefaultNamed: "System default · {name}",
            unnamed: "Unnamed device {number}",
            needsPermission: "The browser shows the names of microphones and headsets only after permission to use the microphone.",
            allow: "Allow the microphone",
            denied: "The microphone did not turn on: check that it is connected and allowed from the padlock next to the address, then try again.",
            unsupported: "This browser does not let you choose the microphone: calls use the system one.",
            inputMissing: "The chosen headset is not connected: using the system microphone.",
            outputMissing: "The chosen speaker is not connected: using the system one.",
            builtIn: "You're using the computer's microphone: with a headset they'll hear you better.",
        },
    },
    dialer: {
        barLabel: "Power Dialer session",
        bar: "Power Dialer · {source} · Now: {lead} · done {done} · {remaining} left · Next: {next}",
        sourceSmartList: "Smart List «{name}»",
        sourceTasks: "Tasks «{view}»",
        sourceTasksWho: "Tasks «{view}» · {who}",
        nextNone: "end of the list",
        nextNoneTasks: "end of the Tasks",
        active: "Active",
        paused: "Paused",
        countdown: "The call to {lead} starts in {seconds} s",
        callNow: "Call now",
        queue: "Queue",
        pause: "Pause",
        resume: "Resume",
        skip: "Skip",
        interrupt: "Stop",
        interruptInCall: "First close the call in progress.",
        interruptBeforeOutcome: "First choose the outcome and do the required steps, then «Stop».",
        next: "Next lead",
        pausedReason: "Paused: press Resume to continue",
        pausedDone: "Paused: «Next lead» restarts from the next Lead, «Resume» stays on this one.",
        beforeNext: "First choose the outcome and do the required steps, then «Next lead».",
        allDone: "All done: move to the next lead with the button in the bar at the top.",
        passedNow: "This lead is skipped now: {reason}. Press «Next lead».",
        advancing: "Next Lead in {seconds}…",
        advancingAttempt: "Next Lead in {seconds}…: attempt {n} closes with {made} of {required}.",
        stayHere: "Stay on this Lead",
        noAnswerWaiting: "No answer: Gioia365 records «No answer».",
        chooseOutcome: "Choose the outcome",
        redialing: "Calling again in {seconds}… (call {n} of {required})",
        queueTitle: "The session queue",
        queueNow: "Now",
        queueNext: "Then, in this order",
        queueNone: "None: after this lead the list is finished.",
        queueNoneTasks: "None: after this lead the Tasks are finished.",
        queuePassed: "Skipped automatically",
        queueWorked: "Already done in this session",
        withReason: "{lead}: {reason}",
        queueResults: {
            called: "called",
            skipped: "skipped, {reason}",
            passed: "moved to the next one without calling",
        },
        skipTitle: "Skip this lead",
        skipLegend: "Why are you skipping it?",
        skipReasons: {
            asked_later: "asked to be called back later",
            data_to_verify: "data to check",
            colleague_follows: "a colleague already follows it",
            other: "another reason",
        },
        skipHint: "The reason stays in the Timeline. The lead does not come back in this session and stays in the list for next time.",
        skipHintTasks: "The reason stays in the Timeline. The lead does not come back in this session and its callback stays in the Tasks for next time.",
        skipGo: "Skip and move on",
        summaryTitle: "Session stopped",
        summaryFinishedTitle: "You finished the list",
        summaryFinishedTitleTasks: "You finished the calls",
        summaryOf: "Summary of the session on «{source}».",
        summaryFinished: "There are no other leads to call now in «{source}».",
        summaryOfTasks: "Summary of the session on {source}.",
        summaryFinishedTasks: "There are no other leads to call now in {source}.",
        summarySaved: "The session stays saved. Whenever you want, even another day, open the list and press «Resume calling»: it starts again from {next}.",
        summarySavedTasks: "The session stays saved. Whenever you want, even another day, open the Tasks and press «Resume calling»: it starts again from {next}.",
        summaryStats: {
            leadsCalled: "Leads called",
            calls: "Calls",
            answered: "Answered",
            minutes: "Minutes on the phone",
            skipped: "Skipped by you",
        },
        summarySkipped: "Skipped by you:",
        summaryPassedOver: "Skipped automatically, they could not be called:",
        summaryLeft: "{total} Leads remain in the list: {detail}.",
        summaryLeftOne: "1 Lead remains in the list: {detail}.",
        summaryLeftNone: "No other Leads remain in the list.",
        summaryLeftTasks: "{total} Leads remain in the Tasks: {detail}.",
        summaryLeftOneTasks: "1 Lead remains in the Tasks: {detail}.",
        summaryLeftNoneTasks: "No other Leads remain in the Tasks.",
        summaryToCall: "{count} to call",
        summaryToCallNone: "none to call",
        summaryAndPassed: "{toCall} and {count} skipped automatically for now",
        summaryAndPassedOne: "{toCall} and 1 skipped automatically for now",
        backToList: "Back to the list",
        continue: "Keep calling",
        passover: {
            status_blocks: "the status does not allow calling",
            in_call: "on the phone with {name}",
            reserved: "{name} is working on it",
            no_phone: "no number to call",
            phone_wrong: "the number is marked wrong",
            callback_later: "callback agreed at {time}",
        },
        restored: "Session in progress on {source}",
        backToLead: "Back to the card",
        leaveWithSession: "A calling session is in progress: it stays saved, you resume it from the list.",
        leaveWithSessionTasks: "A calling session is in progress: it stays saved, you resume it from the Tasks.",
        nextTitle: "Next lead",
        attemptPending: "Of attempt {n} you made {made} out of {required}. You decide",
        attemptPendingNote: "The missing call stays marked as skipped, with your name.",
        attemptPendingNoteMany: "The missing calls stay marked as skipped, with your name.",
        stay: "Stay on this card",
        openNext: "Open the next lead",
    },
    // The recording of a call in the Timeline and «Listen» (M4 plan, Task 12).
    recordings: {
        states: {
            available: "Ready to listen",
            processing: "Being prepared: ready in a few minutes",
            live: "Recording: you will find it here when the call ends",
            expired: "Audio expired: data and notes remain",
            manual: "No recording: call from a mobile phone, entered by hand",
            error: "Recording failed: the provider did not deliver it",
            none: "No answer: nothing to record",
            close: "No Close recording in Gioia365",
            closeCopying: "Close recording: to be copied into Gioia365",
            closeError: "Copy from Close failed",
            missing: "No recording: the call was not recorded",
        },
        notAllowed: "You do not have permission to listen to colleagues' recordings.",
        listen: "Listen",
        listenFor: "Listen · {duration}",
        loading: "Preparing the audio…",
        clock: "{position} / {duration}",
        pause: "Pause · {clock}",
        resume: "Resume · {clock}",
        again: "Listen again · {duration}",
        againShort: "Listen again",
        speed: "Listening speed",
        speeds: {
            normal: "1×",
            faster: "1.5×",
            fastest: "2×",
        },
        gone: "The recording is no longer available.",
        playFailed: "The audio could not be played: try again.",
    },
    leadArchive: {
        archive: "Archive",
        ask: "Archive the Lead? It leaves lists and Smart Lists; you restore it from Archived.",
        reason: "Reason (optional)",
        yes: "Yes, archive",
        no: "No",
        done: "Lead archived: it stays in the Timeline with your name and the time.",
        link: "Archived ({count})",
        title: "Archived",
        intro: "Archived Leads are not deleted: «Restore» puts them back in the lists as they were, with owner, status and Timeline. Only the company's Super admin can delete them forever.",
        caption: "Archived Leads: they do not appear in lists or Smart Lists",
        search: "Search archived Leads",
        columns: {
            pick: "Pick",
            lead: "Lead",
            who: "Who and when",
            why: "Why",
            actions: "Actions",
        },
        pickOne: "Pick {name}",
        ownerOf: "owner {name}",
        restore: "Restore",
        restorePicked: "Restore the selected ones",
        restored: "Restored: {names}. It is back in the lists with its owner, status and Timeline. The Timeline keeps who restored it.",
        restoredMany: "Restored: {names}. They are back in the lists with their owner, status and Timeline. The Timeline keeps who restored them.",
        restoreFailed: "{name}: not restored. {reason}",
        mergedInto: "Merged into «{name}» in Data cleanup",
        mergedIntoHidden: "Merged into another Lead in Data cleanup",
        mergedNoRestore: "A Lead merged into another one cannot be restored.",
        deletePicked: "Delete the selected ones forever",
        deleteOnlySuperAdmin: "Only the company's Super admin can delete a Lead forever.",
        deleteWarning: "Deleted forever, Leads never come back, not even their Timeline.",
        deleteAsk: "Delete the selected Leads ({count}) forever? They never come back. Type «elimina» to confirm.",
        deleteWord: "elimina",
        deleteYes: "Yes, delete forever",
        deleted: "Deleted forever: {names}. The deletion stays in the Activity log with your name.",
        deleteFailed: "{name}: not deleted. {reason}",
        mergedLeadsFirst: "{count} other Leads were merged into this one: delete those first, from Archived.",
        mergedLeadsFirstOne: "Another Lead was merged into this one: delete that one first, from Archived.",
        pickFirst: "Tick the Leads first.",
        empty: "No archived Leads.",
        emptySearch: "No archived Leads for «{q}».",
        more: "Show more",
        phoneOfArchived: "It belongs to an archived Lead: restore it from «Archived».",
        openArchived: "Open Archived",
    },
    bulkActions: {
        button: "Bulk actions",
        on: "Bulk actions on: tick the Leads in the table.",
        off: "Bulk actions closed.",
        selectedOne: "1 Lead selected",
        selectedMany: "{count} Leads selected",
        selectAll: "Select all {count} results",
        selectAllGli: "Select all {count} results",
        selectAllOne: "Select the only result",
        selectPage: "Select all the Leads shown",
        pickLead: "Select {name}",
        deselect: "Deselect",
        pickFirst: "Tick the Leads in the table, or «Select all».",
        waitList: "Wait for the new list: then only the Leads it shows stay ticked.",
        actions: {
            change_owner: "Change owner",
            change_status: "Change status",
            add_tag: "Add tag",
            remove_tag: "Remove tag",
            archive: "Archive",
        },
        summary: "It concerns {count} Leads: {names}.",
        summaryOne: "It concerns 1 Lead: {names}.",
        andOthers: "and {count} more",
        allResults: "It concerns all {count} Leads of the current view (search and filters included).",
        allResultsGli: "It concerns all {count} Leads of the current view (search and filters included).",
        allResultsOne: "It concerns the only Lead of the current view (search and filters included).",
        fixedNote: "The group of Leads is fixed now: it does not change if the filters change in the meantime. The operation stays in the Activity log with your name.",
        onlyEditable: "Only the Leads you can edit change: the others stay as they are.",
        newOwner: "New owner",
        noOwner: "No owner",
        reason: "Reason · required",
        reasonPlaceholder: "For example: holidays, change of area",
        reasonRequired: "Write the reason for the owner change.",
        newStatus: "New status",
        noStatuses: "There are no statuses to pick.",
        tagToAdd: "Tag to add",
        tagSearch: "Search or create a tag",
        tagNoMatch: "No tags for «{q}».",
        createTag: "Create the tag «{name}» and add it to {count} Leads",
        createTagOne: "Create the tag «{name}» and add it to 1 Lead",
        tagToRemove: "Tag to remove",
        tagCount: "{tag} · {count} of {total} have it",
        tagCountOne: "{tag} · 1 of {total} has it",
        noTags: "The selected Leads have no tags.",
        tagsAllResults: "With all the results you pick among all the company's tags: Leads without that tag stay as they are.",
        archiveNote: "The Leads disappear from lists and Smart Lists, but they are not deleted: you restore them from Archived.",
        confirm: {
            change_owner: "Assign {count} Leads",
            change_status: "Change the status of {count} Leads",
            add_tag: "Add the tag to {count} Leads",
            remove_tag: "Remove the tag from {count} Leads",
            archive: "Archive {count} Leads",
        },
        confirmOne: {
            change_owner: "Assign 1 Lead",
            change_status: "Change the status of 1 Lead",
            add_tag: "Add the tag to 1 Lead",
            remove_tag: "Remove the tag from 1 Lead",
            archive: "Archive 1 Lead",
        },
        done: "Done: {label} on {affected} Leads.",
        doneOne: "Done: {label} on 1 Lead.",
        doneUnchanged: " {unchanged} were already like that.",
        doneUnchangedOne: " 1 was already like that.",
        doneSkipped: " {skipped} could not be changed.",
        doneSkippedOne: " 1 could not be changed.",
        doneDifferent: "The group counted {candidates}, not {expected}: the list changed in the meantime.",
        doneLeftOut: "{count} Leads of the view were not touched: you cannot edit them, or they left the list in the meantime.",
        doneLeftOutOne: "1 Lead of the view was not touched: you cannot edit it, or it left the list in the meantime.",
        labels: {
            change_owner: "owner change",
            change_status: "status change",
            add_tag: "tag added",
            remove_tag: "tag removed",
            archive: "Leads archived",
        },
        tooLarge: "Too many Leads at once ({count}): narrow down with the filters, at most 5,000.",
        needsFeature: {
            change_owner: "Changing the owner of several Leads requires «Change the owner, with a reason».",
            tags: "Adding and removing tags requires «Create and change tags».",
            archive: "Archiving requires «Archive and restore Leads».",
        },
    },
    dataCleanup: {
        mergedNumbersNote: "Numbers of the other Lead: {numbers}",
        button: "Data cleanup",
        buttonCount: "Data cleanup ({count})",
        title: "Data cleanup",
        intro: "Gioia365 finds duplicates (same mobile or same email) and badly written phones or emails, and suggests how to fix them. It changes nothing on its own: every merge and every fix waits for your OK and stays in the Lead's Timeline.",
        tabsLabel: "What to check",
        tabs: {
            duplicates: "Duplicates ({count})",
            issues: "Phones and emails ({count})",
            duplicatesPlain: "Duplicates",
            issuesPlain: "Phones and emails",
        },
        samePhone: "Same mobile: {value}",
        sameEmail: "Same email: {value}",
        caption: "Where the values differ, choose which one to keep",
        columns: {
            field: "Field",
            stays: "Stays · last call {when}",
            staysNoCall: "Stays · came in on {when}",
            other: "Last call {when}",
            otherNoCall: "Never called · came in on {when}",
        },
        fields: {
            firstName: "First name",
            lastName: "Last name",
            salonName: "Target company name",
            mobile: "Mobile",
            landline: "Landline",
            email: "Email",
            city: "City",
            status: "Status",
            owner: "Owner",
        },
        empty: "empty",
        callsRow: "Calls",
        callsText: "{a} + {b}: they all stay, with the Timeline of both",
        tagsRow: "Tags",
        noTags: "none",
        ownerNeedsFeature: "Keeping the other Lead's owner requires «Change the owner, with a reason».",
        merge: "Merge into one Lead",
        notDuplicates: "Not duplicates",
        merged: "Merged: one Lead stays, «{name}», with all the calls and notes. The merge stays in the Timeline and the other one is among the archived.",
        mergedMoved: " From the other Lead: {items}.",
        movedCalls: "{count} calls",
        movedCallsOne: "1 call",
        movedNotes: "{count} notes",
        movedNotesOne: "1 note",
        dismissed: "Marked as different Leads: I won't suggest them together again.",
        noDuplicates: "No duplicates: every mobile and every email appears only once.",
        conflict: "One of the two Leads changed in the meantime: check the values again and retry.",
        valueRefused: "The card no longer accepts the other Lead's «{field}» value: keep the one of the Lead that stays, or correct it on the other Lead's card.",
        more: "Show more",
        issuesCaption: "Phones and emails to fix",
        issueColumns: {
            lead: "Lead",
            field: "Field",
            now: "Now",
            problem: "Problem",
            proposal: "Suggestion",
            actions: "Actions",
        },
        issueFields: {
            mobile: "Mobile",
            landline: "Landline",
            secondMobile: "Second holder's mobile",
            email: "Email",
            secondHolderEmail: "Second holder's email",
        },
        problems: {
            landline_in_mobile_slot: "A landline in the mobile slot",
            mobile_in_landline_slot: "A mobile in the landline slot",
            raw_now_valid: "A number to check that now reads correctly",
            length_out_of_range: "Number too short or too long",
            case_or_spaces: "Capitals or spaces",
            domain_typo: "Misspelt domain",
            invalid: "Does not look like an email",
        },
        moveTo: "Move to «{slot}» as {value}",
        verify: "To check with the Lead",
        fix: "Fix",
        fixAll: "Fix all suggestions ({count})",
        fixAllConfirm: "Confirm: fix {count}",
        fixAllWarning: "Check the list: the fixes stay in each Lead's Timeline.",
        keep: "Keep as is",
        kept: "Left as it is: I won't flag it again.",
        fixed: "Fixed: {field} of {name}. It stays in the Lead's Timeline.",
        fixedMany: "Fixed {count} values. Each fix stays in its Lead's Timeline.",
        fixedSkipped: " {count} could not be fixed: the list is up to date.",
        fixedSkippedOne: " 1 could not be fixed: the list is up to date.",
        noIssues: "All phones and emails are in order.",
        openLead: "Open the Lead",
    },
    leadFields: {
        about: {
            title: "What it is for",
            text: "It decides how the Lead card looks across {organization}: the sections and their order, which fields are there and which are shown, and the company fields, with their type and, for the choice fields, their options.",
            whyTitle: "Why it is in the Settings",
            why: "The company fields are its qualification questions: they tell whether a company is in target and end up in filters, columns and Reports. Another company will have different ones. The Super admin and the Admin change them, and every publication is recorded.",
        },
        readOnly: "You can only view them: the Super admin and the Admin of {organization} change them.",
        readOnlyPlatform: "These are the rules of {organization}: its Super admin or its Admin change them, not the Gioia365 Super admin.",
        version: "Published version: {version}.",
        section: {
            up: "Move the section «{section}» up",
            down: "Move the section «{section}» down",
            visible: "On the card",
            visibleNamed: "Section «{section}» on the card",
            locked: "Always shown: at least one phone is needed, the mobile or the landline.",
            caption: "Fields of the section «{section}»",
            empty: "No fields in this section.",
        },
        table: {
            order: "Order",
            field: "Field",
            type: "Type",
            options: "Options",
            visible: "On the card",
            more: "More actions",
        },
        field: {
            up: "Move up: {field}",
            down: "Move down: {field}",
            name: "Field name: {field}",
            system: "Gioia365 field",
            fromCity: "Gioia365 field: it comes from the city, it is not typed",
            mobile: "Gioia365 field: this or the landline is enough",
            landline: "Gioia365 field: this or the mobile is enough",
            secondHolder: "first name, last name, mobile and email of the second holder: they appear on the card only when a second holder is added",
            usedBy: "{count} Leads with a value",
            usedByOne: "1 Lead with a value",
            unused: "no Lead with a value",
            isNew: "new, not saved yet",
            visible: "On the card",
            visibleNamed: "On the card: {field}",
            always: "Always",
            typeLabel: "Type of «{field}»",
            typeLocked: "cannot change: there are values",
            sectionLabel: "Section of «{field}»",
            archive: "Archive",
            archiveNamed: "Archive «{field}»",
            removeNew: "Remove",
            removeNewNamed: "Remove the new field «{field}»",
        },
        types: {
            number: "Number",
            currency_eur: "Euro",
            choice: "Choice from a list",
            text: "Text",
        },
        typesInText: {
            number: "number",
            currency_eur: "euro",
            choice: "choice from a list",
            text: "text",
        },
        option: {
            name: "Option «{option}» of «{field}»",
            selectable: "Can be chosen",
            selectableNamed: "«{option}» of «{field}» can be chosen",
            hidden: "hidden",
            remove: "Remove the option «{option}»",
            newLabel: "New option for «{field}»",
            add: "Add",
            addNamed: "Add the option to «{field}»",
            none: "No options.",
        },
        add: "New field",
        notes: {
            type: "The type of a field changes only while no Lead has a value in it, counting archived Leads and Leads merged into another too: afterwards it would spoil the data already written.",
            options: "An option chosen by a Lead is not removed: it is hidden, and it stays on the Leads that have it.",
            hidden: "A hidden or archived field does not delete any data: the values of the Leads stay saved. An archived field leaves the card.",
            phones: "Mobile and Landline are always on the card, with their section: a Lead needs at least one phone, the mobile or the landline, and the card must be able to show the one it has.",
        },
        archived: {
            title: "Archived fields",
            text: "They are off the card, and the values the Leads had stay saved.",
            item: "{field} · {usedBy}",
            pending: "archived when you save",
        },
        outside: {
            title: "Fields off the card",
            text: "They exist, but the card does not show them.",
            sectionLabel: "Put «{field}» in the section",
            choose: "Choose the section",
        },
        create: {
            title: "New field",
            name: "Field name",
            type: "Type",
            typeHint: "The type is chosen now: afterwards it changes only while no Lead has a value.",
            section: "Section",
            options: "Options, one per line",
            optionsHint: "For example: None, Paper diary, Excel. More options can be added later too.",
            cancel: "Cancel",
            submit: "Add the field",
            errors: {
                name: "Write the name of the field.",
                nameTaken: "There is already a field with this name.",
                options: "Write at least one option, one per line.",
                optionsRepeated: "Two options have the same name.",
                tooManyOptions: "At most {max} options.",
                optionTooLong: "Each option has at most {max} characters.",
            },
        },
        changes: {
            sectionOrder: "The order of the sections becomes: {order}.",
            sectionHidden: "The section «{section}» is no longer shown on the card: the data stays.",
            sectionShown: "The section «{section}» is back on the card.",
            fieldOrder: "The order of the fields in «{section}» changes.",
            created: "New field «{field}» ({type}) in the section «{section}».",
            createdChoice: "New field «{field}» ({type}: {options}) in the section «{section}».",
            renamed: "«{before}» is now called «{after}».",
            retyped: "«{field}» becomes a {type} field.",
            retypedDropsOptions: "«{field}» becomes a {type} field: its options go away.",
            optionAdded: "«{field}»: new option «{option}».",
            optionRenamed: "«{field}»: the option «{before}» is now called «{after}».",
            optionHidden: "«{field}»: the option «{option}» can no longer be chosen, and it stays on the Leads that have it.",
            optionShown: "«{field}»: the option «{option}» can be chosen again.",
            movedTo: "«{field}» moves to the section «{section}».",
            fieldHidden: "«{field}» is no longer shown on the card: the data stays.",
            fieldShown: "«{field}» is back on the card.",
            enteredHidden: "«{field}» joins the card hidden: it does not show until it is back «On the card».",
            archived: "«{field}» is archived: it leaves the card and the values of the Leads stay saved.",
        },
        problems: {
            noName: "Every field needs a name.",
            sameName: "Two fields are called «{field}»: give each one a different name.",
            noOptions: "The choice field «{field}» needs at least one option.",
            noOptionName: "Every option of «{field}» needs a name.",
            sameOption: "Two options of «{field}» are called «{option}».",
        },
        saved: "Published: the Lead card changes for the whole company.",
        conflict: "Someone else published the card fields while you were changing them. The page now starts from the new version, with your changes on top: check them and save again.",
        errors: {
            typeInUse: "The type of «{field}» stays {type}: {count} Leads have a value in that field, counting archived and merged ones too.",
            typeInUseOne: "The type of «{field}» stays {type}: 1 Lead has a value in that field, counting archived and merged ones too.",
        },
    },
    leadVisibility: {
        about: {
            title: "What it is for",
            text: "It decides which Leads a Salesperson sees, that is whoever uses Gioia365 with the User role or a role copied from it: all the Leads of {organization}, or only the ones entrusted to them, of which they are the owner.",
            whyTitle: "Why it is in the Settings",
            why: "The owner is the person the Lead is entrusted to, and stays so even when a colleague calls it. Whoever leads the team (Super user, Admin and Super admin) always sees all the Leads. The Super admin and the Admin make the choice.",
        },
        readOnly: "You can only view it: the Super admin and the Admin of {organization} choose it.",
        readOnlyPlatform: "This is a rule of {organization}: its Super admin or its Admin choose it, not the Gioia365 Super admin.",
        title: "The Leads a Salesperson sees",
        legend: "Who sees the Leads",
        all: "All the company's Leads: everyone sees, calls and updates the Leads entrusted to colleagues too, which stay theirs",
        own: "Only their own: everyone sees the Leads they are the owner of",
        appliesTo: "It applies to the User and to the roles copied from it: whoever leads the team always sees all the Leads.",
        note: "It applies to the whole company: in the Lead list, in the Smart Lists and in the Tasks. In «Roles and permissions» the row «Leads → View» of these roles follows this choice.",
        mixed: "Today the Salespeople do not all see the same way: a role was changed in «Roles and permissions», or a role sees no Lead. Choose one of the two and save to align them; a role that sees no Lead stays as it is.",
        stillMixed: "Saved. A role that sees no Lead stayed as it was, so this still says «mixed».",
        saved: "Saved: it applies to the whole company from the next page that opens.",
        changes: {
            all: "The Salespeople see all the company's Leads, also the ones entrusted to colleagues.",
            own: "Each Salesperson sees only the Leads they are the owner of.",
        },
    },
    // The “Call sequence” section of the lead card (M5 plan, Task 12): a plain translation of the Italian words.
    callSequence: {
        title: "Call sequence",
        lineAttempt: "Sequence: attempt {n} of {total} · {judged}",
        lineWithVerdict: "{line} · {verdict}",
        judgedNew: "New lead",
        judgedStarted: "just started",
        judgedRestarted: "restarted from the beginning",
        respected: "followed ✓",
        violated: "not followed: {reason}",
        endAnswered: "Sequence: ended at attempt {n} · the lead answered",
        endStopped: "Sequence: stopped by hand",
        endWhatsapp: "Sequence: ended · the lead answered on WhatsApp",
        endCalledBack: "Sequence: ended · the lead called back",
        endManualOther: "Sequence: ended · the lead answered",
        endBlocked: "Sequence: stopped at attempt {n} · {reason}",
        endArchived: "Sequence: ended · lead archived",
        endMerged: "Sequence: ended · merged into a duplicate",
        endExhausted: "Sequence: ended, {total} attempts without an answer",
        endWords: {
            booked: "appointment booked",
            answered: "the lead answered",
            answered_callback: "the lead called back",
            answered_whatsapp: "the lead answered on WhatsApp",
            answered_manually: "the lead answered",
            wrong_number: "wrong number",
            blocked_status: "calls blocked",
            exhausted: "every attempt without an answer",
            stopped_manually: "stopped by hand",
            archived: "lead archived",
            merged: "merged into a duplicate",
        },
        legendLabel: "Call legend",
        legend: { due: "To do", now: "Now", done: "Done", answered: "Answered", not_needed: "No longer needed", not_made: "Skipped", stopped: "Stopped with a reason" },
        attempt: "Attempt {n}",
        attemptNow: "Attempt {n} · now",
        box: "Call {number} · attempt {attempt}: {state}",
        boxAt: "Call {number} · attempt {attempt}: {state}, {at}",
        stop: "Stop the sequence",
        stopAsk: "Stop the sequence?",
        stopYes: "Yes, stop it",
        stopNo: "No",
        restart: "Restart the sequence",
        answered: "The lead answered",
        answeredAsk: "How did the lead answer?",
        answeredHow: { whatsapp: "On WhatsApp", called_back: "Called back", other: "Some other way" },
        answeredHowWords: { whatsapp: "on WhatsApp", called_back: "called back", other: "some other way" },
        reasons: {
            first_call_late: "first call late, after {duration}",
            first_call_late_after_opening: "first call late, {duration} after opening at {time}",
            first_call_missing: "first call late: no call after {duration}",
            first_call_missing_since: "first call late: no call since {halfDay}",
            half_day_missed: "{halfDay} no attempt",
            attempt_short: "at attempt {n} {calls} of {required}",
        },
        callsWord: { none: "no calls", one: "one call", many: "{count} calls" },
        halfDay: { morning: "morning", afternoon: "afternoon" },
        halfDayWords: "{day} {halfDay}",
        duration: { minute: "1 minute", minutes: "{count} minutes", hour: "an hour", hours: "{count} hours", withMinutes: "{hours} and {minutes}" },
        nextStepAttempt: "Sequence call · attempt {n} of {total} · {when}",
        nextStepCallback: "Callback · {when}",
        whenNow: "now",
        seeInTimeline: "See in the Timeline",
    },
    // Settings → “Call sequence” (M5 plan, Task 13): a plain translation of the Italian words.
    callbacks: {
        title: "Call back later",
        agreed: "Agreed with the Lead",
        agreedHint: "Tick it if you decided the time together: the callback gets the clock and a notice appears at that time.",
        soon: "In a few hours",
        days: "In the next days",
        custom: "Another day and time",
        customDay: "Day",
        customTime: "Time",
        save: "Set the callback",
        step: "Choose when to call back",
        stepOpen: "Choose the time",
        stepDone: "Callback set for {when}",
        later: "Call back later",
        headerButton: "Callback",
        exists: "There is already a callback for {when}: move it?",
        existsNoMove: "There is already a callback for {when}.",
        move: "Move",
        saved: "Callback set for {when}.",
        preset: { minutes: "+{minutes} min", hours: "+{hours} h", hoursHalf: "+{hours} h 30" },
        otherDay: "{weekday} {time}",
        weekdayShort: { "1": "Mon", "2": "Tue", "3": "Wed", "4": "Thu", "5": "Fri", "6": "Sat", "7": "Sun" },
        tomorrow: "Tomorrow, {weekday} {date}",
        dayTitle: "{weekday} {date}",
        invalid: {
            past: "That time has already passed.",
            closed_day: "The company is closed that day.",
            outside_hours: "Callbacks are set between {from} and {to}.",
            not_quarter: "Choose a time on the quarter hour.",
            too_far: "Too far ahead: choose a nearer day.",
        },
    },
    manualCall: {
        button: "Log activity",
        title: "Call made outside the CRM",
        intro: "A call made from a mobile or another phone: it stays marked as entered by hand, with your name.",
        day: "Day",
        time: "Time",
        minutes: "Minutes of conversation",
        phone: "Number called",
        save: "Log",
        saved: "Call logged: you will find it in the Timeline, entered by hand.",
        minutesInvalid: "Enter the minutes of conversation, from 0 to 240.",
        invalid: { future: "The time is in the future.", before_lead: "The Lead did not exist yet." },
    },
    tasks: {
        title: "Things to do",
        todayCount: "{count} today",
        views: { today: "Today", overdue: "Overdue", upcoming: "Next days", done: "Done" },
        viewsLabel: "Which tasks",
        columns: {
            when: "When",
            what: "What",
            lead: "Lead",
            city: "City",
            status: "Status",
            latestCall: "Latest call",
            assignee: "Assigned to",
            owner: "Owner",
            action: "Action",
        },
        whatCallback: "Callback · {when}",
        agreed: "agreed",
        overdue: "overdue",
        priorityHigh: "High priority",
        who: "Whose",
        wholeTeam: "Whole team",
        kind: "What",
        kinds: { all: "Everything", calls: "Phone calls" },
        sort: "Sort",
        sorts: { due: "As they should be done", priority: "Priority", lead: "Lead from A to Z", status: "Status" },
        call: "Call",
        open: "Open",
        backToTasks: "Back to Tasks",
        start: {
            otherSession: "You have a calling session in progress on {source}: interrupt it to call from here?",
            from: "You call {count} calls in a row, starting from {lead}.",
            fromOne: "You call 1 call, starting from {lead}.",
            offView: "Calling in a row starts from «Today» or «Overdue».",
            offEmpty: "No calls to make right now.",
            teamWarning: "You would also call your colleagues' Tasks.",
            position: "Place {position} in the call order",
        },
        doneNow: "Done just now",
        doneAt: "{when} · {outcome}",
        empty: {
            today: "Nothing to do today.",
            overdue: "No overdue tasks.",
            upcoming: "No tasks in the next days.",
            done: "No tasks done.",
        },
        emptyHint: "Callbacks are set from the call desk with «Call back later» or from the card with «Callback».",
        onlyManual: "Only the things taken on by hand are here: the sequence calls are made from the Smart Lists.",
        more: "Show more",
        banner: {
            title: "It's {time}: callback with {lead}",
            text: "{salon}, set for {time}. You agreed on it together: the banner stays until you call.",
            textNoSalon: "Set for {time}. You agreed on it together: the banner stays until you call.",
            call: "Call now",
            open: "Open Tasks",
            label: "Agreed callbacks whose time has come",
            announce: "Time for the agreed callback with {lead}, set for {time}.",
        },
    },
    conversations: {
        title: "Conversations",
        intro: "Phone calls, with the recording to listen to and the notes, WhatsApp messages and emails. They are the same events as in each Lead's Timeline.",
        tabsLabel: "What to see",
        calls: "Phone calls",
        whatsappTab: "WhatsApp",
        emailTab: "Email",
        periodLabel: "Period",
        periods: { today: "Today", yesterday: "Yesterday", last7: "Week", last30: "Month", custom: "Custom", all: "All" },
        fromDay: "From",
        toDay: "To",
        periodDays: "From {from} to {to}",
        periodDay: "On {day}",
        who: "Whose",
        wholeTeam: "Whole team",
        direction: "Direction",
        all: "All",
        outbound: "Outgoing",
        inbound: "Incoming",
        outcome: "Outcome",
        anyone: "All",
        ownerThen: "Owner at the time",
        recording: "Recording",
        recordingFilters: {
            available: "Ready to listen",
            processing: "Being prepared",
            expired: "Audio expired",
            missing: "No recording",
            error: "Recording failed",
            none: "No answer",
        },
        audioOnly: "Only playable audio",
        search: "Search for a Lead or a target company",
        caption: "The calls of the period, most recent first",
        columns: {
            when: "When",
            lead: "Lead",
            direction: "Direction",
            outcome: "Outcome",
            duration: "Duration",
            caller: "Who called",
            ownerThen: "Owner at the time",
            recording: "Recording",
            action: "Action",
        },
        manual: "entered by hand",
        liveDuration: "in progress",
        ownerToday: "today: {name}",
        notesOne: "1 note",
        notesMany: "{count} notes",
        listen: "Listen",
        open: "Open",
        closeRow: "Close",
        notesTitle: "Notes on the call",
        noNotes: "No notes.",
        addNote: "Add a note",
        saveNote: "Save the note",
        savingNote: "Saving the note…",
        noteRequired: "Write the note before saving it.",
        noteSaved: "Note saved: you will see it in the Lead's Timeline too.",
        openLead: "Open the Lead",
        noteHint: "A saved note cannot be changed or deleted: it stays with your name and the time, in the Lead's Timeline too.",
        manualHint: "Call entered by hand after making it from a mobile phone: it counts in the numbers and stays recognisable.",
        expiresAt: "The audio stays until {when}: then the call and the notes remain.",
        notesReadOnly: "You can read the notes, but adding one requires being able to edit the Lead.",
        leadOutOfSight: "This Lead is now outside the Leads you see: you cannot open it or add notes to it.",
        empty: "No phone calls with these filters.",
        emptyHint: "Change the period or the filters, or untick «Only playable audio».",
        more: "Show more phone calls",
        whatsapp: {
            unreadOnly: "Unread only",
            caption: "The WhatsApp messages of the period, most recent first",
            note: "Leads' replies arrive here only with the official WhatsApp. With WhatsApp Agile and with the manual way the replies stay on the salesperson's WhatsApp.",
            columns: {
                when: "When",
                lead: "Lead",
                what: "What",
                message: "Message",
                channel: "Which WhatsApp",
                state: "State",
                person: "Whose",
                action: "Action",
            },
            outbound: "Sent",
            prepared: "Prepared",
            quoted: "«{text}»",
            template: "Template «{name}»",
            channels: { meta: "Official WhatsApp", agile: "WhatsApp Agile", manual: "By hand" },
            declaredBy: "Declared sent by {name}",
            unknownNumber: "Number not in Gioia365",
            reply: "Reply",
            markAll: "Mark all as read ({count})",
            markAllUnknown: "Mark all as read",
            markAllHint: "The ones to read that you see here, with these filters.",
            markedAll: "WhatsApp messages marked as read.",
            empty: "No WhatsApp messages with these filters.",
            emptyHint: "Change the period.",
            more: "Show more WhatsApp messages",
            unreadOne: "1 WhatsApp message to read",
            unreadMany: "{count} WhatsApp messages to read",
        },
        email: {
            caption: "The email events of the period, the most recent first",
            note: "GoHighLevel sends the emails: deliveries, opens, clicks, bounces, spam reports, unsubscriptions and replies arrive here. An open can be the automatic preview of an email program.",
            columns: { when: "When", lead: "Lead", event: "Event", subject: "Subject" },
            quoted: "“{text}”",
            link: "Link:",
            empty: "No email events with these filters.",
            emptyHint: "Change the period.",
            more: "Show more email events",
        },
    },
    whatsapp: {
        dayAndTime: "{weekday} {date} at {time}",
        stopConfirmation: "Done: you will not receive any more messages from {organization}.",
        button: "WhatsApp",
        reasons: {
            do_not_contact: "WhatsApp blocked: status «{status}».",
            wrong_number: "WhatsApp stopped: the number is wrong. Fix the mobile to write to the Lead.",
            no_mobile: "WhatsApp stopped: the Lead has no mobile. Add it in the details to write to them.",
            whatsapp_opt_out: "Do not send WhatsApp is on: the Lead asked not to receive messages. Calls remain possible.",
            no_feature: "Your role cannot send WhatsApp messages: whoever manages roles and permissions decides.",
            not_editable: "You can only view this Lead: to write to them you need to be able to edit it.",
            commercial_view: "During «See as…» no WhatsApp messages are sent: leave the view to write.",
            platform_context: "As the Gioia365 Super admin you do not write from here: messages are written with a membership of the company.",
            invalid_number: "The Lead's mobile is not an international number: fix it in the details to write to them.",
            outside_service_window: "More than 24 hours have passed since their last message: Meta only allows an approved template.",
        },
        dialog: {
            title: "WhatsApp to {names}",
            twoNames: "{first} or {second}",
            to: "Who you are writing to",
            recipient: "{name} · {number}",
            template: "Template · the Super admin writes the texts in Settings",
            preview: "Preview",
            text: "Message · you can touch it up before sending it",
            empty: "The message is empty: write something before sending it.",
            missing: "Complete the message before opening WhatsApp: this Lead has no value for {fields}.",
            tooLong: "The message is too long: at most {max} characters, with the line at the bottom.",
            manualNote: "The button opens WhatsApp Desktop on the Lead's chat, with the message already written: you send it yourself, by pressing Enter.",
            open: "Open WhatsApp",
            sentQuestion: "Did you send the message?",
            sentHint: "The CRM cannot see what happens inside WhatsApp: it records the sending only if you confirm it.",
            preparing: "Recording the prepared message…",
            reopen: "Reopen WhatsApp",
            otherText: "The recorded text differs from the one opened in WhatsApp: press «Reopen WhatsApp» and send the recorded one.",
            notSent: "No, I did not send it",
            sent: "Yes, sent",
            sentDone: "Recorded: WhatsApp declared sent.",
            notSentDone: "No sending recorded: only «WhatsApp prepared» remains.",
            send: "Send the WhatsApp",
            officialNote: "It leaves from the official WhatsApp, from your number {number}, with the template approved by Meta.",
            sending: "Sending the message to Meta… Wait for the answer before closing the window.",
            sentToMeta: "Accepted by Meta: you can follow it in the Timeline.",
            sentToMetaCap: "Accepted by Meta: you can follow it in the Timeline. Today the Lead had already received {cap} WhatsApp messages or more.",
            metaRefused: "Meta did not accept the message: the reason is in the Timeline. You can send it by hand with «Open WhatsApp».",
            dailyCap: "Today the Lead has already received {count} WhatsApp messages: at most {cap} a day to the same person, so the number does not get blocked. You can send it anyway.",
            agileNote: "It leaves by itself with WhatsApp Agile from your number {number}.",
            sendingAgile: "Sending the message to WhatsApp Agile… Wait for the answer before closing the window.",
            sentToAgile: "Accepted by WhatsApp Agile: you will find it in the Timeline.",
            queuedAtAgile: "On its way with WhatsApp Agile: you will find the outcome in the Timeline.",
            agileRefused: "WhatsApp Agile did not accept the message, or did not answer: the reason is in the Timeline. Before sending it by hand with «Open WhatsApp», check there that it did not leave.",
            missingSend: "Complete the message before sending it: there is no value for {fields} for this Lead.",
            fallback: {
                senderNotReadyMeta: "Your number is not registered on the official WhatsApp yet: for now it opens in WhatsApp Desktop.",
                senderNotReadyAgile: "Your WhatsApp Agile is not connected: for now it opens in WhatsApp Desktop.",
                channelDisabledMeta: "Your company no longer uses the official WhatsApp: for now it opens in WhatsApp Desktop.",
                channelDisabledAgile: "Your company no longer uses WhatsApp Agile: for now it opens in WhatsApp Desktop.",
                templateNotApproved: "The «{template}» template is not approved by Meta yet ({status}): for now it opens in WhatsApp Desktop.",
                missingValues: "The «{template}» template has a field with no value for this Lead: complete it in the message, for now it opens in WhatsApp Desktop.",
                notReady: "The official WhatsApp is not ready: by hand for now.",
                recipientNotAllowed: "Number not allowed in the test company: the automatic WhatsApp does not go out, for now it opens in WhatsApp Desktop.",
                dailyCap: "This Lead already received the {cap} WhatsApp messages of the day: with WhatsApp Agile the next one does not go out, for now it opens in WhatsApp Desktop.",
                dailyCapCount: "Today the Lead has already received {count} WhatsApp messages: with WhatsApp Agile at most {cap} a day, so this one does not go out. For now it opens in WhatsApp Desktop.",
                paced: "A WhatsApp Agile message left your number less than 8 minutes ago: for now it opens in WhatsApp Desktop.",
                pacedAt: "A WhatsApp Agile message left your number less than 8 minutes ago: the next one can leave at {time}. For now it opens in WhatsApp Desktop.",
                channelDown: "Your WhatsApp Agile is not delivering: it needs to be connected again with the QR code. For now it opens in WhatsApp Desktop.",
                providerUnreachable: "WhatsApp Agile is not answering right now: for now it opens in WhatsApp Desktop.",
            },
            metaStatus: {
                none: "to send",
                pending: "in review",
                rejected: "rejected",
                paused: "paused",
                disabled: "switched off",
            },
        },
        step: {
            question: "Send the WhatsApp «{template}» · optional",
            questionAny: "Send a WhatsApp · optional",
            open: "Send WhatsApp",
        },
        optOut: {
            row: "WhatsApp",
            label: "Do not send WhatsApp",
            switchedOn: "Done: no more WhatsApp messages go to this Lead, with any of the three ways.",
            switchedOff: "Off: the Lead receives WhatsApp messages again.",
            onlyManagers: "A Super user, an Admin or the Super admin switches it off, when the Lead asks for messages again.",
            onlyEditors: "Whoever can edit this Lead switches it on.",
            since: "On since {when}.",
            sinceBy: "Switched on by {name} on {when}.",
        },
        reply: {
            title: "Reply on WhatsApp",
            to: "To {link}, from the official WhatsApp of {person}.",
            toManual: "To {link}, from your WhatsApp.",
            wrote: "The Lead wrote on {when}: «{text}»",
            wroteKind: "{kind} ({when})",
            text: "Your reply",
            withinWindow: "They wrote in the last 24 hours: you can reply in your own words.",
            template: "Template approved by Meta",
            send: "Send",
            required: "Write the reply before sending it.",
            noApproved: "More than 24 hours have passed since their last message and no template is approved by Meta yet: for now it opens in WhatsApp Desktop.",
            numberGone: "Gioia365 no longer has the number that received the message: for now it opens in WhatsApp Desktop.",
            numberNotReady: "The number of {person} is not ready on the official WhatsApp: for now it opens in WhatsApp Desktop.",
            numberOff: "The number of {person} is no longer on the official WhatsApp: for now it opens in WhatsApp Desktop.",
            phoneGone: "The Lead wrote from a number that is no longer in their card: write to them from the Lead's card.",
        },
    },
    callSequenceSettings: {
        title: "Call sequence",
        about: "What it is for",
        aboutText: "How many calls in a row to make to a Lead who does not answer, in which half-days, and within how many minutes to make the first one: Gioia365 does not force the Salesperson, but shows whether the rule was respected.",
        readOnly: "You can only view it: the Super admin of {organization} changes it.",
        readOnlyPlatform: "This is a rule of {organization}: its Super admin changes it, not the Gioia365 Super admin.",
        attempts: "The attempts",
        attempt: "Attempt",
        attemptNumber: "Attempt {n}",
        calls: "Calls in a row",
        callsOf: "Calls in a row in attempt {n}",
        callsOne: "1 call",
        callsMany: "{count} calls",
        when: "When",
        whenFirst: "Within {minutes} minutes of the Lead coming in",
        whenNext: "The next working half-day",
        remove: "Remove",
        addAttempt: "+ Add an attempt",
        removeLast: "Remove the last attempt",
        total: "{calls} calls in {days} working days",
        totalOneDay: "{calls} calls in 1 working day",
        totalOne: "1 call in 1 working day",
        example: "A Lead coming in now",
        exampleRow: "Attempt {n}: {day} {halfDay}",
        exampleFirst: "Attempt 1: {day} {halfDay}, first call by {time}",
        exampleDay: "{weekday} {date}",
        weekday: { "1": "Monday", "2": "Tuesday", "3": "Wednesday", "4": "Thursday", "5": "Friday", "6": "Saturday", "7": "Sunday" },
        halfDay: { morning: "morning", afternoon: "afternoon" },
        halves: "The half-days",
        morningEnd: "The morning ends at",
        afternoonStart: "The afternoon starts at",
        fridayOne: "On Friday a single attempt, in the morning",
        halvesNote: "The start and the end of the day come from “Calendar, time zone and language”. Between morning and afternoon no call of the sequence starts.",
        firstCall: "The first call",
        firstCallMinutes: "within {minutes} minutes",
        cascade: "In the cascade, before each call",
        cascadeAfter: "In the cascade, after each call",
        countdown: "Wait",
        countdownNone: "nothing, call right away",
        countdownSeconds: "{seconds} seconds",
        countdownHint: "During those seconds the Salesperson looks at the card and can skip the Lead before the phone rings.",
        advance: "After the call, move on to the next Lead",
        advanceHint: "The countdown starts with «End the call», after the required steps. «Stay on this Lead» in the bar stops it.",
        advanceNow: "Right away",
        advanceSeconds: "After {seconds} seconds",
        advanceManual: "I move on myself",
        autoRedial: "If nobody answers, call again by itself up to the attempt's calls in a row",
        autoRedialHint: "A call nobody answers (rings out or busy) is recorded by Gioia365 as «No answer» and the same Lead is called again after the seconds before the call, until the attempt has its calls in a row. «Next lead» moves on earlier.",
        restart: "Without contact, the sequence starts over after",
        restartDays: "{days} working days",
        restartNever: "Never",
        restartHint: "Applies to sequences that ended without an answer after all the attempts: working days of the company calendar count, closures excluded.",
        saved: "Rule saved: it applies to the sequences that start from now on.",
        conflict: "Meanwhile someone changed the company settings: the page now starts from the saved rule, with your changes on top. Check them and save again.",
        problems: {
            afternoonBeforeMorning: "The afternoon must start when the morning ends, or later.",
            dayInsidePause: "The whole working time on {day} ({start}–{end}) falls in the pause between morning and afternoon: move the end of the morning or the start of the afternoon.",
        },
        changes: {
            attempts: "The attempts go from {before} to {after}.",
            newAttempt: "New attempt {n}: {calls}, the next half-day.",
            attemptCalls: "Attempt {n}: {after} calls in a row instead of {before}.",
            morningEnd: "The morning ends at {after} instead of {before}.",
            afternoonStart: "The afternoon starts at {after} instead of {before}.",
            firstCall: "The first call must be made within {after} minutes of the Lead coming in, instead of {before}.",
            fridayOneOn: "On Friday the sequence has a single attempt, in the morning.",
            fridayOneOff: "On Friday the sequence has two attempts, morning and afternoon, like the other days.",
            countdown: "In the cascade, before each call: {after} instead of {before}.",
            countdownNone: "no wait",
            advance: "After the call, the next Lead: {after} instead of {before}.",
            advanceNow: "right away",
            advanceSeconds: "after {seconds} seconds",
            advanceManual: "“I move on myself”",
            autoRedial: "If nobody answers, call again by itself: {after} instead of {before}.",
            yes: "yes",
            no: "no",
            restart: "Without contact, it starts over after: {after} instead of {before}.",
            restartDays: "{days} working days",
            restartNever: "“never”",
        },
    },
    whatsappSendingSettings: {
        title: "How WhatsApps are sent",
        about: "What it is for",
        aboutText: "Here you decide, for each salesperson, which WhatsApp they use and which number their messages leave from. There are three options: the official WhatsApp from Meta, the recommended one; WhatsApp Agile, as in GioiaFlow; or by hand, from WhatsApp Desktop.",
        whoDecidesTitle: "Who decides",
        whoDecides: "The company Super admin or the Gioia365 Super admin, who also sets up the WhatsApp for the salesperson: salespeople do not need to connect anything. Every change stays in the Activity log with author and time.",
        readOnly: "Which WhatsApp each person uses is decided and set up by the company's Super users, Admins and Super admin, or by the Gioia365 Super admin: you do not need to connect anything.",
        channels: {
            meta: {
                label: "Official WhatsApp from Meta",
                tag: "recommended",
                text: "The message leaves from the number registered on the official WhatsApp from Meta, with templates approved by Meta. Gioia365 knows whether it was delivered and read, and the Lead's replies arrive in the CRM.",
                choice: "Number registered on Meta, templates approved by Meta, delivery and reading visible, replies in the CRM.",
                short: "Official",
            },
            agile: {
                label: "WhatsApp Agile",
                tag: "as in GioiaFlow",
                text: "The message leaves by itself from the number connected with the QR code, with the same system as GioiaFlow. The text can be touched up before sending; Gioia365 only knows that the provider has taken it.",
                choice: "Number connected with the QR code; the message leaves by itself and can be touched up before sending.",
                short: "Agile",
            },
            manual: {
                label: "By hand, from WhatsApp Desktop",
                tag: "as today",
                text: "Gioia365 opens WhatsApp Desktop on the salesperson's computer, with the message already written. They press Enter and then «Yes, sent»: the CRM does not see whether it arrived.",
                choice: "WhatsApp Desktop opens on their computer; they press Enter and then «Yes, sent».",
                short: "By hand",
            },
        },
        company: {
            title: "The WhatsApps {organization} uses",
            text: "First step: the Super admin chooses which WhatsApps the company uses. Second step, below: for each person you choose which of these they use and with which number.",
            readOnly: "This choice is made by the {organization} Super admin and the Gioia365 Super admin.",
            always: "Always stays: it is the fallback when the others are not ready.",
            nextRelease: "Comes with the next release",
            metaUnavailable: "The official WhatsApp is not connected to Gioia365 yet",
            agileUnavailable: "Not available: WhatsApp Agile is not connected to Gioia365 yet",
            switchedOn: "{channel} switched on for {organization}: you can now choose it for each person with «Set up».",
            switchedOff: "{channel} switched off for {organization}. The change stays in the Activity log.",
            switchedOffOne: "{channel} switched off for {organization}: 1 person moves to by hand until you set them up again. The change stays in the Activity log.",
            switchedOffMany: "{channel} switched off for {organization}: {count} people move to by hand until you set them up again. The change stays in the Activity log.",
            conflict: "Meanwhile someone changed the company settings: above is the saved choice. Check it and try again.",
        },
        people: {
            title: "Each salesperson's WhatsApp",
            text: "For each one you choose which WhatsApp they use and which number their messages leave from. You choose among the WhatsApps {organization} uses. A new salesperson starts with the official WhatsApp, the recommended one, if {organization} uses it; otherwise by hand.",
            caption: "Each salesperson's WhatsApp and number",
            columns: {
                person: "Salesperson",
                channel: "WhatsApp",
                number: "Number",
                state: "Status",
                action: "Action",
            },
            you: "you",
            noNumber: "No number",
            setup: "Set up",
            setupNamed: "Set up {name}'s WhatsApp",
            autoTitle: "Happens by itself:",
            autoText: "before every send Gioia365 checks that the salesperson's WhatsApp is ready and, for the official WhatsApp, that the template is approved by Meta. If it is not, the message opens in WhatsApp Desktop as by hand: a WhatsApp never shows as sent unless it really left.",
        },
        states: {
            manual: "WhatsApp Desktop on their computer",
            metaReady: "Registered on Meta",
            metaPending: "To be registered: by hand for now",
            metaFailed: "Registration on Meta failed: by hand for now",
            metaCallerRemoved: "The mobile phone was removed from the fleet",
            metaNotConnected: "Connection with Meta to be finished: by hand for now",
            metaNotConfigured: "The official WhatsApp is not connected to Gioia365 yet",
            agileReady: "Connected with the QR code",
            agilePending: "Not connected: by hand for now",
            agileUnchecked: "Connected with the QR code, not checked yet",
            agileDown: "Not delivering since {since}: by hand for now",
            agileDownStale: "Was not delivering at the check of {checked}: the next send checks it again",
        },
        team: {
            metaReady: "registered on Meta",
            metaPending: "to be registered",
            metaFailed: "registration failed",
            metaCallerRemoved: "mobile removed from the fleet",
            metaNotConnected: "connection with Meta to be finished",
            metaNotConfigured: "not connected to Gioia365",
            agileReady: "connected",
            agilePending: "to be connected",
            agileUnchecked: "not checked yet",
            agileDown: "not delivering since {since}",
            agileDownStale: "was not delivering at the check of {checked}",
            failed: "I cannot read people's WhatsApp, so the «WhatsApp» column is missing here. Try again.",
        },
        dialog: {
            title: "{name}'s WhatsApp",
            legend: "Which WhatsApp they use",
            number: "WhatsApp number of their WhatsApp Desktop",
            placeholder: "+39 300 000 0000",
            numberHint: "Spaces, dots and dashes are removed automatically. The prefix is needed, for example +39.",
            manualNote: "There is nothing to connect: the salesperson writes from this number with WhatsApp Desktop on their computer.",
            effect: "What changes:",
            effectManual: "{name} sends WhatsApps by hand, from WhatsApp Desktop, and confirms with «Yes, sent».",
            save: "Save",
            numberInvalid: "Write the number with the prefix, for example +39 300 000 0101.",
            numberTaken: "This number already belongs to {name}: each person has their own.",
            notUsed: "{organization} does not use this WhatsApp: the Super admin switches it on at the top of «Sending WhatsApps».",
            conflict: "Meanwhile someone changed {name}'s WhatsApp: the table shows the one saved now. To keep the number you wrote, save again.",
            saved: "Saved. {effect} It stays in the Activity log.",
            numberMeta: "WhatsApp number of their work phone",
            effectMeta: "{name}'s WhatsApps leave from the official WhatsApp, with templates approved by Meta.",
            saveMeta: "Register on Meta and save",
            effectAgile: "{name}'s WhatsApps leave by themselves with WhatsApp Agile.",
            saveAgile: "I scanned the code, save",
        },
        agile: {
            code: "WhatsApp Agile code",
            codeHint: "The code of this number, from the WhatsApp Agile panel. You can also paste the whole link: the code is taken from it.",
            codeSavedHint: "The saved code is not shown. To connect the same phone again press «Connect the phone again»; for another number write its code.",
            codeMissing: "Write the WhatsApp Agile code of this number.",
            codeSavedHintNoRepair: "The saved code is not shown: to connect the phone again write its code again.",
            codeMissingSaved: "Write the WhatsApp Agile code, or press «Connect the phone again».",
            codeMissingSavedNoRepair: "Write the WhatsApp Agile code of this number.",
            codeTaken: "This code already belongs to {name}.",
            codeInvalid: "The code has only letters, digits, «_» and «-»: check you copied all of it.",
            qrTitle: "The QR code",
            step1: "Take the salesperson's work phone and open WhatsApp.",
            step2: "Go to Settings → Linked devices → Link a device.",
            step3: "Scan the QR code that opens in a new tab with «Open the QR code».",
            openQr: "Open the QR code",
            openQrFirst: "Write the code first: the QR code opens from it.",
            repair: "Connect the phone again",
            repairing: "Reading the QR code of the saved number…",
            repairReady: "The QR code of the saved number is ready: open it and scan it with the work phone.",
            releaseOne: "When the phone connects again, WhatsApp Agile immediately sends the messages it kept queued: 1 accepted in the last 24 hours from this number.",
            releaseMany: "When the phone connects again, WhatsApp Agile immediately sends the messages it kept queued: {count} accepted in the last 24 hours from this number.",
            saving: "Checking the code with WhatsApp Agile…",
            downOne: "{name}'s WhatsApp Agile is not delivering: it needs to be connected again with the QR code.",
            downMany: "The WhatsApp Agile of {names} is not delivering: it needs to be connected again with the QR code.",
        },
        meta: {
            registrationTitle: "Registration on Meta:",
            registrationText: "Meta's window opens inside Gioia365 and the number enters the company's Business Manager. The number also stays in the WhatsApp Business app on the phone (Meta calls it «coexistence»): no SMS code, nothing deleted.",
            registeredCount: "Registered numbers: {count} of {cap}.",
            capReached: "The Business Manager already has {count} registered numbers: adding more needs a request to Meta.",
            registering: "Registration on Meta in progress…",
            windowOpen: "Complete the steps in Meta's window: as soon as you finish, Gioia365 registers the number.",
            failed: "Registration on Meta failed: {reason}",
            failedAtStep: "Registration on Meta failed at the step «{step}»: {reason}",
            retry: "Try again",
            retryNamed: "Try again to register {name}'s number on Meta",
            openWindow: "Open Meta's window",
            steps: {
                token: "exchange of the code with Meta",
                webhook: "address of Meta's messages",
                subscribed: "subscription to Meta's messages",
                phone_number: "reading the numbers on Meta",
            },
            reason: {
                noResponse: "Meta did not answer in time and it is not known whether the step succeeded: «Try again» repeats it safely.",
                lockLost: "another operation on the company's WhatsApp interrupted it: try again shortly.",
                tokenRejected: "Meta no longer accepts the company's connection: «Try again» reopens Meta's window.",
                rateLimited: "Meta asks to slow down: try again in a few minutes.",
                metaDown: "Meta has a fault right now: try again in a few minutes.",
                permission: "Meta does not give Gioia365 permission for this step: the Meta app needs checking.",
                invalidResponse: "Meta answered in a way Gioia365 does not expect: try again; if it happens again, tell whoever looks after Gioia365.",
                generic: "Meta refused the step: try again; if it happens again, tell whoever looks after Gioia365.",
            },
            windowClosed: {
                cancelled: "Meta's window closed before the end. If it did not open, the browser blocked it: allow Gioia365's windows and press «Open Meta's window».",
                incomplete: "Meta's window did not send everything needed: reopen it and complete the steps.",
                error: "Meta's window stopped with an error: reopen it and try again.",
                sdkUnavailable: "Meta's window does not open: check the connection, or that the browser does not block Facebook, and try again.",
            },
        },
        business: {
            title: "Meta Business Manager",
            verified: "company verified by Meta",
            nameUnknown: "The name on Meta has not been read yet",
            numbers: "Numbers registered on the official WhatsApp: {count} of {cap}. Before Meta's verification at most 2 can be registered, after it 20; for more you ask Meta.",
            numbersUnknown: "Numbers registered on the official WhatsApp: not read from Meta yet. Before Meta's verification at most 2 can be registered, after it 20; for more you ask Meta.",
            perDayTitle: "How many people per day",
            perDayText: "The limit applies to the whole Business Manager, not per number: it counts how many different people you write to first in 24 hours. It starts at 250 and rises by itself with verification and message quality.",
            none: "No number is registered on Meta yet: start with «Set up» on a salesperson, choosing «Official WhatsApp from Meta».",
            unfinished: "A registration on Meta is not finished: resume it with «Set up» and «Register on Meta and save».",
            failed: "The last registration on Meta failed: {reason} Resume it from «Set up», on the salesperson's row, with «Try again» or «Register on Meta and save».",
            readAt: "Read from Meta on {when}.",
            templatesApproved: "Templates approved by Meta: {approved} of {total}",
            templatesText: "They are written and sent for approval in {link}. Every delivered message is paid for, with different prices for marketing and utility templates.",
        },
    },
    whatsappTemplatesSettings: {
        intro: "The company's standard messages, which salespeople send with one click after the call. The Super admin writes them and they apply to the whole company; every change stays in the Activity log.",
        readOnly: "Only the company's Admins and Super admin write and change the templates: salespeople use them as they are.",
        variablesTitle: "Words that fill themselves in",
        variables: {
            nome: "name of the owner",
            aziendaTarget: "name of the target company",
            commerciale: "who sends the message",
            nostraAzienda: "name of our company",
            dayAndTime: "of the callback, the discovery call or the demo",
        },
        template: {
            name: "Template name",
            suggested: "Suggested {outcomes}. Always available from «Send WhatsApp».",
            after: "after «{outcome}»",
            notSuggested: "It is not in any path: it is sent from «Send WhatsApp».",
            text: "Text",
            insert: "Insert in the text",
            preview: "How Giulia Ferri receives it",
            save: "Save",
            nameMissing: "Give the template a name.",
            textMissing: "Write the text of the message.",
            tooLong: "The text is too long: with the «reply STOP» line at the end a WhatsApp has at most {max} characters, and here there are {count}.",
            saved: "Template «{name}» saved: it applies right away to the whole company.",
            conflict: "Meanwhile someone changed this template: the page now starts from the saved one, with your changes on top. Check them and save again.",
        },
        sample: {
            nome: "Giulia",
            aziendaTarget: "Studio Aurora",
            commerciale: "Luca",
            dayAndTime: "Friday 25/09/2026 at 10:00",
        },
        stopLine: {
            title: "The «reply STOP» line",
            text: "At the end of every WhatsApp, by hand too, there is this line: it tells the Lead how to stop receiving messages. It can be changed, but not removed.",
            label: "Text of the line",
            hint: "At most {max} characters, on a single line.",
            empty: "Write the line: every WhatsApp must say how to stop receiving them.",
            tooLong: "With this line the template «{name}» goes over the {max} characters of a WhatsApp: shorten the template or the line.",
            save: "Save",
            saved: "Line saved: it applies right away to every WhatsApp.",
            conflict: "Meanwhile someone changed the line: the page now starts from the saved one, with your change on top. Check it and save again.",
            metaWarning: "This line goes to Meta at the end of every template: saving it sends the templates already on Meta back to review, and meanwhile they are sent by hand.",
            savedInReview: "Line saved: it applies right away to every WhatsApp. Back in review by Meta: {names}; meanwhile they are sent by hand.",
            notResubmitted: "To send to Meta again: {names}. They are sent by hand until you press «Send to Meta for approval» on the template.",
        },
        meta: {
            howItLeaves: "How the message leaves depends on each salesperson's WhatsApp, chosen in «Sending WhatsApps». With the official WhatsApp only a template approved by Meta leaves, as it is: whoever uses a template not yet approved sends it by hand. With WhatsApp Agile it leaves by itself and can be retouched at the desk. By hand it opens in WhatsApp Desktop already written and is retouched there.",
            status: {
                none: "Meta: to send",
                pending: "Meta: in review",
                approved: "Meta: approved",
                rejected: "Meta: rejected",
                paused: "Meta: paused",
                disabled: "Meta: switched off",
            },
            category: {
                utility: "Utility",
                marketing: "Marketing",
            },
            categoryChanged: "Category decided by Meta: {decided} (Gioia365 had proposed {proposed}).",
            rejected: "Meta's reason: {reason} Change the text and save it: it goes back to review by itself.",
            rejectedReason: {
                abusiveContent: "the text has content Meta does not allow.",
                incorrectCategory: "the category does not match the text.",
                invalidFormat: "the format of the text is not right (the variables, the line breaks or the characters).",
                promotional: "it is a promotional text for its category.",
                scam: "Meta considers it a possible scam.",
                tagContentMismatch: "the text does not match the category or the language.",
                unknown: "Meta did not say.",
            },
            paused: "Meta paused it for the quality of the messages: while it stays so, whoever uses the official WhatsApp sends it by hand.",
            disabled: "Meta switched it off: whoever uses the official WhatsApp sends it by hand until you send it to Meta again.",
            lastError: "The last sending to Meta failed: {reason}",
            failure: {
                noResponse: "Meta did not answer in time: try again.",
                lockLost: "another operation on the company's WhatsApp interrupted it: try again shortly.",
                connection: "Meta no longer accepts the company's connection: register on Meta again in «Sending WhatsApps».",
                permission: "Meta does not give Gioia365 permission to send templates: the Meta app needs checking.",
                rateLimited: "Meta asks to slow down: try again in a few minutes.",
                metaDown: "Meta has a fault right now: try again in a few minutes.",
                generic: "Meta did not accept it: check the text and try again; if it happens again, tell whoever looks after Gioia365.",
            },
            submit: "Send to Meta for approval",
            submitted: "Sent to Meta: approval usually arrives within a few hours.",
            saveFirst: "Save the text first: the saved text is what goes to Meta.",
            textChanged: "A changed text goes back to review by Meta: until it is approved, whoever uses the official WhatsApp sends it by hand.",
            savedInReview: "Template «{name}» saved. The text changed: it goes back to review by Meta and, until it is approved, whoever uses the official WhatsApp sends it by hand.",
            notResubmitted: "The text is saved but did not leave for Meta again: {reason} Until you send it with «Send to Meta for approval», it is sent by hand.",
            notConnected: "The company's official WhatsApp is not connected to Meta yet: first register a number with «Register on Meta and save», in «Sending WhatsApps».",
            conflict: "The text changed while Meta was receiving it: the page now shows the saved one. If it is the right one, send it to Meta again.",
            channelsFailed: "I cannot read which WhatsApps the company uses: the templates' state on Meta is missing here.",
            quoted: "«{name}»",
        },
    },
    // Settings → «Goals» (plan M7, Task 6; D9; SEZ-16).
    goalsSettings: {
        about: "What it is for",
        aboutText: "The goals of the month, person by person, and the percentages the Report uses to colour the numbers and to work back from sales to calls. Only who has «Goals» among the permissions of their role sees and changes them: by default the Super admin.",
        readOnlyPlatform: "These are the goals of {organization}: its Super admin changes them, not the Gioia365 Super admin.",
        noAccess: "Only who has «Goals» among the permissions of their role sees and changes the goals: by default the Super admin.",
        month: "Month",
        monthLocked: "Save or discard the changes before changing month.",
        averageSale: "Average value of a sale",
        averageSaleHint: "In euro, for the company and for every month: from the sales goal it gives the closings needed.",
        goalsTitle: "Sales goal of the month",
        goalsHint: "In euro, one row per salesperson, for {month}. Empty means no goal.",
        noGoal: "No goal",
        noPeople: "There is no salesperson in the team yet.",
        inactive: "{name} (no longer active)",
        targetsTitle: "Percentage goals",
        targetsHint: "The Report colours the numbers green from «From» upwards and works back from sales to calls with «From». They apply to the whole company.",
        from: "From",
        to: "To",
        decided: "decided, cannot be changed",
        range: "{min}–{max}%",
        atLeast: "at least {min}%",
        saved: "Goals saved: the Report uses them from now on.",
        conflict: "In the meantime someone changed the goals: the page now starts from the saved ones, with your changes on top. Check them and save again.",
        problems: {
            averageSale: "The average value of a sale is written in euro, from 0.01 to 10,000,000, without thousands separators.",
            goal: "The goal of {name} is written in euro, from 0 to 10,000,000, without thousands separators.",
            percent: "{name}: percentages go from 0.1 to 100, with at most one decimal.",
            minMissing: "{name}: write «From».",
            minOverMax: "{name}: «From» cannot be higher than «To».",
        },
        changes: {
            averageSale: "Average value of a sale: from {before} to {after}.",
            averageSaleSet: "Average value of a sale: {after}.",
            averageSaleRemoved: "Average value of a sale removed (it was {before}).",
            goal: "{name}, {month}: from {before} to {after}.",
            goalSet: "{name}, {month}: {after}.",
            goalRemoved: "{name}, {month}: no goal (it was {before}).",
            target: "{name}: from {before} to {after}.",
        },
    },
    assignmentSettings: {
        title: "Lead assignment",
        about: "What it is for",
        aboutText: "Decides who gets a new Lead that arrives from Meta or from an import: in turn among the chosen people, all to one person, or to nobody, and then a Super user, an Admin or the Super admin assigns it by hand.",
        aboutTeam: "It is a team rule, not a personal one: it keeps two salespeople from working the same Lead and a Lead from being left with nobody.",
        aboutNow: "For now the rule applies to «New Lead», when you do not choose an owner; Leads that arrive from GoHighLevel and from files will use it as soon as those entries are ready.",
        readOnly: "You can only view it: the Super admin and the Admin of {organization} change it.",
        readOnlyPlatform: "It is a rule of {organization}: its Super admin and Admin change it, not the Gioia365 Super admin.",
        newLeads: "New Leads",
        how: "How they are assigned",
        modeRoundRobin: "In turn among the chosen people",
        modeSingle: "All to one person",
        modeManual: "To nobody: a Super user, an Admin or the Super admin assigns them by hand",
        whoJoins: "Who is in the turn",
        suspended: "{name} (suspended)",
        noCandidates: "There is no salesperson in the team yet to put in the turn.",
        orderNote: "The turn follows the alphabetical order of the names. Anyone who is invited appears here when they accept the invitation.",
        weightLabel: "Leads in a row to {name}",
        weightOption: "{count} in a row",
        weightNote: "Next to each person choose how many new Leads they get in a row before it is the next person's turn: with 2 and 1, the first gets two and the second one, then it starts again.",
        toWhom: "To whom",
        choosePerson: "Choose a person",
        nextLeads: "The next 6 new Leads: {names}. Anyone who is suspended skips the turn by themselves.",
        nextNone: "New Leads arrive without an owner, and show up in the Lead list under «No owner», until a Super user, an Admin or the Super admin assigns them. Anyone who is suspended skips the turn by themselves.",
        returning: "A Lead that comes back",
        returningLegend: "If a Lead that already exists arrives again (same mobile)",
        returningKeep: "It stays with its owner; if the owner is suspended or archived, it is assigned like a new Lead",
        returningAsNew: "It is assigned like a new Lead",
        returningNote: "A returning Lead is recognised by the mobile only: the same email is at most a duplicate to check in «Data cleanup». For now this choice is only saved: the GoHighLevel Lead entry, which comes later, will use it.",
        saved: "Rule saved: it applies from the next new Lead.",
        conflict: "Someone has changed the company settings in the meantime: the page now starts from the saved rule, with your changes on top. Check them and save again.",
        problems: {
            needPerson: "Choose at least one active person for the turn.",
            needSingle: "For «All to one person» choose an active person.",
        },
        changes: {
            mode: "New Leads go {after} (before: {before}).",
            modeRoundRobin: "in turn among the chosen people",
            modeSingle: "all to one person",
            modeManual: "to nobody, a Super user, an Admin or the Super admin assigns them by hand",
            people: "In the turn: {names}.",
            weights: "Leads in a row: {list}.",
            single: "All new Leads go to {name}.",
            returningKeep: "A returning Lead stays with its owner.",
            returningAsNew: "A returning Lead is assigned like a new Lead.",
        },
    },
    leadIntakeSettings: {
        about: "What it is for",
        aboutText: "This is where you connect the doors through which Leads come into Gioia365 by themselves: the Meta forms, the forms of the website and the landing pages and, while they stay on, the GoHighLevel landing pages.",
        aboutSame: "Every Lead comes in through the same path as «New Lead»: if the mobile is already there it is not doubled, its details are updated and the tags are added; a new Lead gets its owner from the «Lead assignment» rule and its call sequence starts right away.",
        aboutSecret: "These are company connections: you set them up once and they apply to everyone. The addresses are secret like a password: whoever knows them can let Leads into {organization}.",
        readOnly: "Read only: the intake is set up by the Super admin of {organization} and the Gioia365 Super admin.",
        meta: "Meta forms",
        metaUnavailable: "The link with Meta is not active on this server.",
        metaText: "The Leads of the Meta forms come straight into Gioia365, without going through GoHighLevel: every minute Gioia365 reads the forms of the linked Facebook page.",
        metaRules: "A new Lead gets its owner from the «Lead assignment» rule and the «Facebook» or «Instagram» tag; whoever answers «no» to «Are you an owner, do you have a salon?» never becomes a Lead. The Leads that arrive from the moment of the link come in: the earlier ones stay where they are.",
        metaNone: "No page linked.",
        metaConnect: "Connect the Facebook page",
        metaReconnect: "Connect the page again",
        metaConnectHint: "Log in with an account that manages the page and has a role on the Meta app, and keep all the permissions Facebook asks for.",
        metaCancelled: "The Facebook window closed before the end: nothing changed.",
        metaSdkUnavailable: "The Facebook window did not open: check that the browser does not block Facebook and try again.",
        metaPermissions: "Facebook did not give the permissions to read the forms: try again and keep all the permissions it asks for.",
        metaNoPages: "This account manages no Facebook page: log in with the account that manages the page.",
        metaChooseTitle: "Choose the page",
        metaChooseLegend: "The Facebook page the Leads come from",
        metaChooseText: "The Leads of the forms of the chosen page will come into {organization}. A page is linked to one company only.",
        metaChooseConfirm: "Connect this page",
        metaConnected: "Linked: «{page}», since {when}.",
        metaConnectedDone: "Page linked: the Leads of its forms come in from now on.",
        metaRoundNone: "The first reading of the forms starts within a minute.",
        metaRoundOk: "Last reading of the forms: {when}.",
        metaRoundFailed: "The last reading of the forms, on {when}, did not succeed: Gioia365 tries again by itself every minute.",
        metaRoundTokenRejected: "Meta no longer accepts the link: connect the page again.",
        metaDisconnect: "Disconnect the page",
        metaDisconnectTitle: "Disconnect the page?",
        metaDisconnectText: "The Leads of the forms of «{page}» stop coming into Gioia365. The Leads already in stay.",
        metaDisconnectConfirm: "Yes, disconnect it",
        metaDisconnected: "Page disconnected: the Leads of the Meta forms no longer come in.",
        metaConflict: "Meanwhile someone changed the link with Meta: the box now shows the saved one.",
        web: "Website and landing page forms",
        webActive: "Receive the Leads of the website and landing page forms",
        webAddress: "The address to put in the form",
        webOwner: "The form Leads get their owner from the «Lead assignment» rule.",
        ghl: "GoHighLevel",
        ghlActive: "Receive the Leads from GoHighLevel",
        ghlAddress: "The address to put in GoHighLevel",
        addressHidden: "The last part is secret: you see it whole only when you copy it.",
        addressNone: "The address is created when you switch the intake on and save.",
        off: "Off: the address answers «not authorized» and no Lead comes in. Leads already in stay.",
        copy: "Copy the address",
        copiedWeb: "Address copied: it is also inside «Copy the code», below.",
        copiedGhl: "Address copied: paste it in the GoHighLevel «Webhook» action.",
        copyFailed: "The browser does not allow copying: the whole address is in the field, select it and copy it by hand.",
        rotate: "Change the address",
        rotateTitle: "Change the address?",
        rotateTextWeb: "The current address stops working right away: afterwards, put the new piece of code in every website and landing page form. Leads already in stay.",
        rotateTextGhl: "The current address stops working right away: afterwards, paste the new one in every GoHighLevel workflow that uses it. Leads already in stay.",
        rotateConfirm: "Yes, change it",
        rotated: "Address changed: the previous one no longer works. Copy the new one.",
        origins: "Websites the forms come from",
        originsHint: "Write the website address as you see it in the browser, for example https://www.example.com: only the pages of these websites can read Gioia365's answer and say «Thank you» to whoever fills the form in.",
        originsNone: "No website: the forms still let Leads in, but the page cannot say «Thank you».",
        originField: "Website address",
        originAdd: "Add",
        originRemove: "Remove {origin}",
        originInvalid: "Write only the start of the address, with https://, for example https://www.example.com.",
        originTaken: "This website is already there.",
        originsMax: "At most {count} websites.",
        snippet: "The piece of code to put in the page",
        snippetText: "A ready form, with the fields Gioia365 reads, the hidden field against programs and the time the page opens. Put it in the website or landing page: the labels can change, the field names cannot.",
        snippetLabel: "Form code",
        snippetCopy: "Copy the code",
        snippetCopied: "Code copied, with the real address inside: paste it in the page.",
        snippetPlaceholder: "FORM-ADDRESS",
        form: {
            firstName: "First name",
            lastName: "Last name",
            phone: "Mobile",
            email: "Email",
            salon: "Company name",
            city: "City",
            consent: "I want to be contacted",
            send: "Send",
            thanks: "Thank you! We will get back to you soon.",
            phoneInvalid: "Write a mobile number (with the country code, if it is not Italian).",
            tooMany: "Too many submissions from here: try again in a few minutes.",
            error: "It could not be sent: try again.",
        },
        ghlSteps: "What to do in GoHighLevel, once",
        ghlStep1: "In GoHighLevel open «Automations» and the workflow that receives the Leads of the Meta forms.",
        ghlStep2: "Add the «Webhook» action, POST method, and paste the address copied above.",
        ghlStep3: "In the «Custom Data» section of the action you can add campaign_name and form_name (and, if you have them, campaign_id, adset_name, ad_name, form_id): they become the Lead's origin.",
        ghlStep4: "Save the workflow. The first Lead that arrives shows up below, in «The latest Leads in».",
        owner: "Who becomes owner",
        ownerLegend: "Who becomes owner of a new Lead from GoHighLevel",
        ownerTag: "The one written in the «Owner: First Last» tag, if they are an active team member; otherwise the «Lead assignment» rule",
        ownerRule: "Always the «Lead assignment» rule",
        ownerNote: "A Lead that was already there stays with its owner, as «Lead assignment» says. The «Owner: …» tag does not stay among the Lead's tags.",
        test: "Let a test Lead in",
        testText: "A made-up Lead comes in, with the «Prova ingresso» tag, through the same path as real Leads: you find it below and at the top of the Lead list.",
        testOnlyDemo: "Only in test companies: here every Lead that comes in is real.",
        testDone: "A test Lead came in: you find it below, in «The latest Leads in».",
        recent: "The latest Leads in",
        recentCaption: "The latest 50 Leads in, newest first",
        recentOnlyEditors: "Seen by whoever sets up the intake: they include the names of the Leads of the whole company.",
        recentEmpty: "No Lead has arrived yet.",
        refresh: "Refresh",
        columns: {
            when: "When",
            from: "From",
            lead: "Lead",
            what: "What happened",
            owner: "Owner",
        },
        providers: {
            web: "Website",
            ghl: "GoHighLevel",
            meta: "Meta",
        },
        results: {
            created: "New Lead",
            updated: "Already there with the same mobile: details updated and tags added",
            duplicate: "Sent twice: the same content arrived in the last 24 hours, nothing new",
            discarded: "Discarded: {reason}",
            pending: "Being processed",
            retrying: "To redo: the company database did not answer, Gioia365 retries by itself (attempts: {attempts})",
            failed: "Did not come in: the company database did not answer for {attempts} attempts",
        },
        discardReasons: {
            phone_missing: "the phone is missing",
            invalid_phone: "the phone cannot be read",
            phone_invalid: "the phone is not a valid mobile",
            archived_lead: "the mobile belongs to an archived Lead",
            not_an_object: "the content cannot be read",
            honeypot: "a program filled it in (the hidden field is filled)",
            too_fast: "sent less than 3 seconds after the page opened",
            not_owner: "answered «no» to «Are you an owner, do you have a salon?»",
            other: "a reason Gioia365 cannot tell",
        },
        notes: {
            tag_unknown: "the «Owner: …» tag is not a team member, the rule decided",
            tag_ambiguous: "the «Owner: …» tag fits more than one person, the rule decided",
            tag_inactive: "the «Owner: …» tag is a suspended person, the rule decided",
            fill_time_missing: "without the time the page opened",
            clock_ahead: "with the computer clock ahead",
        },
        withNote: "{what} · {note}",
        ownerVia: {
            tag: "{name} (from the tag)",
            rule: "{name} (from the rule)",
            kept: "{name} (stays theirs)",
            chosen: "{name}",
        },
        noOwner: "No owner",
        none: "—",
        changes: {
            webOn: "The Leads of the website and landing page forms come in by themselves.",
            webOff: "The website and landing page forms no longer let Leads in: the address answers «not authorized».",
            origins: "Websites the forms come from: {list}.",
            originsNone: "No website the forms come from.",
            ghlOn: "The Leads from GoHighLevel come in by themselves.",
            ghlOff: "GoHighLevel no longer lets Leads in: the address answers «not authorized».",
            ownerTag: "A new Lead from GoHighLevel gets its owner from the «Owner: …» tag, otherwise from the rule.",
            ownerRule: "A new Lead from GoHighLevel always gets its owner from the rule.",
        },
        saved: "Intake saved: it applies from the next Lead that arrives.",
        conflict: "In the meantime someone changed the intake: the page now starts from what is saved, with your changes on top. Check them and save again.",
    },
    importExport: {
        about: {
            title: "What it is for",
            text: "From here Leads come into Gioia365 and, later on, go out. You can import from CSV or view the guided import from Close. Exporting comes later.",
            whoTitle: "Who sees it",
            who: "The Super admin and the Admin of {organization}, and the Gioia365 Super admin.",
        },
        denied: "Import and export is seen by the Super admin and the Admin of {organization}, and by the Gioia365 Super admin: with your role you do not see it.",
        ways: "Ways to import and export",
        later: "Coming later",
        close: {
            title: "Guided import from Close",
            text: "The report of the test run without saving and of the import from Close: how many Leads come in, who becomes the owner, how each field moves and what there is to check. The Gioia365 Super admin starts them, or Gioia365 by itself every evening at 21:00.",
            open: "Open the guided import from Close",
        },
        ghl: {
            title: "GoHighLevel",
            text: "The read-only key of the GoHighLevel sub-account and the read test: how many contacts and conversations there are. For now nothing comes into Gioia365. The Gioia365 Super admin saves it.",
            open: "Open GoHighLevel",
        },
        file: {
            title: "Import from a CSV file",
            text: "Import Leads from CSV. For Excel, save the sheet as CSV first.",
            when: "It comes with the other ways Leads come in, together with GoHighLevel.",
        },
        export: {
            title: "Export",
            text: "Download the Leads in an Excel or CSV file.",
            when: "It comes later: when is not decided yet.",
        },
        backToSection: "Back to Import and export",
    },
    closeImport: {
        about: {
            title: "What it is for",
            text: "Before leaving Close there is a test run without saving: Gioia365 reads everything from Close and shows you here what would come in and who it would go to, without saving anything. Read how many Leads come in, who becomes the owner, how each field moves and what there is to check. When everything adds up the real import runs, and the report is the same.",
            whoTitle: "Who sees it",
            who: "The Super admin and the Admin of {organization}, and the Gioia365 Super admin. The report never shows the text of the notes or the customers' names: only numbers and Close references and, after the import, «Open the Lead».",
        },
        denied: "The import from Close is seen by the Super admin and the Admin of {organization}, and by the Gioia365 Super admin: with your role you do not see it.",
        whoStartsTitle: "Who starts them.",
        whoStartsText: "The Gioia365 Super admin starts the test run without saving and the import from «Every evening from Close», above; with the evening import on, Gioia365 runs it by itself at 21:00. A test run without saving changes nothing in Gioia365. While a run is in progress, this page refreshes by itself every 5 seconds.",
        nightly: {
            title: "Every evening from Close",
            intro: "While the team still works in Close, Gioia365 imports the day's data by itself every evening at 21:00, Italian time: it reads everything from Close again and writes only what changed. So the reports fill up every night.",
            keyTitle: "Key",
            keyLabel: "Close API key",
            keyHint: "You create it in Close, in the settings, under «API Keys». Gioia365 tries it with Close before saving it and keeps it encrypted: afterwards it is never shown again, here or anywhere else.",
            keySave: "Save the key",
            keySaving: "Trying it with Close…",
            keySaved: "Key saved on {date} at {time} by {person}.",
            keySavedBySomeone: "Key saved on {date} at {time}.",
            keyNone: "No key saved.",
            keyRemove: "Remove the key",
            keyRemoveConfirm: "Remove the key? The evening import turns off and the key cannot be recovered: turning it on again needs a new key and a test run without saving.",
            keyRemoveYes: "Yes, remove the key",
            keySavedToast: "Key saved.",
            keySavedOffToast: "Key saved. A new key needs a new test run without saving: the evening import is off.",
            keyRemovedToast: "Key removed: the evening import is off.",
            dryRunTitle: "Test run without saving",
            dryRunText: "Reads everything from Close and shows you what would come into Gioia365 and who it would go to, without saving anything.",
            dryRunStart: "Test run without saving",
            dryRunDone: "The test run without saving with this key finished on {date} at {time}.",
            dryRunRunning: "The test run without saving with this key is in progress: follow it below.",
            dryRunStopped: "The last test run without saving with this key stopped: do another one.",
            dryRunMissing: "A test run without saving completed with this key is missing.",
            dryRunToast: "Test run without saving started: follow it below.",
            eveningTitle: "Import",
            switchLabel: "Import every evening at 21:00",
            switchHint: "It turns on after a test run without saving completed with the current key.",
            importNow: "Import now",
            importNowText: "Runs the real import straight away, the same as the evening one.",
            importToast: "Import started: follow it below.",
            onToast: "Evening import turned on.",
            offToast: "Evening import turned off.",
            nextToday: "Next import: today at 21:00",
            nextTomorrow: "Next import: tomorrow at 21:00",
            nextSoon: "Next import: this evening, within a few minutes",
            notReady: "The evening import is on but does not start: a test run without saving completed with this key is missing.",
            off: "The evening import is off.",
            last: "Last evening import: {date} at {time}, {outcome}.",
            outcome: {
                running: "in progress",
                completed: "finished",
                interrupted: "stopped by the server restart, it resumes by itself",
                failed: "stopped with an error",
            },
            reason: {
                close_auth_failed: "Close no longer accepts the key: save a new one.",
                close_key_unreadable: "The saved key can no longer be read: save it again.",
                close_dry_run_required: "A test run without saving completed with this key is missing.",
                close_unavailable: "Close was not answering: the next evening tries again by itself.",
                other: "It stopped with an error: the Gioia365 team checks it.",
            },
            reasonCode: "Code: {code}",
            busy: "An import from Close is in progress: wait until it finishes.",
            readOnlyOn: "Import from Close every evening at 21:00: on.",
            readOnlyOff: "Import from Close every evening at 21:00: off.",
            readOnlyWho: "The Gioia365 Super admin turns it on and off.",
            platformShortcut: "For the key and the buttons, enter as the Gioia365 Super admin:",
            platformShortcutButton: "Enter as the Gioia365 Super admin",
        },
        // «Ready to switch Close off?» (M8, 22/10/2026): the switch-over check, only for the Gioia365 Super admin. Numbers only.
        handover: {
            title: "Ready to switch Close off?",
            intro: "Before cancelling: from the last finished import, how much data is in Close and how much is already in Gioia365, and why something is missing. The numbers come from what the import has already saved: looking at them asks Close nothing, so they do not see what entered Close afterwards. That is why the check only counts after Close is read-only for the team and after the last import.",
            base: "Last finished import: {date} at {time}.",
            ready: "All set",
            readyText: "Gioia365 has everything the last import read from Close, audio and attachments included. If Close was already read-only before that import, it can be cancelled.",
            notReady: "Not yet",
            notReadyText: "Before cancelling, still missing:",
            item: {
                no_import: "A finished import from Close: there is none yet.",
                import_old: "An import from today: the last finished one is from {date} at {time}.",
                unexplained: "{resource}: {count} in Close that are not in Gioia365, for no known reason. The Gioia365 team looks into it.",
                new_after_run: "{resource}: {count} arrived in Close after the last import. They come in with the next one.",
                unknown_type: "{count} Close activities of a type Gioia365 does not know: they did not come in and are lost when cancelling. To decide: bring them in (to be built) or leave them in Close.",
                audio_copy_off: "The audio of {count} calls is still only in Close and copying is off: there is no storage to keep it.",
                audio_to_copy: "The audio of {count} calls is still to be copied: copying goes on by itself, every minute.",
                audio_failed: "The audio of {count} calls was not copied after every attempt: the Gioia365 team looks into it.",
                counted_only: "{resource}: {count} in Close that do not come into Gioia365, only counted for now. Decide before cancelling.",
                counted_only_savedSearches: "Saved searches: {count} in Close that did not become Smart Lists and are not decided yet; they are lost when cancelling. For each one, below: «Rebuilt by hand» or «Let go».",
                attachments_copy_off: "Note attachments still only in Close: {count}, and copying is off: there is no storage to keep them.",
                attachments_to_copy: "Note attachments still to be copied: {count}. Copying goes on by itself, every minute.",
                attachments_failed: "Note attachments not copied after every attempt, or larger than 50 MB: {count}. The Gioia365 team looks into them; if needed they are downloaded by hand from Close before cancelling.",
                lead_not_updatable: "{resource}: {count} in Close on a Lead that is no longer in Gioia365 (deleted forever) or was archived or merged while the import was running: they did not come in. The next import tries again; on a Lead deleted forever they no longer come in.",
            },
            caption: "Close and Gioia365 side by side",
            what: "What",
            inClose: "In Close",
            inGioia365: "In Gioia365",
            difference: "The difference",
            notEntering: "not coming in",
            noDifference: "None",
            resource: {
                leads: "Leads",
                calls: "Calls",
                notes: "Notes",
                emails: "Emails",
                events: "History events",
                opportunities: "Opportunities",
                otherActivities: "SMS and other activities",
                openTasks: "Open tasks",
                savedSearches: "Saved searches",
                people: "Close people",
            },
            resourceHint: {
                events: "Status changes, meetings, completed tasks, updates and merges made in Close and the rest of the history.",
                emails: "They come in the Lead Timeline as history, with subject and text: Gioia365 does not send them.",
                openTasks: "They come in as callbacks in the Tasks section; those overdue by more than 30 days or that cannot, in a note on the Lead card.",
                savedSearches: "They come in as Smart Lists when their filters exist in Gioia365 too; the others, with the reason, are below.",
                people: "Close users, including those who are no longer there.",
            },
            reason: {
                no_phone: "{count} without a valid number: they do not come in",
                merged: "{count} merged into another Lead: their history is on the Lead that stays",
                lead_not_imported: "{count} of a Lead that did not come in",
                lead_not_updatable: "{count} on a Lead deleted forever, or archived or merged during the import: not in",
                invalid_date: "{count} without a valid date",
                in_note: "{count} in a note on the Lead's page",
                too_old: "{count} overdue by more than 30 days: in a note on the Lead's page",
                out_of_scope: "{count} SMS and email thread summaries (the emails come in one by one): not part of Gioia365",
                unknown_type: "{count} of a type Gioia365 does not know",
                new_after_run: "{count} arrived after the last import: they come in with the next one",
                counted_only: "{count} to rebuild by hand or let go",
                decided: "{count} decided: rebuilt by hand or let go",
                historic_author: "{count} stay only as authors of their activities",
                invited: "{count} invited to the team, not accepted yet",
            },
            unexplained: "{count} unexplained",
            audioTitle: "Call audio",
            audioWithAudio: "Calls with audio in Close",
            audioCopied: "Copied to Gioia365",
            audioToCopy: "To be copied",
            audioFailed: "Failed",
            audioMissing: "No longer in Close",
            audioOff: "Audio copying is off: there is no storage to keep it. The Gioia365 team turns it on.",
            attachmentsTitle: "Note attachments",
            attachmentsTotal: "Attachments of Close notes",
            attachmentsCopied: "Copied into Gioia365",
            attachmentsToCopy: "To copy",
            attachmentsFailed: "Not copied",
            attachmentsMissing: "No longer in Close",
            attachmentsOff: "Attachment copying is off: there is no storage to keep them, the same as for the audio. The Gioia365 team turns it on.",
            savedSearchesTitle: "Close saved searches to rebuild",
            savedSearchesText: "The ones that did not become Smart Lists, with the reason. For each one: «Rebuilt by hand» when the Smart List exists, «Let go» if it is no longer needed. A decided one no longer stops cancelling, and the choice can be undone. Never the Close filters.",
            savedSearchUnnamed: "Unnamed search",
            savedSearchRebuilt: "Rebuilt by hand",
            savedSearchDropped: "Let go",
            savedSearchUndo: "Undo",
            savedSearchDecided: "{decision}: {name}, on {date} at {time}",
            savedSearchActions: "Decision on «{name}»",
            savedSearchReason: {
                not_lead: "it does not search Leads",
                text_query: "it is a text search",
                user_dependent: "it depends on who looks («my Leads»)",
                nesting: "it has more filter levels than a Smart List holds",
                unknown_clause: "it has a filter Smart Lists do not have (dates, activities, text)",
                field: "it searches a field that is a note in Gioia365",
                status: "it searches a status Gioia365 does not have",
                owner: "it searches an owner who is not a Salesperson in Gioia365",
                tag: "it searches a tag Gioia365 does not have",
                value: "it searches an option Gioia365 does not have",
                too_long: "it would become a filter that is too long",
                no_owner: "it belongs to someone who is not an active team member",
                name_taken: "its owner already has a list with that name",
                not_examined: "not examined yet: with the next import",
            },
            savedSearchesMore: "and {count} more",
            after: "The order, decided by Lucio: Close read-only for the team, the last import, the audio and attachments copied, «All set» here, then cancelling.",
        },
        when: {
            dryRun: "Test run without saving of {date} at {time}",
            apply: "Import of {date} at {time}",
        },
        duration: {
            seconds: "{count} s",
            minutes: "{count} min",
            hours: "{hours} h {minutes} min",
        },
        runs: {
            title: "Runs",
            intro: "Newest first. Click the date to open the report.",
            caption: "Test runs without saving and imports from Close",
            when: "When",
            what: "What",
            state: "Status",
            duration: "Duration",
            empty: "There is no test run and no import yet. It starts with a test run without saving, which the Gioia365 Super admin starts.",
            dryRun: "Test run without saving",
            apply: "Import",
            synthetic: "with made-up data, to try the page",
            dryRunSub: "reads Close and shows what would come in, without saving anything",
            applySub: "writes Leads, history and notes into Gioia365",
            running: "in progress",
            completed: "finished",
            failed: "stopped with an error",
            aborted: "interrupted",
            runningFor: "in progress for {duration}",
            leadsRead: "{count} Leads read from Close",
        },
        phases: {
            label: "Phases",
            extract: "Reads the data from Close",
            plan: "Compares with Gioia365",
            apply: "Writes into Gioia365",
            done: "Writes the report",
            stateDone: "done",
            stateNow: "now",
            stateTodo: "later",
        },
        running: {
            subDryRun: "{when}, in progress. Nothing changes in Gioia365.",
            subApply: "{when}, in progress. In the «Writes into Gioia365» phase the Leads come in one block at a time.",
            leadsRead: "Leads read from Close: {count}",
            activitiesRead: "Activities read from Close (calls, notes and the others): {count}",
            starting: "It is starting to read from Close.",
            phaseNow: "Current phase: {phase}.",
            heartbeat: "Last signal from the run: {time}.",
            silent: "No signal since {time}: it may have stopped. The next test run or import of the same kind resumes it from where it got to.",
            reportLaterDryRun: "The full report arrives when the test run finishes.",
            reportLaterApply: "The full report arrives when the import finishes.",
        },
        stopped: {
            failed: "Stopped with an error after {duration}, in the «{phase}» phase.",
            aborted: "Interrupted after {duration}, in the «{phase}» phase.",
            dryRun: "Nothing changed in Gioia365: a test run without saving never writes. Do another one with «Test run without saving».",
            applyBeforeWriting: "Nothing changed in Gioia365: it stopped before writing. The next import reads everything from Close again.",
            applyWhileWriting: "What it had already written stays in Gioia365. The next import reads everything from Close again and writes only what is missing or changed.",
            newer: "Open the next run, of {date} at {time}",
            reasonAuth: "Close did not accept the key.",
            reasonAbandoned: "Closed to make room for a new run.",
            reasonCode: "Error code: {code}.",
        },
        unreadable: "The report of this run cannot be read: the Gioia365 team checks it. The run stays in the list.",
        jump: {
            label: "Go to a part of the report",
            lead: "Go to:",
            summary: "Summary",
            users: "Close users",
            variables: "Variables",
            check: "To check",
        },
        summary: {
            title: "Summary",
            subDryRun: "{when}: what would happen. Nothing changed in Gioia365. Duration: {duration}.",
            subApply: "{when}: what came into Gioia365. Duration: {duration}.",
            leads: {
                title: "Leads",
                sub: "In Close {count} Leads.",
                create: "New",
                createSubDryRun: "not in Gioia365 yet: they would come in",
                createSubApply: "were not in Gioia365: they came in",
                update: "Updated",
                updateSub: "already in Gioia365, with something new in Close: only the fields nobody touched in Gioia365 change",
                unchanged: "Unchanged",
                unchangedSub: "the same as at the last import: left as they are",
                skipped: "Not imported",
                skippedSub: "without any phone number, not even in the calls or in the other contacts",
                missing: "No longer in Close",
                missingSub: "they stay in Gioia365: a Lead is never deleted by itself",
            },
            history: {
                title: "Close history",
                sub: "It goes into the Timeline of each Lead, with the original author and date.",
                subAgain: "Only what is new since the previous import.",
                calls: "Calls",
                callsSub: "day, time, duration, outcome, who called and the notes",
                callsInvalid: "day, time, duration, outcome, who called and the notes; {count} failed for a technical error, which do not count",
                notes: "Notes",
                notesSub: "written in Close, with author and date, and the notes made from the Close fields",
                statusChanges: "Status changes",
                // Close emails come in as history (22/10/2026).
                emails: "Close emails",
                emailsSub: "in the Lead Timeline, with direction, subject and text; Gioia365 does not send them",
                other: "Other events",
                otherSub: "meetings, completed Tasks, activities such as «Qualification Call», opportunity stage changes, import updates and Lead merges made in Close",
                opportunities: "Opportunities",
                opportunitiesSub: "with stage, value and who follows them; updated from Close: {update}; left out, in a note on the card: {skipped}",
                // The historical Close disco and demo (22/10/2026).
                appointments: "Historical disco and demo",
                appointmentsSub: "appointments already closed, to whoever booked them, on the booking day; updated from Close: {update}; left out (already in Gioia365, or with nobody in the team): {skipped}; meetings that cannot be told to be a disco or a demo, only in the Timeline: {ambiguous}",
                tasks: "Open Tasks",
                tasksSub: "as callbacks in the Tasks section; updated from Close: {update}; closed because completed in Close: {completed}; left out, in a note on the card: {skipped}, of which overdue by more than 30 days: {tooOld}",
            },
            later: {
                title: "Close Smart Views",
                sub: "They become Smart Lists when their filters exist in Gioia365 too; Mirko's first.",
                savedSearches: "Smart Views in Close",
                savedSearchesSub: "new Smart Lists: {create}; updated from Close: {update}; to rebuild by hand, with the reason in «Ready to switch Close off?»: {skipped}",
            },
            notImported: {
                title: "Not imported",
                sub: "Counted, they stay in Close.",
                email: "Email",
                emailThread: "Email threads",
                sms: "SMS",
                emailSub: "SMS are not part of Gioia365; of email threads, the single emails come in",
                otherSub: "an activity type Gioia365 does not know",
                recordings: "Call recordings",
                recordingsSub: "the call data comes in, the audio is copied later, queued, into the Gioia365 archive",
            },
        },
        users: {
            title: "Close users",
            intro: "Each Close user and who they match in Gioia365. They are matched by email: if a team member uses another email, the match is made by hand before the next test run. Whoever is not in the team comes in as a suspended person, with their Close name.",
            peopleDryRun: "Close people who are no longer here: would come in as suspended {count}.",
            peopleApply: "Close people who are no longer here: came in as suspended {count}.",
            peopleExisting: "Already in Gioia365 from an earlier import, suspended or as the Team set them later (reactivated, archived): {count}.",
            caption: "Close users and Gioia365 people",
            closeUser: "Close user",
            inGioia: "In Gioia365",
            how: "How they are matched",
            leadsOwned: "Owner in Close of",
            calls: "Calls in Close",
            notes: "Notes in Close",
            effect: "What happens to their Leads",
            historic: "historical author, not in the team",
            historicNoEmail: "historical author: no valid email in Close",
            historicPlatform: "historical author: they are the platform manager",
            historicNoRole: "historical author: the company has no User role",
            invitedPill: "invited: has not accepted yet",
            newSuspended: "would come in as a suspended person",
            newSuspendedApply: "comes in as a suspended person with the next import",
            commercial: "Salesperson: can be the owner",
            leader: "leads the team: does not become the owner",
            inactive: "not active in the team",
            suspended: "suspended: keeps owning their Leads",
            suspendedFromClose: "suspended, from Close: keeps owning their Leads",
            archived: "archived: gets no Leads",
            byEmail: "same email",
            byHand: "matched by hand",
            none: "nobody in the team with their email",
            effectOwner: "They stay theirs, with calls and notes.",
            effectInactive: "They come in without an owner, to assign: the person is not active in the team. Calls and notes stay theirs.",
            effectLeader: "They come in without an owner, to assign: only a Salesperson (User) can be the owner. Calls and notes stay theirs.",
            effectLeadsTo: "Their Leads go to {name}, by the rule of the move from Close, unless someone in Gioia365 already changed the owner. Calls and notes stay theirs.",
            effectNotLinked: "They come in without an owner, to assign; the card keeps «Owner in Close: {name}». Calls and notes come in with their name and the «from Close» mark.",
            effectSuspended: "They stay theirs, with calls and notes, until someone reassigns them from the Team. The person is suspended: they get no new Leads and take no seat; if they come from Close they come back to the team only with an invitation they accept.",
            effectNewSuspended: "Comes in as a suspended person with their Close name: the Leads stay theirs, calls and notes too, and the reports show them by name. They get no new Leads and take no seat; they come back to the team only with an invitation they accept.",
            effectNewSuspendedLater: "Not created in this import: their Leads came in without an owner, with «Owner in Close: {name}». They are created suspended with the next one, which gives them the Leads nobody changed.",
            effectArchived: "They come in without an owner, to assign: the person is archived. Calls and notes stay theirs.",
            effectInvited: "They come in without an owner until they accept the invitation: from the next import they are theirs. Calls and notes come in with their name.",
            nobody: "Nobody",
            nobodyHow: "Leads without an owner in Close",
            nobodyEffect: "They come in without an owner, as in Close.",
            countsNote: "These are Close numbers: the Leads they own in Close, the calls they made and the notes they wrote in Close. A suspended person from Close is resumed or archived from the Team, like the others.",
        },
        variables: {
            title: "How the variables move",
            intro: "One row per Close field: where it goes in Gioia365, the values found and how many Leads have them. In red, with the ✕, the values that have no match yet: they are not lost, they stay in a note on the card.",
            caption: "How the Close fields move into Gioia365",
            closeField: "Close field",
            inGioia: "In Gioia365",
            values: "Values found",
            filled: "Leads with a value",
            bandData: "They become card data",
            bandNote: "They become notes on the card, with «original date unknown»",
            bandOther: "Used for something else or not copied",
            unmappedOne: "1 field has values without a match. Values that go into a note on the card: {notes}.",
            unmappedMany: "{count} fields have values without a match. Values that go into a note on the card: {notes}.",
            allMapped: "Every value has its match.",
            onlyUnmapped: "Only the fields with values without a match",
            noneUnmapped: "No field with values without a match: every value has its option.",
            empty: "This run found no Close fields to move.",
            unmapped: "{value} → no match · {leads} · stays in a note",
            mapped: "{value} → {label}",
            leads: "{count} Leads",
            freeText: "Free text: the text is not shown, only how many Leads have it.",
            noteValues: "It goes into the note as it is.",
            ignored: "Not copied: the value stays in Close.",
            ownerInfo: "See «Close users» above.",
            regionInfo: "It helps recognise the city when several municipalities have the same name.",
            showAll: "Show all {count} values",
            showFewer: "Show fewer values",
            to: {
                tags: "Tags, with the same name",
                salonName: "Target company name",
                owner: "Owner",
                createdAt: "Entry date",
                city: "Does not become a field",
                note: "A note: Close field «{label}»",
                ignored: "Not copied",
            },
        },
        check: {
            title: "To check",
            introDryRun: "The cases the test run found, group by group. Each group opens with the Close references; after the import, each one has «Open the Lead».",
            introApply: "The cases the import found, group by group. Each group opens with the Close references and «Open the Lead» for the Leads you see.",
            look: "To look at",
            lookSub: "Warnings: something to decide here, or a piece of data to fix after the import.",
            know: "Just to know",
            knowSub: "Information: the import already knows what to do.",
            noCases: "No cases: {names}.",
            group: "{name}: {count}",
            what: "What happens:",
            caption: "{name}: the cases",
            ref: "Close reference",
            detail: "What",
            inGioia: "In Gioia365",
            open: "Open the Lead",
            notImported: "not imported",
            notYet: "not in Gioia365 yet",
            shown: "Showing {shown} of {total}.",
            all: "All {total} cases.",
            perUser: "One row per Close user.",
            more: "Show {count} more",
            empty: "No case to show.",
            refs: {
                lead: "Lead {id}",
                activity: "Activity {id}",
                user: "Close user {id}",
                opportunity: "Opportunity {id}",
                task: "Task {id}",
                appointment: "Disco or demo {id}",
                saved_search: "Smart View {id}",
                other: "{resource} {id}",
            },
        },
        anomalies: {
            no_phone: { name: "Leads without a phone", what: "Without any number, not even in the calls or in the other contacts, a Lead does not come in: this is already decided. It stays in Close." },
            duplicate_phone: { name: "Same mobile on two Leads", what: "Both come in, each with its history: the number also belongs to another Close Lead, or to more than one Gioia365 Lead. If they are the same person they are merged with «Data cleanup»." },
            joined_by_mobile: { name: "Joined to an existing Lead", what: "The mobile already belonged to a Gioia365 Lead that came in another way (Meta, GoHighLevel, a file, by hand): the Close history goes onto that Lead, which keeps its status and owner; no duplicate." },
            invalid_phone: { name: "Invalid number", what: "The number does not become the mobile or the landline: it stays in a note on the card." },
            phone_from_calls: { name: "Number taken from the calls", what: "The holder had no valid number: the number of the last call made in Close applies (open question 48)." },
            phone_from_other_contact: { name: "Number taken from another contact", what: "Without other numbers, the first valid number of another contact of the Lead applies (open question 80)." },
            city_not_found: { name: "City not recognised", what: "The Lead comes in without a city; address and postal code stay. The city is chosen later on the card." },
            city_ambiguous: { name: "City with several municipalities of the same name", what: "The province is missing and there is more than one municipality with that name: the Lead comes in without a city." },
            unknown_status: { name: "Status Gioia365 does not know", what: "The status becomes «No Type»." },
            unmapped_option: { name: "Value without a match", what: "The field stays empty and the value goes into a note on the card, until the option is decided in the variables review." },
            field_conflict: { name: "Two Close fields that say different things", what: "The first field applies; the value of the other goes into a note on the card (open question 53)." },
            owner_not_linked: { name: "Close owner who cannot be the owner in Gioia365", what: "The Lead comes in without an owner, to assign: only a Salesperson (User) of the team, active or suspended, can be the owner; whoever has no email in Close stays a name. The card keeps who the owner was in Close." },
            invalid_email: { name: "Invalid email", what: "It does not become the Lead's email: it stays in a note." },
            invalid_date: { name: "Invalid date", what: "The date is not written: the next date applies, or the activity does not come in." },
            missing_in_source: { name: "Lead no longer in Close", what: "In Gioia365 it stays as it was: a Lead is never deleted by itself (open question 57)." },
            local_change_kept: { name: "Changed both in Close and in Gioia365", what: "Someone changed it in Gioia365 after the import: the Gioia365 value stays (open question 57)." },
            source_changed_after_import: { name: "Activity changed in Close after the import", what: "In Gioia365 it stays as it was at the import; here you see that it changed in Close." },
            value_too_long: { name: "Value too long for the field", what: "The field stays empty and the whole value goes into a note on the card." },
            lead_not_updatable: { name: "Lead archived or merged in Gioia365", what: "The import does not change its card; its new Close history comes in anyway, on the remaining Lead if merged, and new Tasks and opportunities in a note." },
            unknown_opportunity_status: { name: "Opportunity stage Gioia365 does not know", what: "The opportunity does not come in: stage, value, dates and note go into a note on the Lead card." },
            task_not_imported: {
                name: "Open Task left out",
                what: "It does not become a callback, because the Lead already has an open one, because nobody in the team can take it or because in Close it is not a call to make: its data go into a note on the Lead card.",
            },
            // The Close saved searches (22/10/2026).
            saved_search_not_imported: {
                name: "Close Smart View that does not become a Smart List",
                what: "The Smart List is not born: a Close filter does not exist in Gioia365, or the owner is missing or the name is taken. The name and the reason are in «Ready to switch Close off?», to rebuild it by hand.",
            },
            // The historical Close disco and demo (22/10/2026).
            appointment_not_imported: {
                name: "Close disco or demo left out",
                what: "It does not become an appointment: the same one is already in Gioia365, or nobody in the team booked it and the Lead has no owner, or it is a Close meeting that cannot be told to be a disco or a demo, which stays in the Timeline and does not count in the reports.",
            },
            opportunity_not_imported: { name: "Opportunity left out", what: "It does not come in, because a Lead has at most one open opportunity or because nobody in the team can follow it: its data go into a note on the Lead card." },
            opportunity_incomplete: { name: "Opportunity with missing data", what: "It comes in anyway. A sale without a value counts as zero euros; a sale by someone outside the team does not count in the sales reports." },
            name_split_uncertain: { name: "First and last name to check", what: "One word only, or more than three: the split is checked and corrected on the card." },
            extra_contacts: { name: "More than two people on the same Lead", what: "The first person is the holder, the second the second holder; the others go into the note «Other contacts from Close» (open question 50)." },
            extra_phones: { name: "Extra numbers", what: "The numbers beyond mobile and landline go into a note on the card." },
            city_foreign: { name: "Address abroad", what: "The Lead comes in without a city: the cities are the Italian municipalities." },
            author_not_linked: { name: "Activities of people not in the team", what: "It comes in with the name of who did it and the «from Close» mark, but it belongs to nobody in the team." },
            created_on_used: { name: "Entry date taken from «Creato il»", what: "The entry date is the one of the Close field «Creato il», not the day the Lead was born in Close (open question 51)." },
            last_call_mismatch: { name: "Last call different from the one written in Close", what: "Nothing changes: the last call comes from the imported calls. It is only a check." },
            activity_not_imported: { name: "Activities not imported", what: "They are counted and do not come in: emails, email threads and SMS are not part of Gioia365, the others are activity types Gioia365 does not know." },
            recording_not_copied: { name: "Audio to copy from Close", what: "The call data comes in; the audio is copied later, queued, into the Gioia365 archive." },
            attachments_not_copied: { name: "Attachments to copy from Close", what: "The note comes in and says how many attachments it had; the attachments are copied later, queued, into the Gioia365 archive." },
            nul_characters_removed: { name: "Invalid characters removed from the text", what: "Invisible characters the database does not accept: they are removed and the rest of the text comes in." },
            unknown: { name: "Other cases ({code})", what: "A case this page cannot explain yet: the Gioia365 team looks at it." },
        },
        detail: {
            holderPrimary: "holder",
            holderSecond: "second holder",
            noPhone: "no valid number; calls in Close: {calls}; numbers in the other contacts: {others}",
            phoneFromCalls: "calls in Close: {calls}; the number of the last one applies",
            phoneFromSecond: "taken from the second holder",
            phoneFromContact: "taken from Close contact no. {contact}",
            invalidPhone: "{holder}: {reason}",
            phoneReason: {
                too_short: "number too short",
                too_long: "number too long",
                invalid_characters: "not a number",
                empty: "empty number",
                other: "invalid number",
            },
            duplicateClose: "the same {phone} is on other Close Leads: {count}",
            duplicateGioia: "on Leads already in Gioia365: {count}",
            joined: "joined to the Lead with the same mobile, which came in another way",
            joinedArchived: "joined to the archived Lead with the same mobile, which stays archived",
            phoneSlot: {
                primaryMobile: "holder's mobile",
                primaryLandline: "holder's landline",
                secondMobile: "second holder's mobile",
                other: "number",
            },
            provinceWritten: "province written in Close: {province}",
            provinceEmpty: "empty province",
            candidates: "municipalities with the same name: {count}",
            country: "Country: {country}",
            countryUnknown: "Country not given",
            italy: "Italy",
            closeStatus: "status in Close: «{status}»",
            closeStatusUnknown: "unknown status",
            option: "field «{field}»: «{value}»",
            optionNoValue: "field «{field}»",
            callOutcome: "call outcome in Close: «{value}»",
            optionReason: {
                hidden_tag: "tag hidden in Gioia365",
                field_missing: "the field is not in Gioia365",
                field_not_choice: "the field in Gioia365 is not a choice",
                option_missing: "the option is no longer in Gioia365",
            },
            conflict: "«{field}» says something different from «{target}»",
            conflictNoTarget: "«{field}» says something different",
            ownerName: "owner in Close: {name}",
            ownerReason: {
                not_linked: "not in the team",
                suspended: "not active in the team",
                not_commercial: "not a Salesperson",
                not_eligible: "cannot be the owner",
            },
            ownerUnknown: "the Close owner cannot be the owner in Gioia365",
            author: "activities of {name}: {count}",
            authorUnknown: "a Close user without a name",
            nameOneWord: "{holder}: one word only, it is in the First name",
            nameWords: "{holder}: {count} words",
            emailOf: "{holder}'s email",
            dateActivity: "date of the activity",
            dateCreated: "creation date in Close",
            dateField: "«{field}»",
            createdOn: "entry date taken from the Close field",
            lastCall: {
                no_call: "Close has a last call written, but there is no call",
                date: "in Close the last call is on another day",
                user: "in Close the last call is by another person",
                date_and_user: "in Close the last call is on another day and by another person",
            },
            missing: "no longer in Close",
            kept: "field «{field}»: the Gioia365 value stays",
            keptReason: {
                phone_repeated_on_lead: "the number is already on the Lead",
                phone_required: "at least one phone is needed",
                open_exists: "the Lead already has another open opportunity",
            },
            changed: {
                call: "call changed in Close",
                note: "note changed in Close",
                other: "activity changed in Close",
                mapping_changed: "note that would now be read differently",
                not_in_source: "note no longer in Close",
            },
            closeType: "type in Close: {type}",
            closeTypeUnknown: "unknown type",
            outOfScope: {
                Email: "email: emails are not part of Gioia365",
                EmailThread: "email thread summary: its emails come in one by one",
                SMS: "SMS: text messages are not part of Gioia365",
            },
            recordingAndVoicemail: "recording and voicemail message",
            recording: "call recording",
            voicemail: "voicemail message",
            extraContacts: "extra people: {count}",
            extraPhones: "extra numbers: {count}",
            attachments: "attachments: {count}",
            nul: "texts cleaned: {count}",
            tooLong: "field «{field}»: {length} characters, {max} fit",
            notUpdatable: {
                archived: "archived in Gioia365",
                merged: "merged into another Lead",
                missing: "no longer in Gioia365",
            },
            opportunityStage: "stage in Close: «{stage}»",
            opportunityStageUnknown: "stage without a name",
            keptOpportunity: "opportunity: the Gioia365 one stays",
            keptTask: "Task: the Gioia365 one stays",
            appointmentReason: {
                duplicate: "already in Gioia365",
                no_person: "nobody in the team booked it and the Lead has no owner",
                ambiguous: "a meeting that cannot be told to be a disco or a demo",
            },
            appointmentKind: {
                disco: "disco",
                demo: "demo",
            },
            taskReason: {
                open_exists: "the Lead already has an open callback",
                no_assignee: "nobody in the team can take it",
                unknown_type: "a Close Task type that is not a call",
                too_old: "overdue by more than 30 days",
                lead_not_updatable: "the Lead is archived or merged in Gioia365: in a note on the card",
            },
            opportunityReason: {
                open_exists: "the Lead already has an open opportunity",
                no_assignee: "nobody in the team can follow it",
                lead_not_updatable: "the Lead is archived or merged in Gioia365: in a note on the card",
            },
            opportunityMissing: {
                value_missing: "sold without a value",
                value_invalid: "a value Gioia365 does not accept",
                closer_not_linked: "sold by someone outside the team",
            },
        },
    },
    ghlRead: {
        about: {
            title: "What it is for",
            text: "Gioia365 reads contacts, emails and conversations from GoHighLevel to match them with the Leads and complete the history missing from Close. First a test run that saves nothing, then the tags are confirmed one by one, then the import: the Lead fields stay those from Close.",
            whoTitle: "Who sees it",
            who: "The Super admin and the Admin of {organization}, and the Gioia365 Super admin. The Super admin of {organization} and the Gioia365 Super admin save, remove and test the key; only the Gioia365 Super admin imports from and writes to GoHighLevel.",
        },
        denied: "GoHighLevel is seen by the Super admin and the Admin of {organization}, and by the Gioia365 Super admin: with your role you do not see it.",
        title: "Key and read test",
        intro: "A read-only key of the GoHighLevel sub-account. Gioia365 keeps it encrypted and never shows it again.",
        keyTitle: "Key",
        tokenLabel: "Private Integration Token",
        tokenHint: "Gioia365 tries it with GoHighLevel before saving it and keeps it encrypted: afterwards it is never shown again, here or anywhere else.",
        locationLabel: "Location ID",
        locationHint: "It is not a secret: it identifies the sub-account.",
        keySave: "Save the key",
        keySaving: "Trying it with GoHighLevel…",
        keySaved: "Key saved on {date} at {time} by {person}.",
        keySavedBySomeone: "Key saved on {date} at {time}.",
        keyLocation: "Location: {location}.",
        keyNone: "No key saved.",
        keyActive: "Key saved and active",
        keyChange: "Change the key",
        keyChangeCancel: "Keep the current one",
        keyRemove: "Remove the key",
        keyRemoveConfirm: "Remove the key? Gioia365 can no longer read from GoHighLevel until you save a new one.",
        keyRemoveYes: "Yes, remove the key",
        keySavedToast: "Key saved.",
        keyRemovedToast: "Key removed.",
        howTitle: "How to create the key in GoHighLevel",
        howStep1: "Enter the company's sub-account and open «Settings».",
        howStep2: "Open «Private Integrations» and press «Create new integration».",
        howStep3: "As the name write «Gioia365».",
        howStep4: "Choose only the read-only scopes: contacts.readonly, conversations.readonly, conversations/message.readonly, locations.readonly, locations/customFields.readonly, opportunities.readonly.",
        howStep5: "Create the integration and copy the token right away: GoHighLevel shows it only once.",
        howLocation: "The Location ID is in «Settings» → «Business Profile», under «Location ID»; it is also in the sub-account's address, after «/location/».",
        probeTitle: "Test reading",
        probeText: "Counts the contacts and conversations of the location and tells you only the numbers: no names, no data, nothing is written in GoHighLevel or in Gioia365.",
        probeStart: "Test reading",
        probing: "Reading from GoHighLevel…",
        probeNeedsKey: "Save the key first.",
        probeNone: "No read test with this key yet.",
        probeWhen: "Last test on {date} at {time} by {person}.",
        probeWhenBySomeone: "Last test on {date} at {time}.",
        probeToast: "Read test done.",
        probeOk: "Reading works",
        resource: { contacts: "Contacts", conversations: "Conversations" },
        count: "{what}: {count}",
        outcome: {
            rejected: "{what}: GoHighLevel does not accept the key, or it lacks a scope.",
            forbidden: "{what}: the key is not allowed to read them.",
            rate_limited: "{what}: GoHighLevel received too many requests, try again in a minute.",
            unavailable: "{what}: GoHighLevel did not answer, try again in a few minutes.",
        },
        scopes: "The read-only scopes needed: contacts.readonly, conversations.readonly, conversations/message.readonly, locations.readonly, locations/customFields.readonly, opportunities.readonly.",
        readOnlyOn: "GoHighLevel key: saved.",
        readOnlyOff: "GoHighLevel key: not saved yet.",
        readOnlyWho: "The Super admin of {organization} and the Gioia365 Super admin save and test it.",
        platformShortcut: "For the key and the buttons, enter as the Gioia365 Super admin:",
        platformShortcutButton: "Enter as the Gioia365 Super admin",
        platformPartsWho: "Importing from GoHighLevel and writing to GoHighLevel are done by the Gioia365 Super admin.",
        platformPartsShortcut: "To import from and write to GoHighLevel, enter as the Gioia365 Super admin:",
    },
    ghlWrite: {
        title: "Writing to GoHighLevel",
        intro: "Gioia365 is the main record: it keeps GoHighLevel's contacts up to date so the email automations can use them. It finds each Lead's contact from the existing link, then the email, then the mobile; if it finds more than one it writes nothing. Never between 21:00 and 22:05 (the Close import). When off, it writes nothing.",
        fields: "It writes first name, last name, email and mobile (only when Gioia365 has them: an empty value never clears), the fields {fields}, and adds the tags {tags} (never removed).",
        scopes: "To write, the token also needs the scopes: {scopes}.",
        stopped: {
            forbidden: "GoHighLevel refused the token for writing and the writing switched itself off. Create a new token that also has the scopes {scopes}, save it above, run the test again and switch it back on.",
            fields_missing: "A «G365 · …» field is gone from GoHighLevel and the writing switched itself off: switch it back on, the missing fields are created again.",
        },
        needsKey: "Save the key first.",
        loading: "Loading the writing status…",
        counts: {
            considered: "Leads looked at: {count}",
            update: "Contacts to update: {count}",
            create: "Contacts to create: {count}",
            unchanged: "Already up to date, nothing to write: {count}",
            noMatch: "Without a contact in GoHighLevel (not created): {count}",
            ambiguous: "With more than one possible contact (not written): {count}",
            rejected: "Refused by GoHighLevel: {count}",
            archived: "Archived or merged (not written): {count}",
            failed: "Failed, to retry: {count}",
        },
        dryRunTitle: "1. Test without writing",
        dryRunText: "Looks at the {count} most recently changed Leads and tells you what it would write, with a few examples with the data hidden. It only reads: nothing changes in GoHighLevel.",
        dryRunStart: "Test without writing",
        dryRunRunning: "Testing…",
        dryRunToast: "Test done: the result is below.",
        dryRunWhen: "Test of {date} at {time}, by {person}.",
        dryRunWhenNoOne: "Test of {date} at {time}.",
        dryRunOld: "This test was made with an older key: run it again.",
        noDryRun: "No test yet.",
        missingFields: "Fields to create in GoHighLevel when you switch on: {fields}.",
        examplesTitle: "Examples",
        exampleLead: "Lead",
        exampleWhat: "What it would do",
        exampleFields: "Fields and tags",
        operation: {
            update: "Updates the contact found {by}",
            create: "Creates a new contact",
        },
        matchedBy: {
            contact: "by the link",
            email: "by the email",
            phone: "by the mobile",
        },
        skip: {
            noMatch: "Nothing: no contact in GoHighLevel",
            ambiguous: "Nothing: more than one possible contact",
            archived: "Nothing: archived",
        },
        outcome: {
            ok: "It went fine.",
            forbidden: "GoHighLevel refused the token: it also needs the scopes {scopes}.",
            fields_missing: "A «G365 · …» field was missing: the writing switched off.",
            rate_limited: "GoHighLevel received too many requests: it retries at the next round.",
            unavailable: "GoHighLevel did not answer: it retries at the next round.",
            close_window: "Nothing is written between 21:00 and 22:05.",
        },
        switchTitle: "2. Switch",
        isOn: "On: every minute Gioia365 updates the contacts of the changed Leads.",
        isOff: "Off: nothing is written to GoHighLevel.",
        changed: "Changed on {date} at {time} by {person}.",
        changedNoOne: "Changed on {date} at {time}.",
        createMissing: "Create the missing contacts in GoHighLevel",
        createMissingHint: "Off: it only updates the contacts that already exist. On: a Lead with an email or mobile and no contact gets a new one, and GoHighLevel's automations can write to them.",
        needsDryRun: "It switches on after a successful test without writing with the current key.",
        turnOn: "Switch the writing on",
        turnOnYes: "Yes, switch on",
        confirm: "From now on Gioia365 updates the Leads' contacts in GoHighLevel, and GoHighLevel's automations can send emails with that data. It creates the missing «G365 · …» fields. Switch on?",
        confirmWithCreate: "From now on Gioia365 updates the contacts in GoHighLevel and creates the missing ones: GoHighLevel's automations can send emails to the new contacts too. It creates the missing «G365 · …» fields. Switch on?",
        turnOff: "Switch the writing off",
        saveSetting: "Save",
        onToast: "Writing switched on.",
        offToast: "Writing switched off.",
        roundTitle: "Last round",
        roundWhen: "On {date} at {time}.",
        noRound: "No round yet.",
        queue: "Queued: {pending} · written: {done} · not written: {skipped} · stopped after too many attempts: {failed}.",
    },
    ghlImport: {
        title: "Import from GoHighLevel",
        intro: "Matches every GoHighLevel contact with the Leads and brings in the missing history: personal emails and replies, WhatsApp, Instagram, Facebook, SMS, calls; newsletters and sequences in one line with the count. No Lead field changes. Contacts only in GoHighLevel with an Italian mobile become new Leads of {owner}, with the tag “{tag}”, in the Smart List “{list}”, without a sequence. Candidates of the hiring funnel stay out.",
        needsKey: "Save the key first.",
        closeBusy: "The Close import is running, or it is between 21:00 and 22:05 Rome time: the GoHighLevel test run and import can start again when it is done.",
        dryRunTitle: "1. Test run without saving",
        dryRunText: "Reads everything from GoHighLevel and tells you only numbers and tags: nothing is written, neither in Gioia365 nor in GoHighLevel. It can take tens of minutes (one request per conversation): the page updates by itself.",
        dryRunStart: "Test run without saving",
        dryRunStarting: "Starting…",
        dryRunToast: "Test run started: the report shows up here when it ends.",
        dryRunOld: "This test run used an earlier key: run it again.",
        running: "Running, started on {date} at {time}…",
        started: "Started on {date} at {time}.",
        finished: "Finished on {date} at {time}.",
        failed: "Did not succeed ({code}). Try again: what already came in is not duplicated.",
        noRun: "No test run yet.",
        contactsTitle: "Contacts",
        read: "Read: {count}",
        matchedByContact: "Already Leads, by GoHighLevel contact: {count}",
        matchedByEmail: "Already Leads, by email: {count}",
        matchedByPhone: "Already Leads, by phone: {count}",
        matchedArchived: "Of these archived (they get the history, not the tags): {count}",
        toCreate: "New Leads to create: {count}",
        sameNewLead: "With the mobile or email of another contact that becomes a new Lead (they join it, they do not make another): {count}",
        created: "New Leads created: {count}",
        ownerMissing: "{owner} is not in the Team as an active User: without them the import does not start.",
        candidates: "Hiring funnel candidates, left out: {count} (already Leads: {already})",
        uncertain: "Uncertain (signs of a candidacy and of a salon): {count}; already Leads, matched: {matched}; not becoming Leads: {notCreated}",
        discardedTitle: "Not becoming Leads",
        noItalianMobile: "Without an Italian mobile: {count}",
        notQualified: "Type “not qualified”: {count}",
        notHairdresser: "“Are you a hairdresser?” = No: {count}",
        pipelineRead: "Hiring pipelines read: {pipelines}, with {count} contacts",
        pipelineUnreadable: "The key cannot read opportunities: the hiring pipeline was not checked (tags, source and form still are).",
        conversationsTitle: "Conversations",
        conversations: "Read: {count}; of contacts left out, not read: {outOfScope}",
        channelLine: "{channel}: {single} as a line, {counted} in the count",
        skippedTitle: "Not coming in (GoHighLevel activities and other types)",
        skippedLine: "{kind}: {count}",
        channels: { email: "Email", whatsapp: "WhatsApp", instagram: "Instagram", facebook: "Facebook", sms: "SMS", call: "Calls" },
        requests: "Requests to GoHighLevel: {count}",
        incomplete: "GoHighLevel says {contacts} contacts and {conversations} conversations; {read} and {readConversations} were read: the reading is incomplete, run the test run again before importing.",
        gapTolerated: "GoHighLevel says {contacts} contacts and {conversations} conversations; {read} and {readConversations} were read. The difference stays under 0.1% (usually items deleted or listed twice on its side): you can import.",
        tagsTitle: "2. Tags, one by one",
        tagsText: "Tick the tags that come onto the Leads: they are added, never removed. Campaigns come in by default; technical and hiring tags do not. Nothing is imported until you confirm.",
        tagsNone: "No tags on the contacts.",
        tagColumn: "Tag",
        contactsColumn: "Contacts",
        destinyColumn: "Kind",
        enterColumn: "Comes in",
        destiny: { enter: "campaign", technical: "technical", candidates: "hiring" },
        tagsConfirm: "Confirm the tags",
        tagsConfirming: "Saving…",
        tagsConfirmed: "Tags confirmed on {date} at {time} by {person}: {count} come in.",
        tagsConfirmedBySomeone: "Tags confirmed on {date} at {time}: {count} come in.",
        tagsToast: "Tags confirmed.",
        importTitle: "3. Import now",
        importText: "Writes into Gioia365 what the test run showed, with the confirmed tags. It can be run again: nothing comes in twice.",
        importNeeds: "First a test run finished with the current key and its tags confirmed.",
        importStart: "Import now",
        importConfirm: "Import from GoHighLevel now? The new Leads are created and the history goes into the Timelines.",
        importYes: "Yes, import",
        importToast: "Import started: the report shows up here when it ends.",
        writtenTitle: "Written",
        leadsCreated: "New Leads: {count} (already created before: {already})",
        tagsAdded: "Tags added to Leads: {count}",
        messagesWritten: "Messages in as a line: {count}",
        summariesWritten: "Count lines: {count}",
        alreadyImported: "Already in before, not repeated: {count}",
        smartList: { created: "Smart List “{list}” created.", existing: "Smart List “{list}” already there.", missing: "Smart List “{list}” not created." },
    },
    appointments: {
        headerButton: "Book disco or demo",
        kind: { disco: "Disco", demo: "Demo" },
        dialog: {
            title: "Book disco or demo",
            moveTitle: "Move: {kind} on {when}",
            kind: "What are you booking",
            day: "Day",
            time: "Time",
            minutes: "Duration in minutes",
            minutesHint: "From 5 to 480 minutes.",
            colleague: "Colleague to invite",
            noColleague: "No colleague",
            leadEmail: "Lead email",
            leadEmailHint: "Needed for the Google Calendar invitation.",
            withCalendar: "An event with a Meet link is created on your Google Calendar: the invitation goes to the Lead and to the chosen colleague.",
            withoutCalendar: "Your Google Calendar is not connected: the appointment stays only in Gioia365 and the link is sent with WhatsApp.",
            withoutEmail: "Without the Lead's email the appointment stays only in Gioia365 and the link is sent with WhatsApp.",
            save: "Book",
            move: "Move",
            saved: "{kind} booked for {when}.",
            moved: "{kind} moved to {when}.",
            exists: "This Lead already has an open {kind}: move or close it from the Summary.",
            invalidTime: "Choose a valid day and time.",
        },
        block: {
            title: "Disco and demo",
            opportunity: "Opportunity: {stage}",
            reschedule: "to be rescheduled",
            item: "{kind} · {when} · {minutes} min",
            meet: "Open the Meet link",
            files: {
                transcript: "Transcript",
                notes: "Gemini notes",
                recording: "Recording",
                opensGoogle: "{name}: opens in Google, with Google's permissions",
                waiting: "Transcript and recording: Gioia365 looks for them in Google after the Meet ends, for up to 7 days.",
                none: "Google has no transcript or recording of this Meet: they must be turned on in the Meet.",
                unavailable: "Transcript not readable: the Google Calendar of whoever booked it is no longer connected.",
                no_calendar: "No transcript in Gioia365: this {kind} is not on Google Calendar. It arrives by itself when it is booked by someone who connected Google Calendar from «Your account».",
            },
            calendar: {
                created: "On Google Calendar",
                pending: "Google Calendar being updated",
                failed: "Google Calendar not updated: the appointment stays in Gioia365",
                not_connected: "Only in Gioia365",
            },
            status: { open: "Scheduled", done: "Closed", canceled: "Canceled" },
            result: { held: "Held", no_show: "The Lead did not show up" },
            held: "Held",
            heldMinutes: "Actual minutes (optional)",
            saveHeld: "Mark as held",
            noShow: "The Lead did not show up",
            move: "Move",
            cancel: "Cancel",
            cancelReason: "Reason for canceling",
            cancelConfirm: "Cancel the appointment",
            keep: "Keep it",
            afterStart: "Results can be recorded from the appointment time.",
            saved: "Result saved.",
            canceled: "Appointment canceled.",
        },
        stages: {
            disco_booked: "Disco booked",
            disco_held: "Disco held",
            demo_booked: "Demo booked",
            demo_held: "Demo held",
            sold: "Sold",
            lost: "Lost",
        },
        step: {
            question: "Book the {kind}: after this result it is required.",
            open: "Book",
            done: "{kind} booked for {when}",
        },
        account: {
            title: "Google Calendar",
            help: "Connect your Google Calendar: the discos and demos you book are created there, with the Meet link.",
            connected: "Connected to {email}.",
            notConnected: "Not connected.",
            revoked: "Disconnected: you can connect it again.",
            failed: "The connection no longer works: connect it again.",
            unavailable: "Google Calendar is not available in Gioia365 yet: the platform administrator turns it on.",
            connect: "Connect Google Calendar",
            disconnect: "Disconnect",
            disconnected: "Google Calendar disconnected.",
            justConnected: "Google Calendar connected.",
            justFailed: "The connection with Google did not succeed. Try again from Your account.",
        },
        tasks: {
            what: "{kind} · {when} · {minutes} min",
            offAppointments: "Discos and demos are not called in a cascade: the Power Dialer only takes callbacks.",
            meet: "Meet",
        },
        banner: {
            title: "{kind} at {time} with {lead}",
            soon: "in {minutes} min",
            announce: "Reminder: {kind} at {time} with {lead}.",
            meet: "Open Meet",
            dismiss: "Close the reminder",
        },
        timeline: {
            booked: "{kind} booked for {when} · {minutes} min",
            rescheduled: "{kind} moved to {when}",
            canceled: "{kind} canceled",
            canceledReason: "Reason: {reason}",
            held: "{kind} held",
            noShow: "{kind}: the Lead did not show up",
            opportunityOpened: "Opportunity opened: “{stage}”",
            stageChanged: "Opportunity: from “{before}” to “{after}”",
            stageNow: "Opportunity: “{stage}”",
            // A historical Close disco or demo (22/10/2026).
            imported: "{kind} booked in Close, imported",
            importedWhen: "For {when}",
            importedOutcome: {
                held: "Held",
                canceled: "Canceled in Close",
                unknown: "Outcome not written in Close: not counted among the ones to do",
            },
        },
    },
    opportunities: {
        title: "Opportunities",
        headerButton: "Opportunity",
        openCount: "{count} open",
        intro: "Every booked disco opens an opportunity. Here you see where each one stands: disco, demo, up to “Sold” or “Lost”. The Lead status does not change by itself.",
        layoutLabel: "How to view them",
        layouts: { board: "By stage", table: "Table" },
        viewsLabel: "Which",
        views: { open: "Open", sold: "Sold", lost: "Lost", all: "All" },
        who: "Whose",
        wholeTeam: "Whole team",
        campaign: "Campaign",
        allCampaigns: "All",
        search: "Search a Lead or a target company",
        totalsLabel: "Where the work stands",
        totals: {
            disco_booked: "Discos to do",
            disco_held: "Discos done, demo to book",
            demo_booked: "Demos to do",
            demo_held: "Demos done, to close",
            sold: "Sold in {month}",
            lost: "Lost in {month}",
        },
        countWithValue: "{count} · {value}",
        stages: {
            disco_booked: "Disco booked",
            disco_held: "Disco held",
            demo_booked: "Demo booked",
            demo_held: "Demo held",
            sold: "Sold",
            lost: "Lost",
        },
        none: "None",
        noShow: "Did not show up: to reschedule",
        reschedule: "To reschedule",
        empty: "No opportunities here.",
        emptyFiltered: "Change the search or the campaign.",
        emptyHint: "An opportunity opens when you book a disco or a demo: from «New opportunity» above or from the Lead card.",
        newButton: "New opportunity",
        newDialog: {
            title: "New opportunity",
            intro: "Choose what you book and the Lead: the opportunity opens with the booking.",
            kind: "What you book",
            search: "Search the Lead: name, salon or phone",
            typeMore: "Type at least two letters.",
            noLead: "No Lead found among those you see.",
            results: "Leads found",
            unnamed: "Unnamed Lead",
        },
        more: "Show more",
        caption: "Opportunities, by stage and then by date",
        columns: {
            lead: "Lead",
            stage: "Stage",
            next: "Next step",
            assignee: "Sales rep",
            bookedBy: "Booked by",
            closedBy: "Closed by",
            value: "Value",
            campaign: "Campaign",
            openedAt: "Opened on",
        },
        next: {
            disco_booked: "Disco {when}",
            disco_held: "Disco held {when}: book the demo",
            demo_booked: "Demo {when}",
            demo_held: "Demo held {when}: Sold or Lost?",
            sold: "{product} · {value} · {date}",
            lost: "Lost on {date}: {reason}",
        },
        step: {
            disco_booked: "Disco to do",
            disco_held: "Disco held, demo to book",
            demo_booked: "Demo to do",
            demo_held: "Demo held, to close",
            at: "{step} · {when}",
        },
        products: { club: "Club", percorso: "Percorso" },
        lostReasons: {
            not_interested: "Not interested",
            price: "Price",
            timing: "Timing",
            competitor: "Competitor",
            unreachable: "No longer answers",
            other: "Other",
        },
        reasonWithNote: "{reason} · {note}",
        detail: {
            title: "Opportunity of {name}",
            status: "{salon} · status “{status}”: the opportunity stage does not change it.",
            statusNoSalon: "Status “{status}”: the opportunity stage does not change it.",
            steps: "Stages",
            step: { disco: "Disco", demo: "Demo", sold: "Sold" },
            reached: "reached",
            notReached: "not yet",
            stage: "Stage",
            next: "Next step",
            owner: "Sales rep (Lead owner)",
            bookedBy: "Disco booked by",
            closedBy: "Closed by",
            product: "What they bought",
            value: "Value",
            contract: "Contract type",
            offer: "Offer made",
            payFrom: "Pays from",
            bonus: "Bonus",
            campaign: "Campaign",
            openedAt: "Opened on",
            history: "How it went",
            opened: "The opportunity opens",
            appointment: {
                open: "{kind} scheduled",
                held: "{kind} held",
                no_show: "{kind}: did not show up",
                canceled: "{kind} canceled",
            },
            sold: "Sold: {product} · {value}",
            lost: "Lost. Reason: {reason}",
            howTo: "The stage changes from the Lead card, in the “Opportunity” window and in “Disco and demo”: each step asks for its data (day and time, minutes, reason or value) and ends up in the Timeline.",
            open: "Update in the Lead card",
        },
        box: {
            title: "Opportunity",
            stage: "Stage",
            next: "Next step",
            noneOpen: "None open",
            note: "The Lead status stays separate: it does not change with the opportunity.",
            open: "Open the opportunity",
            notVisible: "This Lead's open opportunity is not among the ones you see: its stage is in “Disco and demo”.",
        },
        window: {
            stageNow: "Stage now:",
            stageWith: "{stage} · {detail}",
            sale: "{product} · {value}",
            none: "No open opportunity",
            whatHappened: "What happened?",
            toOpen: "To open an opportunity",
            bookDisco: "Book disco",
            bookDemo: "Book demo",
            sold: "Sold",
            lost: "Lost",
            appointments: "Discos and demos held, missed, moved or canceled are marked in the “Disco and demo” box.",
            final: "Final stage. Later on, the customer will be created from here in the administration module.",
            readOnly: "{name} follows it: you can see it, not change it.",
            reopen: "Reopen",
            reopened: "Opportunity reopened: back to “{stage}”.",
            statusNote: "The Lead status never changes by itself: you change it from the Status menu.",
        },
        soldDialog: {
            title: "Sold",
            product: "What they bought",
            choose: "Choose",
            productMissing: "Choose Club or Percorso.",
            value: "Value in € · required",
            valueMissing: "Enter the sale value in euros.",
            contract: "Contract type",
            contractPlaceholder: "For example: 12 months",
            offer: "Offer",
            paymentStart: "Payment start date",
            bonus: "Bonus",
            closer: "Who closed it",
            closerMissing: "Choose who closed the sale.",
            save: "Record the sale",
            saved: "Sale recorded. The status stays “{status}”: if needed, change it yourself from the Status menu.",
        },
        lostDialog: {
            title: "Lost",
            reason: "Why is the opportunity lost? · required",
            choose: "Choose the reason",
            reasonMissing: "Choose the reason.",
            note: "Notes",
            notePlaceholder: "For example: chose another course, no budget",
            noteHint: "With “Other” the note is required.",
            noteMissing: "Write the reason: it stays in the Timeline.",
            save: "Mark as lost",
            saved: "Opportunity marked as lost. The Lead status does not change.",
        },
        timeline: {
            sold: "Sold · {product} · {value}",
            closedBy: "Closed by {name}",
            lost: "Opportunity lost",
            reason: "Reason: {reason}",
            imported: "Opportunity from Close: «{stage}»",
            importedChanged: "Opportunity from Close: from «{before}» to «{after}»",
            importedValue: "Value: {value}",
        },
    },
    reports: {
        title: "The numbers of the work",
        intro: "Like your «KPI SALES INDIVIDUALE» sheet: calls, disco, demo and closings, with the same formulas. The starting period is the Month.",
        tabsLabel: "Which report",
        introCampaigns: "Like your «Vendite per campagne» sheet: where the Leads come from, who worked them, what they bought and for how much.",
        tabs: { sales: "Sales team", campaigns: "Campaigns" },
        status: "Report «{tab}», {range}.",
        controls: {
            label: "Period and people",
            period: "Period",
            customMissing: "Choose both dates.",
            customOrder: "«From» comes after «To»: swap them.",
            customFuture: "The latest day is today, {day}.",
            customTooLong: "One year at most: choose a shorter period.",
            who: "Whose",
            wholeTeam: "Whole team",
            whoHint: "Nobody chosen means «Whole team». Choose more than one to add them up.",
            inactive: "no longer active",
        },
        range: {
            dayName: "{weekday} {date}",
            dayUntil: "{day}, until {time}",
            days: "from {from} to {to}",
            daysUntil: "from {from} to {to}, today until {time}",
        },
        // The days of the week of the Report, long and short.
        weekday: {
            long: { "1": "Monday", "2": "Tuesday", "3": "Wednesday", "4": "Thursday", "5": "Friday", "6": "Saturday", "7": "Sunday" },
            short: { "1": "Mon", "2": "Tue", "3": "Wed", "4": "Thu", "5": "Fri", "6": "Sat", "7": "Sun" },
        },
        compare: {
            day: "The arrows compare with {day}.",
            dayUntil: "The arrows compare with {day}, until {time}.",
            days: "The arrows compare with the {count} days before: from {from} to {to}.",
            daysUntil: "The arrows compare with the {count} days before: from {from} to {to}, the last one until {time}.",
        },
        scope: {
            own: ": you see only your own numbers. Colleagues do not appear, not even in the totals.",
            watchingLead: "As {name} sees it",
            watching: ": only their own numbers, without colleagues.",
            team: "Whole team",
            teamCount: ": {count} salespeople, nobody chosen.",
            teamCountOne: ": 1 salesperson, nobody chosen.",
            one: "One person",
            many: "{count} people",
            chosen: ": {names}. The numbers are the sum, with each Lead counted once.",
        },
        summary: {
            team: "The team's numbers",
            person: "The numbers of {name}",
            people: "The numbers of the {count} people chosen",
            own: "Your numbers",
            intro: "The groups and numbers of the «KPI SALES INDIVIDUALE» sheet, with the same formulas. They are the same numbers as the Home and, for closings, the Opportunities page.",
            footnote: "Targets: «8–10%» of disco on calls and «at least 50%» demo show-up are already decided; the others come from your «Calcolo Sales» sheet and are changed in Settings → «Goals». Percentages are recalculated on the totals, never averaged over people. Calls, answers and minutes come from telephony; disco, demo and sales from appointments and «Sold»; what is entered by hand counts the same and stays recognisable.",
            callsSub: "{count} closed early, under 20 seconds: excluded",
            callsManual: " · {count} entered by hand",
            fromClose: " · {count} from Close, historical",
            minutesSub: "calls {calls} · disco {disco} · demo {demo}",
        },
        groups: { calls: "Calls", disco: "Disco", demo: "Demo", closings: "Closings" },
        kpis: {
            calls: { label: "Calls made", short: "Calls", how: "the valid calls" },
            answered: { label: "Answered calls", short: "Answered" },
            answerRate: { label: "% answered", short: "% answered", how: "answered ÷ made" },
            leads: { label: "Different Leads called", short: "Different Leads", how: "each counts once in the period" },
            leadRate: { label: "% of Leads who answered", short: "% Leads answered", how: "Leads who answered ÷ different Leads called" },
            minutes: { label: "Minutes on the phone", short: "Minutes on the phone", how: "calls, disco and demo" },
            discoBooked: { label: "Disco booked", short: "Booked", how: "to whoever booked them" },
            discoOnCalls: { label: "Disco on calls", short: "On calls", how: "booked ÷ calls made" },
            discoOnAnswered: { label: "Disco on answers", short: "On answers", how: "booked ÷ answered calls" },
            discoDue: { label: "Disco due", short: "Due", how: "with the time in the period, cancelled ones removed" },
            discoHeld: { label: "Disco held", short: "Held", how: "closed with «Done»" },
            discoShow: { label: "% disco show-up", short: "% show-up", how: "held ÷ due" },
            discoRescheduled: { label: "Disco rescheduled", short: "Rescheduled", how: "«Moved» with the new day" },
            demoBooked: { label: "Demo booked", short: "Booked", how: "to whoever booked them" },
            demoOnDisco: { label: "Demo on disco", short: "On disco", how: "demo booked ÷ disco held" },
            demoDue: { label: "Demo due", short: "Due", how: "with the time in the period, cancelled ones removed" },
            demoHeld: { label: "Demo held", short: "Held", how: "closed with «Done»" },
            demoRescheduled: { label: "Demo rescheduled", short: "Rescheduled", how: "«Moved» with the new day" },
            demoShow: { label: "% demo show-up", short: "% show-up", how: "held ÷ due" },
            closings: { label: "Closings", short: "Closings", how: "«Sold», to whoever closed" },
            closeRate: { label: "% close rate", short: "% close rate", how: "closings ÷ demo held" },
            value: { label: "Value of the closings", short: "Value", how: "the sum of the values of «Sold»" },
            averageValue: { label: "Average value of a closing", short: "Average value", how: "value ÷ closings" },
        },
        headTitle: "{label} · {how}",
        delta: {
            points: "{sign}{value} points",
            decimal: ".",
            percent: "{sign}{value}%",
            first: "none before",
            stable: "steady",
            title: "Period before: {value}",
            hidden: " compared with the period before, which had {value}",
        },
        target: {
            range: "target {min}–{max}%",
            atLeast: "target at least {min}%",
            exact: "target {min}%",
            badge: "{target} · {word}",
            cell: "{target}: {word}",
            hidden: " ({target}: {word})",
            cardHidden: " ({word})",
            words: { below: "below", inLine: "on track", above: "above" },
        },
        marks: { ok: "✓", below: "↓" },
        table: {
            groups: { summary: "Summary", calls: "Calls", disco: "Disco", demo: "Demo", closings: "Closings", all: "All, as in the sheet" },
            cardKey: "{calls} · {closings}",
            callsOne: "1 call",
            callsMany: "{count} calls",
            closingsOne: "1 closing",
            closingsMany: "{count} closings",
            countedOnce: "Leads counted once",
            wideNote: "With all the columns the table is as wide as the sheet and scrolls sideways in its frame; the name stays fixed on the left.",
        },
        team: {
            title: "One row per salesperson",
            intro: "Like the month's sheet: one row per person and the total. In green with ✓ the target reached, in orange with ↓ the one missed.",
            groupsLabel: "Columns of the team table",
            caption: "The numbers of each salesperson, {range}",
            firstHead: "Salesperson",
            total: "Whole team",
            totalChosen: "Total of the people chosen",
        },
        days: {
            title: "Day by day",
            intro: "{whose}: one row per working day, the most recent at the top, and the total, like the rows of the sheet.",
            groupsLabel: "Columns of the day-by-day table",
            caption: "Day by day, {range}",
            firstHead: "Day",
            total: "Total of the period",
            note: "In the total «Different Leads» is lower than the sum of the days: a Lead called on several days counts once. Closed days (Saturday, Sunday, holidays) appear only if someone worked.",
        },
        trend: {
            title: "Trend",
            metricsLabel: "What the trend shows",
            metrics: { calls: "Calls", discoBooked: "Disco booked", demoHeld: "Demo held", closings: "Closings" },
            counts: {
                discoBookedOne: "1 disco booked",
                discoBookedMany: "{count} disco booked",
                demoHeldOne: "1 demo held",
                demoHeldMany: "{count} demo held",
            },
            bar: "{day}: {count}",
            barAnswered: "{day}: {count}, {answered} answered",
            chartDays: "{metric} day by day, {range}",
            chartHours: "Calls hour by hour, {range}",
            summary: "Average per working day: {now}; in the period before {before} (the dashed line).",
            summaryNoBefore: "Average per working day: {now}; the period before had no working days.",
            answeredBlue: " In blue the answered calls.",
            hourly: "On a single day the trend is hour by hour, for calls: in blue the answered ones.",
            average: "average of the period before: {value}",
            notAnswered: "Not answered",
            answered: "Answered",
            legendNote: "The number above each bar; the detail of each day is in «Day by day».",
            legendNoteHourly: "The number above each bar.",
        },
        hours: {
            span: "from {from} to {to}",
            bar: "{span}: {what}",
            cell: "{weekday} {span}: {what}",
            calls: "{calls}, {answered} answered",
            rate: " ({rate})",
            pause: "break between morning and afternoon",
            friday: "closed, on Friday calls are made only in the morning",
            closed: "closed",
            withCalls: "{state}; {calls}",
        },
        heat: {
            title: "When calls are made",
            introPeriod: "The calls of the period summed by weekday and hour: the bluer, the more calls, and the number is written inside. Hover over a square, or tap it, for the answers.",
            introDay: "The calls of the day hour by hour: the bluer, the more calls, and the number is written inside. Hover over a square, or tap it, for the answers.",
            mapLabel: "Map of calls by day and hour",
            hint: "Hover over a square, or tap it, to see calls and answers.",
            detail: "{sentence}.",
            legend: "Striped: {parts}, when the sequence does not call.",
            legendPause: "{from}–{to} break",
            legendFriday: "Friday afternoon",
            legendClosed: "outside working hours",
        },
        campaigns: {
            title: "The campaigns",
            whoseTeam: "Whole team.",
            whoseChosen: "Leads that came in with {names} as owner, their disco and their sales.",
            whoseOwn: "Only yours: the Leads that came to you as owner, the disco you booked, the sales you closed.",
            intro: "{whose} Each Lead stays in the campaign it first came from, even if it later comes back from another one.",
            caption: "The campaigns, {range}",
            firstHead: "Campaign or list",
            columns: {
                fresh: { label: "New Leads", how: "came in for the first time from here" },
                back: { label: "Returning", how: "Leads that already existed, came in again from here" },
                disco: { label: "Disco booked", how: "of the Leads that first came in from here" },
                closings: { label: "Sales", how: "«Sold», to who closed" },
                closeRate: { label: "% close rate", how: "sales ÷ demo held of the Leads that first came from here" },
                value: { label: "Value", how: "sum of the «Sold» values" },
                average: { label: "Average value", how: "value ÷ sales" },
            },
            total: "All campaigns",
            noSource: "No source",
            salesOne: "1 sale",
            salesMany: "{count} sales",
        },
        campaignSales: {
            title: "Sales by campaign",
            introTeam: "One row per sale, as in your sheet, grouped by campaign; within each, the most recent on top.",
            introOwn: "The sales you booked or closed, one row per sale.",
            caption: "Sales by campaign, {range}",
            productUnknown: "Not stated",
            columns: {
                lead: "Lead",
                date: "Date",
                campaign: "Campaign or list",
                who: "Who did what",
                product: "What they bought",
                offer: "Offer and payment",
                value: "Value",
            },
            group: "{campaign} · {sales} · {value}",
            hiddenLead: "A Lead you do not see",
            salonCity: "{salon} · {city}",
            field: "{label}: {value}",
            fields: { addetti: "Staff", ficheMedia: "Average ticket", presenzeMensili: "Monthly visits" },
            latest: "Latest entry: {campaign}, {day}",
            disco: "Disco: {name}, {day}",
            demo: "Demo: {name}, {day}",
            noDisco: "No disco",
            noDemo: "No demo",
            closedBy: "Closed by: {name}",
            countsTo: "Counts to {name}, who closed",
            contract: "Contract type: {contract}",
            offer: "Offer proposed: {offer}",
            noOffer: "No offer proposed",
            payFrom: "Pays from {day}",
            bonus: "Bonus: {bonus}",
            noBonus: "No bonus",
            card: {
                key: "{day} · {value}",
                salon: "Target company",
                campaign: "Campaign or list",
                latest: "Latest entry",
                disco: "Disco",
                demo: "Demo",
                closedBy: "Closed by",
                product: "What they bought",
                offer: "Offer proposed",
                payFrom: "Pays from",
                bonus: "Bonus",
                personDay: "{name}, {day}",
                campaignDay: "{campaign}, {day}",
                productContract: "{product}, {contract}",
                noOffer: "none",
                noBonus: "none",
            },
            empty: "No sales in the period.",
            emptyHint: "The campaigns above brought Leads and disco, but nobody has bought yet: try the «Month».",
            footnote: "«Who did what» comes from the appointments and from «Sold»: it replaces the notes written by hand in the sheet. The dates and values of «Sold» are those written by who closed.",
        },
        // «Goals of the month» (plan M7, Task 6).
        goals: {
            title: "Goals of the month",
            intro: "From {from} to {to}, whatever period is chosen above. Like your «Calcolo Sales» sheet: from the sales goal it works back to the closings, demos, discos and calls needed. The black mark on the bar is where you should be today, on working day {day} of {days}.",
            goalOwn: "Your goal: {value}",
            goalTeam: "Team goal: {value}",
            goalPerson: "Goal of {name}: {value}",
            goalPeople: "Goal of the chosen people ({names}): {value}",
            averageSale: "Average value of a sale: {value}",
            callsPerDay: "Calls per day: {needed} needed, the average is {average}",
            partial: "People with a goal: {with} of {of}; the others have none for this month and their numbers do not count here.",
            steps: {
                value: "Sales of the month",
                closings: "Closings",
                demoHeld: "Demos held",
                demoDue: "Demos due",
                discoHeld: "Discos held",
                discoDue: "Discos due",
                calls: "Calls",
            },
            how: {
                value: "the goal, in euro",
                closings: "goal ÷ average value of {value}",
                demoHeld: "closings ÷ close rate {rate}",
                demoDue: "demos held ÷ show-up {rate}",
                discoHeld: "demos due ÷ demos on disco {rate}",
                discoDue: "discos held ÷ show-up {rate}",
                calls: "discos ÷ disco on calls {rate}",
            },
            of: { consonant: "of ", vowel: "of " },
            needed: "Needed in the month: {value}",
            done: "Done since {day}: {value}",
            projected: "At this pace at the end of the month: {value}",
            separator: " · ",
            status: { inLine: "on track", slightlyBehind: "slightly behind", behind: "behind" },
            bar: "{label}: done {done} of {needed}; today you should be at {expected}%",
            footnote: "Goal, average value and percentages are set by the Super admin in Settings → «Goals», person by person. Commissions and company revenue, which the sheet has, are not here.",
            missingGoal: "No goal for the month from {from} to {to}.",
            missingAverage: "The average value of a sale is missing: it is written in Settings → «Goals».",
            setGoals: "Set the goals",
        },
        blocks: {
            title: "The day in 30-minute blocks",
            intro: "{name}, {day}. Each bar is half an hour: above, the calls, in blue the answered ones; below, in «+N», the other activities in the CRM (notes, WhatsApp, Tasks).",
            dayUntil: "{day}, until {time}",
            person: "Person",
            day: "Day",
            barsLabel: "The day in 30-minute blocks",
            facts: { phone: "On the phone", screen: "Only at the computer", idle: "Idle", calls: "Calls" },
            blocksOne: "1 block",
            blocksMany: "{count} blocks",
            factBlocks: "{blocks} · {time}",
            factCalls: "{calls} · {answered} answered · {time}",
            states: { phone: "on the phone", screen: "only at the computer", idle: "idle", pause: "break", closed: "closed", future: "not yet" },
            span: "From {from} to {to}: {state}",
            numbers: "{span} · {calls}, {answered} answered, {time} on the phone · {activities} (notes, WhatsApp, Tasks)",
            callsOne: "1 call",
            callsMany: "{count} calls",
            activitiesOne: "1 other activity",
            activitiesMany: "{count} other activities",
            extra: "+{count}",
            hint: "Hover over a bar, or tap it, to see what happened in that half hour.",
            detail: "{sentence}.",
            legendStriped: "Striped: {parts}",
            legendPause: "break {from}–{to}",
            legendClosed: "closed",
            legendFuture: "not yet",
            off: "The day in 30-minute blocks is off. It is switched on once the company has given the notice to the sales team.",
            turnOn: "Switch on for {company}",
            turnOff: "Switch off for {company}",
            confirmTitle: "Switch on the day in blocks for {company}?",
            confirm: "Whoever sees the team reports will see each person's day, half hour by half hour; each salesperson their own. Switch it on only after the notice to the sales team.",
            confirmAction: "Switch on",
            loading: "Reading the day…",
            error: "I cannot read the day right now.",
            noWorkingDay: "There is no working day in the chosen period.",
        },
        states: {
            loading: "Reading the numbers of the period…",
            emptyTitle: "No numbers in this period",
            empty: "{range}: no calls, no appointments and no sales. They were closed days, or nobody worked.",
            emptyChosen: "{range}: no calls, no appointments and no sales by the people chosen. They were closed days, or nobody worked.",
            emptyCampaigns: "{range}: no Leads came in, no disco and no sales. They were closed days, or nobody worked.",
            emptyCampaignsChosen: "{range}: no Leads came in, no disco and no sales of the people chosen. They were closed days, or nobody worked.",
            goToMonth: "See the «Month»",
            errorTitle: "I cannot read the numbers right now",
            error: "Gioia365 did not answer. I will not show old numbers as if they were current: try again shortly.",
            noAccessTitle: "Reports are not among the things you see",
            noAccess: "Your role does not have «Reports and Home numbers → View». If you need them, ask the Super admin: it is changed in Settings → «Roles and permissions».",
            home: "Back to Home",
        },
    },
    activity: {
        title: "Who did what",
        introTeam: "Every action of the company, automatic ones included, newest first. The detail is in the Lead's Timeline.",
        introOwn: "Your actions, newest first. The detail is in the Lead's Timeline.",
        introWatching: "The actions {name} sees, newest first.",
        caption: "The actions of the period, newest first",
        columns: {
            when: "When",
            who: "Who",
            what: "What",
            lead: "Lead",
            action: "Open",
        },
        group: "What",
        allGroups: "All actions",
        groups: {
            calls: "Calls",
            outcomes: "Outcomes",
            notes: "Notes",
            whatsapp: "WhatsApp",
            status: "Status",
            owner: "Owner",
            tasks: "Tasks and callbacks",
            appointments: "Disco and demo",
            opportunities: "Opportunities",
            sequence: "Call sequence and Power Dialer",
            lead_data: "Other Lead data",
            imports: "Imports",
            settings: "Settings and Smart Lists",
            platform: "Gioia365 accesses",
        },
        more: "Show more actions",
        loadingMore: "Loading more actions…",
        empty: "No actions in this period.",
        emptyHint: "Try another period, remove a filter or search another Lead.",
        automatic: "automatic",
        fromClose: "from Close",
        platformActor: "Gioia365 · {name}",
        viewOf: "viewing as {name}",
        leadArchived: "archived",
        leadMerged: "merged into a Lead you do not see",
        leadMergedInto: "merged into {name}",
        hiddenLead: "A Lead you do not see",
        hiddenAction: "{group}: action on a Lead you do not see",
        noLead: "—",
        openInTimeline: "Open in the Timeline",
        note: "Note written",
        memo: "Call memo",
        platformPath: "{method} {path}",
        skippedRoles: "Roles left as they were: {names}",
        noAccessTitle: "«Activity» is not among the things you see",
        noAccess: "Your role does not have «Activity → View». If you need it, ask the Super admin: it is changed in Settings → «Roles and permissions».",
        types: {
            whatsappPrepared: "WhatsApp prepared",
            whatsappDeclaredSent: "WhatsApp marked as sent",
            whatsappSent: "Official WhatsApp sent",
            whatsappFailed: "WhatsApp not delivered",
            whatsappReceived: "WhatsApp received from the Lead",
            dialerStarted: "Power Dialer started · {name}",
            dialerInterrupted: "Power Dialer interrupted · {name}",
            dialerFinished: "Power Dialer finished · {name}",
            dialerPaused: "Power Dialer paused · {name}",
            dialerResumed: "Power Dialer resumed · {name}",
            callerNumberAdded: "Office mobile added",
            callerNumberVerified: "Office mobile verified",
            callerNumberVerificationFailed: "Office mobile verification failed",
            callerNumberAssigned: "Office mobile given to a person",
            callerNumberUnassigned: "Office mobile taken from a person",
            callerNumberRemoved: "Office mobile removed",
            whatsappSenderSet: "A person's WhatsApp set",
            whatsappTemplateUpdated: "WhatsApp template changed",
            whatsappSettingsUpdated: "«Reply STOP» line changed",
            leadFieldsPublished: "Card fields published",
            leadVisibilityChanged: "«Who sees the Leads» changed",
            tableLayoutPublished: "Company view saved",
            callSequenceChanged: "Call sequence changed",
            whatsappChannelsChanged: "Company WhatsApp changed",
            assignmentChanged: "Lead assignment changed",
            reportGoalsChanged: "Goals changed",
            workBlocksChanged: "30-minute day turned on or off",
            leadIntakeChanged: "Lead intakes changed",
            intakeAddressCopied: "Intake address copied",
            intakeAddressRotated: "Intake address changed",
            smartListCreated: "Smart List «{name}» created",
            smartListSaved: "Smart List «{name}» saved",
            smartListShared: "Smart List «{name}» shared",
            smartListRenamed: "Smart List renamed to «{name}»",
            smartListArchived: "Smart List «{name}» archived",
            tagCreated: "Tag «{name}» created",
            importCompleted: "Import completed",
            leadDeleted: "Lead deleted for good",
            phoneMarkedWrong: "Number marked as wrong",
            platformAccess: "The Gioia365 manager opened the company's data",
        },
    },
    // Settings → "Connections" (M7 part 2): a block of its own, at the end, so the others stay untouched.
    connections: {
        menu: "Connections",
        about: {
            title: "What it is for",
            text: "Here you see in one place whether {organization}'s connections work: phone, WhatsApp, lead intake, Google, Close and email. This page changes nothing: each row says what is missing and where to fix it.",
            whoTitle: "Who sees it",
            who: "The company's Admin and Super admin, and the Gioia365 Super admin. No phone numbers, emails or keys: only states, counts and the names of team members.",
        },
        groups: {
            calls: "Calls",
            whatsapp: "WhatsApp",
            intake: "Lead intake",
            other: "Other connections",
        },
        items: {
            telephony: "Phone",
            callerNumbers: "Office mobiles",
            whatsappOfficial: "Official WhatsApp",
            whatsappAgile: "WhatsApp Agile",
            whatsappManual: "WhatsApp by hand",
            intakeMeta: "Meta forms",
            intakeWeb: "Website and landing pages",
            intakeGhl: "GoHighLevel",
            google: "Google Calendar",
            closeImport: "Import from Close",
            email: "System email",
        },
        state: {
            working: "Working",
            incomplete: "To complete",
            off: "Off",
            error: "Not working",
        },
        lastWorked: "Last time it worked: {when}",
        missingTitle: "What is missing",
        facts: {
            recordingOn: "Calls are recorded.",
            recordingOff: "Calls are not recorded.",
            numbers: "Mobiles in the pool: {total} · verified: {verified} · being verified: {pending} · verification failed: {failed} · given to someone: {assigned}",
            senders: "People ready: {ready} · to fix: {notReady}",
            templates: "Templates approved by Meta: {approved} of {total}",
            manualPeople: "People writing by hand: {count}",
            page: "Connected Facebook page: {page}",
            failedArrivals: "Arrivals that did not get in during the last 7 days: {count}",
            closeOn: "On: it imports every evening at 21:00.",
            closeOff: "Off: nothing is imported in the evening.",
            closeNext: "Next import: {when}",
            closeLast: "Last evening import: {outcome}",
        },
        closeOutcome: {
            running: "running",
            completed: "finished",
            interrupted: "stopped by a restart, it resumes by itself",
            failed: "failed",
        },
        people: {
            withoutNumber: "Can call without a mobile:",
            withoutWhatsApp: "Send WhatsApp without a WhatsApp set up:",
            googleConnected: "Connected by:",
            googleFailed: "No longer working for:",
            nobody: "nobody",
        },
        fix: {
            byGioia365: "Gioia365 sets it up.",
            platformCompanies: "Open the Gioia365 companies",
            team: "Go to Team",
            whatsappSending: "Go to «Sending WhatsApps»",
            whatsappTemplates: "Go to «WhatsApp templates»",
            leadIntake: "Go to «Lead intake»",
            ownAccount: "Everyone connects their own calendar from «Your account».",
            closeImport: "Go to the import from Close",
        },
        missing: {
            telephony_off: "The phone is not on: Gioia365 turns it on.",
            telephony_setting_up: "The phone is being set up.",
            telephony_failed: "Setting up the phone did not succeed.",
            telephony_account_blocked: "The phone account is suspended or closed.",
            telephony_check_failed: "The last phone check did not succeed.",
            recording_off: "Calls are not recorded: they should always be.",
            numbers_none: "There is no office mobile in the pool.",
            numbers_pending: "Some mobiles are waiting for verification: whoever holds the phone must type the code.",
            numbers_failed: "A mobile's verification did not succeed: it must be done again.",
            people_without_number: "Someone who can call has no mobile: they cannot call.",
            whatsapp_meta_unavailable: "Official WhatsApp is not active on Gioia365.",
            whatsapp_meta_company_off: "The company does not use official WhatsApp.",
            whatsapp_meta_not_connected: "The registration with Meta is not finished.",
            whatsapp_meta_failed: "A registration with Meta did not succeed.",
            whatsapp_meta_link_error: "Meta reports a problem with the connection: check it in «Sending WhatsApps».",
            whatsapp_meta_messages_failed: "Some WhatsApps in the last 24 hours were not sent.",
            whatsapp_meta_no_senders: "Nobody has official WhatsApp ready.",
            whatsapp_meta_senders_not_ready: "Someone's official WhatsApp is not ready.",
            whatsapp_meta_templates: "Some templates are not approved by Meta yet.",
            whatsapp_agile_unavailable: "WhatsApp Agile is not available on Gioia365.",
            whatsapp_agile_company_off: "The company does not use WhatsApp Agile.",
            whatsapp_agile_no_senders: "Nobody has WhatsApp Agile ready.",
            whatsapp_agile_senders_not_ready: "Someone's WhatsApp Agile is not ready.",
            whatsapp_agile_down: "A phone linked to WhatsApp Agile does not deliver: link it again with the QR code.",
            intake_meta_unavailable: "Meta forms are not active on Gioia365.",
            intake_meta_no_page: "No Facebook page is connected.",
            intake_meta_round_failed: "The last reading of the forms did not succeed: the page may need connecting again.",
            intake_meta_no_round: "Gioia365 has not read the forms since the last start: if it stays like this, something is wrong.",
            intake_meta_round_stale: "The last reading of the forms is more than an hour old: there should be one every minute.",
            intake_door_off: "This source is off: no lead comes in from here.",
            intake_failed_arrivals: "Some arrivals in the last 7 days did not get in.",
            intake_no_arrivals: "No lead has arrived in the last 90 days: check that the form sends its contacts here.",
            google_unavailable: "Google Calendar is not active on Gioia365.",
            google_nobody: "Nobody has connected their calendar.",
            google_failed: "Someone's calendar is no longer connected: it must be connected again.",
            close_no_key: "The Close key is missing.",
            close_dry_run_needed: "Before importing, a trial without saving is needed with the current key.",
            close_nightly_off: "The evening import is off.",
            close_last_failed: "The last evening import did not succeed.",
            email_off: "System emails are not sent: invitations and password resets are handed over by hand.",
        },
    },
};
//# sourceMappingURL=en.js.map